// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FolderPlus, ArrowLeft, Users, X, Sparkles } from 'lucide-react';
// import { jwtDecode } from "jwt-decode";
// import AlertBox from '../../Components/AlertBox';

// const AddProject = ({ projects, setProjects, onNavigate }) => {
//   const navigate = useNavigate();
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [showAlert, setShowAlert] = useState(null);

//   useEffect(() => {
//     setIsLoaded(true);
//   }, []);

//   // ---------------- Simple Styles ----------------
//   const addProjectStyle = {
//     minHeight: '100vh',
//     backgroundColor: '#f8fafc',
//     padding: '2rem',
//     fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
//   };

//   const pageHeaderStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '2rem',
//     padding: '1.5rem',
//     backgroundColor: 'white',
//     borderRadius: '0.5rem',
//     border: '1px solid #e5e7eb',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
//   };

//   const headerTitleStyle = {
//     fontSize: '1.875rem',
//     fontWeight: 700,
//     color: '#1f2937',
//     margin: 0,
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.5rem'
//   };

//   const btnStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     padding: '0.5rem 1rem',
//     border: '1px solid #d1d5db',
//     borderRadius: '0.375rem',
//     fontWeight: 500,
//     cursor: 'pointer',
//     gap: '0.5rem',
//     transition: 'all 0.2s ease',
//     fontSize: '0.875rem',
//     backgroundColor: 'white'
//   };

//   const btnSecondaryStyle = {
//     ...btnStyle,
//     backgroundColor: '#6b7280',
//     color: 'white',
//     borderColor: '#6b7280'
//   };

//   const btnPrimaryStyle = {
//     ...btnStyle,
//     backgroundColor: '#3b82f6',
//     color: 'white',
//     borderColor: '#3b82f6'
//   };

//   const formContainerStyle = {
//     maxWidth: '800px',
//     margin: '0 auto',
//     backgroundColor: 'white',
//     borderRadius: '0.5rem',
//     padding: '2rem',
//     border: '1px solid #e5e7eb',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
//   };
//   const formGroupStyle = { marginBottom: '2rem', marginRight: '1.5rem' };
//   const labelStyle = {
//     display: 'block',
//     marginBottom: '0.5rem',
//     fontWeight: 500,
//     color: '#374151',
//     fontSize: '0.875rem'
//   };

//   const inputStyle = {
//     width: '100%',
//     padding: '0.75rem',
//     backgroundColor: 'white',
//     border: '1px solid #d1d5db',
//     borderRadius: '0.375rem',
//     fontSize: '0.875rem',
//     outline: 'none',
//     color: '#1f2937',
//     transition: 'border-color 0.2s ease'
//   };

//   const textareaStyle = { ...inputStyle, resize: 'vertical', minHeight: '100px' };
//   const selectStyle = { ...inputStyle, cursor: 'pointer' };
//   const formRowStyle = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' };
//   const formActionsStyle = { display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '2rem' };

//   const selectedEmployeesContainer = {
//     display: 'flex',
//     flexWrap: 'wrap',
//     gap: '0.5rem',
//     marginTop: '0.5rem'
//   };

//   const selectedEmployeeChip = {
//     display: 'flex',
//     alignItems: 'center',
//     background: '#f0f9ff',
//     padding: '0.75rem 1rem',
//     borderRadius: '0.5rem',
//     fontSize: '0.9rem',
//     gap: '0.75rem',
//     minHeight: 'auto',
//     border: '1px solid #bae6fd',
//     color: '#0c4a6e',
//     boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//     transition: 'all 0.2s ease'
//   };

//   // ---------------- States ----------------
//   const [employees, setEmployees] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [shouldNavigate, setShouldNavigate] = useState(false);

//   const handleAlertClose = () => {
//     setShowAlert(null);
//     if (shouldNavigate) {
//       if (onNavigate) {
//         onNavigate('/projects', 'Projects');
//       } else {
//         navigate('/projects');
//       }
//       setShouldNavigate(false);
//     }
//   };
//   const [departmentSearchTerm, setDepartmentSearchTerm] = useState('');
//   const [showDepartmentDropdown, setShowDepartmentDropdown] = useState(false);
//   const dropdownRef = useRef(null);
//   const [newCustomField, setNewCustomField] = useState({ key: '', value: '' });
//   // Status management - using API
//   const [statusOptions, setStatusOptions] = useState([]);
//   const [newStatus, setNewStatus] = useState('');
//   const [showStatusForm, setShowStatusForm] = useState(false);

//   // Function to fetch custom statuses from API
//   const fetchCustomStatuses = async () => {
//     try {
//       const token = localStorage.getItem('authToken');
//       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (response.ok) {
//         const statuses = await response.json();

//         // Handle wrapped response format {statuses: Array}
//         let statusArray = [];
//         if (Array.isArray(statuses)) {
//           statusArray = statuses;
//         } else if (statuses && statuses.statuses && Array.isArray(statuses.statuses)) {
//           statusArray = statuses.statuses;
//         } else {
//           console.log('AddProject - Invalid response format:', statuses);
//           setStatusOptions([]);
//           return;
//         }

//         if (statusArray.length > 0) {
//           // Extract status names from the array
//           const statusNames = statusArray.map(status => {
//             // Try to get the name field
//             if (status && typeof status === 'object' && status.name) {
//               return status.name;
//             }
//             console.log('AddProject - No name field found');
//             return null;
//           }).filter(name => name); // Remove null values

//           setStatusOptions(statusNames);
//         } else {
//           setStatusOptions([]);
//         }
//       } else {
//         console.error('AddProject - API Error:', response.status);
//         setStatusOptions([]);
//       }
//     } catch (error) {
//       console.error('AddProject - Fetch Error:', error);
//       setStatusOptions([]);
//     }
//   };

//   // Fetch custom statuses on component mount
//   useEffect(() => {
//     fetchCustomStatuses();
//   }, []);

//   // Test function to create a status if none exist
//   const createTestStatus = async () => {
//     try {
//       const token = localStorage.getItem('authToken');
//       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           company: COMPANY_ID,
//           name: 'Planning'
//         })
//       });

//       if (response.ok) {
//         fetchCustomStatuses(); // Refresh the list
//       } else {
//       }
//     } catch (error) {
//       console.log('AddProject - Error creating test status:', error);
//     }
//   };

//   // Utility function to format date as DD/MM/YYYY
//   const formatDateToDDMMYYYY = (date) => {
//     if (!date) return '';
//     const d = new Date(date);
//     const day = String(d.getDate()).padStart(2, '0');
//     const month = String(d.getMonth() + 1).padStart(2, '0');
//     const year = d.getFullYear();
//     return `${day}/${month}/${year}`;
//   };

//   // Get current date in YYYY-MM-DD format for input field
//   const getCurrentDateForInput = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = String(today.getMonth() + 1).padStart(2, '0');
//     const day = String(today.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   };

//   const [formData, setFormData] = useState({
//     company: '',
//     title: '',
//     description: '',
//     status: '',
//     startDate: getCurrentDateForInput(),
//     dueDate: '',
//     budget: '',
//     progress: 0,
//     clientName: '',
//     clientCompany: '',
//     clientEmail: '',
//     clientMobileNo: '',
//     clientAddress: '',
//     clientCity: '',
//     clientState: '',
//     projectHead: '',
//     departments: [], // Changed to array for multiple departments
//     selectedEmployeeId: '', // for dropdown
//     customFields: [] // Array of {key, value} objects
//   });

//   // Options for state and city dropdowns
//   const indianStates = [
//     'Andhra Pradesh',
//     'Arunachal Pradesh',
//     'Assam',
//     'Bihar',
//     'Chhattisgarh',
//     'Goa',
//     'Gujarat',
//     'Haryana',
//     'Himachal Pradesh',
//     'Jharkhand',
//     'Karnataka',
//     'Kerala',
//     'Madhya Pradesh',
//     'Maharashtra',
//     'Manipur',
//     'Meghalaya',
//     'Mizoram',
//     'Nagaland',
//     'Odisha',
//     'Punjab',
//     'Rajasthan',
//     'Sikkim',
//     'Tamil Nadu',
//     'Telangana',
//     'Tripura',
//     'Uttar Pradesh',
//     'Uttarakhand',
//     'West Bengal'
//   ];

//   const maharashtraCities = [
//     'Mumbai (Capital of Maharashtra)',
//     'Pune',
//     'Nagpur',
//     'Nashik',
//     'Thane',
//     'Aurangabad (now officially Chhatrapati Sambhajinagar)',
//     'Solapur',
//     'Kolhapur',
//     'Amravati',
//     'Jalgaon',
//     'Akola',
//     'Latur',
//     'Sangli',
//     'Satara',
//     'Bhiwandi',
//     'Navi Mumbai',
//     'Kalyan-Dombivli',
//     'Vasai-Virar',
//     'Ahmednagar',
//     'Chandrapur'
//   ];

//   // Map cities by state (expand later as needed)
//   const citiesByState = {
//     Maharashtra: maharashtraCities,
//   };

//   const [showStateList, setShowStateList] = useState(false);
//   const [showCityList, setShowCityList] = useState(false);
//   const stateBoxRef = useRef(null);
//   const cityBoxRef = useRef(null);
//   const [stateHighlight, setStateHighlight] = useState(-1);
//   const [cityHighlight, setCityHighlight] = useState(-1);

//   // Get token from localStorage
//   const token = localStorage.getItem('authToken');

//   let COMPANY_ID = '';
//   if (token) {
//     try {
//       const decodedToken = jwtDecode(token); // Decode JWT
//       // Handle both company and employee login types
//       COMPANY_ID = decodedToken.role === 'company'
//         ? (decodedToken.companyId || decodedToken.id)
//         : decodedToken.companyId;
//     } catch (err) {
//       console.error("Error decoding token:", err);
//     }
//   }
//   // ---------------- Fetch Employees ----------------
//   useEffect(() => {
//     const fetchEmployees = async () => {
//       try {
//         const token = localStorage.getItem('authToken');

//         const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/employees/company/${COMPANY_ID}`, {
//           headers: {
//             'Authorization': `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         });

//         if (res.ok) {
//           const data = await res.json();

//           // Log department-wise employee distribution
//           if (data && data.length > 0) {
//             const departmentGroups = {};
//             data.forEach(emp => {
//               const deptId = emp.department?._id || emp.department || 'No Department';
//               const deptName = emp.department?.name || 'Unknown Department';
//               if (!departmentGroups[deptId]) {
//                 departmentGroups[deptId] = { name: deptName, employees: [] };
//               }
//               departmentGroups[deptId].employees.push(emp);
//             });

//             Object.keys(departmentGroups).forEach(deptId => {
//               const group = departmentGroups[deptId];
//             });
//           }

//           setEmployees(data ? data.filter(emp => emp.isActive !== false) : []);
//         } else {
//           console.error('AddProject - Failed to fetch employees - Status:', res.status);

//           // Try multiple fallback endpoints for company login
//           let fallbackData = null;

//           // Try general employees endpoint with auth
//           try {
//             const fallbackRes = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/employees', {
//               headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'application/json',
//               },
//             });
//             if (fallbackRes.ok) {
//               fallbackData = await fallbackRes.json();
//             }
//           } catch (error) {
//             console.log("AddProject - Auth fallback failed, trying no-auth");
//           }

//           // Try no-auth fallback for company access
//           if (!fallbackData) {
//             try {
//               const noAuthRes = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/employees');
//               if (noAuthRes.ok) {
//                 fallbackData = await noAuthRes.json();
//               }
//             } catch (error) {
//               console.log("AddProject - No-auth fallback failed");
//             }
//           }

//           setEmployees(fallbackData ? fallbackData.filter(emp => emp.isActive !== false) : []);
//         }
//       } catch (error) {
//         console.error('Error fetching employees:', error);
//         setEmployees([]);
//       }
//     };
//     fetchEmployees();
//   }, []);

//   // ---------------- Fetch Departments ----------------
//   useEffect(() => {
//     const fetchDepartments = async () => {
//       try {
//         const token = localStorage.getItem('authToken');

//         let departmentData = null;

//         // First try: with company ID and auth
//         try {
//           const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${COMPANY_ID}`, {
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json',
//             },
//           });
//           if (res.ok) {
//             departmentData = await res.json();
//           }
//         } catch (error) {
//           console.log("AddProject - Auth department fetch failed, trying alternatives");
//         }

//         // Second try: without auth for company access
//         if (!departmentData) {
//           try {
//             const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${COMPANY_ID}`);
//             if (res.ok) {
//               departmentData = await res.json();
//             }
//           } catch (error) {
//             console.log("AddProject - No-auth department fetch failed");
//           }
//         }

//         // Third try: general departments endpoint
//         if (!departmentData) {
//           try {
//             const res = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/departments', {
//               headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'application/json',
//               },
//             });
//             if (res.ok) {
//               departmentData = await res.json();
//             }
//           } catch (error) {
//             console.log("AddProject - General department fetch failed");
//           }
//         }

//         setDepartments(departmentData || []);
//       } catch (error) {
//         console.error('AddProject - Error fetching departments:', error);
//         setDepartments([]);
//       }
//     };
//     fetchDepartments();
//   }, []);

//   // ---------------- Click Outside Handler ----------------
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowDepartmentDropdown(false);
//       }
//       if (stateBoxRef.current && !stateBoxRef.current.contains(event.target)) {
//         setShowStateList(false);
//         setStateHighlight(-1);
//       }
//       if (cityBoxRef.current && !cityBoxRef.current.contains(event.target)) {
//         setShowCityList(false);
//         setCityHighlight(-1);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   // ---------------- Validation Helpers ----------------
//   const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
//   const isValidPhone = (phone) => {
//     // Remove any spaces, dashes, or special characters
//     const cleanPhone = phone.replace(/[\s\-\(\)]/g, '');
//     // Check if it's exactly 10 digits (no starting digit restriction)
//     return /^\d{10}$/.test(cleanPhone);
//   };

//   // ---------------- Computed Values ----------------
//   // Filter departments based on search term
//   const filteredDepartments = departments.filter(dept =>
//     dept.name.toLowerCase().includes(departmentSearchTerm.toLowerCase())
//   );

//   // Group employees by department
//   const employeesByDepartment = employees.reduce((acc, emp) => {
//     const deptId = emp.department?._id || emp.department || 'no-department';
//     const deptName = emp.department?.name || 'No Department';

//     if (!acc[deptId]) {
//       acc[deptId] = {
//         id: deptId,
//         name: deptName,
//         employees: []
//       };
//     }
//     acc[deptId].employees.push(emp);
//     return acc;
//   }, {});

//   // ---------------- Handlers ----------------
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === 'clientState') {
//       setFormData((prev) => ({
//         ...prev,
//         clientState: value,
//         // Reset city if state changed to something that doesn't match current city list
//         clientCity: ''
//       }));
//       return;
//     }
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleDepartmentToggle = (departmentId) => {
//     const id = typeof departmentId === "object" ? departmentId._id : departmentId;

//     setFormData(prev => {
//       const isSelected = prev.departments.includes(id);
//       const updatedDepartments = isSelected
//         ? prev.departments.filter(depId => depId !== id)
//         : [...prev.departments, id];

//       return {
//         ...prev,
//         departments: updatedDepartments,
//         selectedEmployeeId: ''
//       };
//     });

//     setSelectedTeamMembers([]); // Clear team members when departments change
//   };

//   const handleAddTeamMember = () => {
//     const selectedEmployee = employees.find(emp => emp._id === formData.selectedEmployeeId);
//     if (selectedEmployee && !selectedTeamMembers.some(member => member._id === selectedEmployee._id)) {
//       setSelectedTeamMembers(prev => [...prev, selectedEmployee]);
//     }
//     setFormData(prev => ({ ...prev, selectedEmployeeId: '' })); // reset dropdown
//   };

//   const handleRemoveTeamMember = (id) => {
//     setSelectedTeamMembers(prev => prev.filter(member => member._id !== id));
//   };

//   // Custom Fields Handlers
//   const handleAddCustomField = () => {
//     if (newCustomField.key.trim() && newCustomField.value.trim()) {
//       setFormData(prev => ({
//         ...prev,
//         customFields: [...prev.customFields, { ...newCustomField }]
//       }));
//       setNewCustomField({ key: '', value: '' });
//     }
//   };

//   const handleRemoveCustomField = (index) => {
//     setFormData(prev => ({
//       ...prev,
//       customFields: prev.customFields.filter((_, i) => i !== index)
//     }));
//   };

//   const handleCustomFieldChange = (field, value) => {
//     setNewCustomField(prev => ({ ...prev, [field]: value }));
//   };

//   // Add single status to the dropdown list using API
//   const handleAddStatus = async () => {
//     const label = (newStatus || '').trim();
//     if (!label) return;

//     const exists = statusOptions.some(s => s.toLowerCase() === label.toLowerCase());
//     if (exists) {
//       setShowAlert('This status already exists in your local list!');
//       setNewStatus('');
//       return;
//     }

//     try {
//       const token = localStorage.getItem('authToken');
//       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           company: COMPANY_ID,
//           name: label
//         })
//       });

//       if (response.ok) {
//         const newStatus = await response.json();

//         // Refresh the status list from server to ensure we have latest data
//         await fetchCustomStatuses();

//         // Set the new status as selected
//         setFormData(prev => ({ ...prev, status: label }));

//         setNewStatus('');
//         // Keep modal open so user can add more statuses
//         // setShowStatusForm(false);
//         setShowAlert(`Status "${label}" added successfully! You can add more statuses or close the modal.`);
//       } else {
//         const errorData = await response.json().catch(() => ({}));
//         console.error('AddProject - Failed to create status:', errorData);

//         // Handle specific error messages from server
//         if (errorData.message && errorData.message.includes('unique')) {
//           setShowAlert(`Status "${label}" already exists for your company. Please choose a different name.`);
//         } else {
//           setShowAlert(`Failed to create status: ${errorData.message || 'Please try again.'}`);
//         }

//         setNewStatus('');
//       }
//     } catch (error) {
//       console.error('AddProject - Error creating status:', error);
//       setShowAlert('Error creating status. Please check your connection and try again.');
//       setNewStatus('');
//     }
//   };

//   // Open status form
//   const handleOpenStatusForm = () => {
//     setShowStatusForm(true);
//   };

//   // Close status form
//   const handleCloseStatusForm = () => {
//     setShowStatusForm(false);
//     setNewStatus('');
//   };

//   // Remove a status from the list (local only - for project-specific use)
//   const handleRemoveStatus = (statusToRemove) => {
//     const updated = statusOptions.filter(status => status !== statusToRemove);
//     setStatusOptions(updated);
//     // Note: Status options are project-specific and not saved globally

//     // If the removed status was selected, change to the first remaining status or empty
//     if (formData.status === statusToRemove) {
//       setFormData(prev => ({ ...prev, status: updated.length > 0 ? updated[0] : '' }));
//     }
//   };

//   // Delete a status from MongoDB database
//   const handleDeleteStatus = async (statusToDelete) => {
//     try {
//       const token = localStorage.getItem('authToken');

//       // First, find the status ID from the API to delete it
//       const fetchResponse = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (!fetchResponse.ok) {
//         throw new Error('Failed to fetch statuses for deletion');
//       }

//       const statuses = await fetchResponse.json();
//       let statusArray = [];

//       // Handle wrapped response format
//       if (Array.isArray(statuses)) {
//         statusArray = statuses;
//       } else if (statuses && statuses.statuses && Array.isArray(statuses.statuses)) {
//         statusArray = statuses.statuses;
//       }

//       // Find the status object to get its ID
//       const statusToDeleteObj = statusArray.find(status => status.name === statusToDelete);

//       if (!statusToDeleteObj) {
//         setShowAlert(`Status "${statusToDelete}" not found in database.`);
//         return;
//       }

//       // Make DELETE request to remove from MongoDB
//       const deleteResponse = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/${statusToDeleteObj._id}`, {
//         method: 'DELETE',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (deleteResponse.ok) {

//         // Refresh the status list from server
//         await fetchCustomStatuses();

//         // If the deleted status was selected, change to the first remaining status or empty
//         if (formData.status === statusToDelete) {
//           const updatedOptions = statusOptions.filter(status => status !== statusToDelete);
//           setFormData(prev => ({ ...prev, status: updatedOptions.length > 0 ? updatedOptions[0] : '' }));
//         }

//         setShowAlert(`Status "${statusToDelete}" deleted successfully from database!`);
//       } else {
//         const errorData = await deleteResponse.json().catch(() => ({}));
//         console.error('AddProject - Failed to delete status:', errorData);
//         setShowAlert(`Failed to delete status: ${errorData.message || 'Please try again.'}`);
//       }
//     } catch (error) {
//       console.error('AddProject - Error deleting status:', error);
//       setShowAlert('Error deleting status from database. Please check your connection and try again.');
//     }
//   };

//   // Add this useEffect after your other useEffects to handle Google Places Autocomplete
//   useEffect(() => {
//     // Function to initialize Google Places Autocomplete
//     const initAutocomplete = () => {
//       if (!window.google || !window.google.maps || !window.google.maps.places) {
//         console.log('Google Maps not loaded yet');
//         return;
//       }

//       // Initialize autocomplete for client address field
//       const addressInput = document.getElementById('clientAddress');
//       if (addressInput) {
//         const autocomplete = new window.google.maps.places.Autocomplete(addressInput, {
//           types: ['address'],
//           componentRestrictions: { country: 'in' } // Restrict to India, change as needed
//         });

//         // Prevent form submission on Enter key in autocomplete
//         addressInput.addEventListener('keydown', (e) => {
//           if (e.key === 'Enter') {
//             e.preventDefault();
//             e.stopPropagation();
//           }
//         });

//         autocomplete.addListener('place_changed', () => {
//           const place = autocomplete.getPlace();

//           if (!place.geometry) {
//             console.log('No details available for input: ' + place.name);
//             return;
//           }

//           // Extract address components
//           let street = '';
//           let city = '';
//           let state = '';
//           let postalCode = '';
//           let country = '';

//           place.address_components.forEach((component) => {
//             const types = component.types;

//             if (types.includes('street_number') || types.includes('route')) {
//               street += component.long_name + ' ';
//             }
//             if (types.includes('locality') || types.includes('administrative_area_level_2')) {
//               city = component.long_name;
//             }
//             if (types.includes('administrative_area_level_1')) {
//               state = component.long_name;
//             }
//             if (types.includes('postal_code')) {
//               postalCode = component.long_name;
//             }
//             if (types.includes('country')) {
//               country = component.long_name;
//             }
//           });

//           // Update form data programmatically
//           setFormData(prev => ({
//             ...prev,
//             clientAddress: place.formatted_address || street.trim(),
//             clientCity: city,
//             clientState: state
//           }));
//         });
//       }
//     };

//     // Check if Google Maps is already loaded
//     if (window.google && window.google.maps && window.google.maps.places) {
//       initAutocomplete();
//     } else {
//       // Wait for Google Maps to load
//       const checkGoogleMaps = setInterval(() => {
//         if (window.google && window.google.maps && window.google.maps.places) {
//           clearInterval(checkGoogleMaps);
//           initAutocomplete();
//         }
//       }, 100);

//       // Cleanup interval after 10 seconds
//       setTimeout(() => clearInterval(checkGoogleMaps), 10000);
//     }
//   }, []);

//   // Update your handleSubmit to include proper form submission handling
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     e.stopPropagation(); // Add this to prevent event bubbling
//     console.log('Form submitted - handleSubmit called');

//     // Validation
//     if (!formData.title || !formData.startDate || !formData.dueDate || formData.departments.length === 0) {
//       console.log('Validation failed: Missing required fields', {
//         title: formData.title,
//         startDate: formData.startDate,
//         dueDate: formData.dueDate,
//         departments: formData.departments
//       });
//       setShowAlert('Please fill in all required fields (Title, Start Date, Due Date, Departments)');
//       return;
//     }
//     if (statusOptions.length === 0 || !formData.status) {
//       console.log('Validation failed: Status not set', { statusOptions, status: formData.status });
//       setShowAlert('Please add at least one status and select it for the project.');
//       return;
//     }
//     if (formData.clientEmail && !isValidEmail(formData.clientEmail)) {
//       console.log('Validation failed: Invalid email', formData.clientEmail);
//       setShowAlert('Please enter a valid email address.');
//       return;
//     }
//     if (formData.clientMobileNo && !isValidPhone(formData.clientMobileNo)) {
//       console.log('Validation failed: Invalid mobile number', formData.clientMobileNo);
//       setShowAlert('Please enter a valid 10-digit mobile number.');
//       return;
//     }

//     console.log('All validations passed, creating project...');
//     setLoading(true);

//     try {
//       const token = localStorage.getItem('authToken');

//       const projectData = {
//         company: formData.company || COMPANY_ID,
//         title: formData.title,
//         description: formData.description,
//         status: formData.status,
//         startDate: formData.startDate,
//         dueDate: formData.dueDate,
//         budget: formData.budget ? parseFloat(formData.budget) : 0,
//         progress: parseInt(formData.progress) || 0,
//         teamMembers: selectedTeamMembers.map((emp) => emp._id),
//         projectHead: formData.projectHead || null,
//         clientName: formData.clientName,
//         clientCompany: formData.clientCompany,
//         clientEmail: formData.clientEmail,
//         clientMobileNo: formData.clientMobileNo,
//         clientAddress: formData.clientAddress,
//         clientCity: formData.clientCity,
//         clientState: formData.clientState,
//         department: formData.departments,
//         customFields: formData.customFields,
//         statusOptions: statusOptions,
//       };

//       console.log('Sending project data to API:', projectData);

//       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/projectsmgnt', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`
//         },
//         body: JSON.stringify(projectData)
//       });

//       if (response.ok) {
//         const savedProject = await response.json();
//         console.log('Project created successfully:', savedProject);

//         // Update projects list if setProjects is provided
//         if (setProjects) {
//           setProjects(prev => [...prev, savedProject]);
//         }

//         setShowAlert('Project created successfully!');
//         setShouldNavigate(true);
//       } else {
//         const errorData = await response.json().catch(() => ({}));
//         console.error('Failed to create project:', errorData);
//         setShowAlert(`Failed to create project: ${errorData.message || 'Please try again.'}`);
//       }
//     } catch (error) {
//       console.error('Error creating project:', error);
//       setShowAlert('Error creating project. Please check your connection and try again.');
//     } finally {
//       setLoading(false);
//     }
//   };
//   // ---------------- UI ----------------
//   return (
//     <div style={addProjectStyle}>
//       <div style={pageHeaderStyle}>
//         <button onClick={() => onNavigate ? onNavigate('/projects', 'Projects') : navigate('/projects')} style={btnSecondaryStyle}>
//           <ArrowLeft size={20} />
//           Back to Projects
//         </button>
//         <h1 style={headerTitleStyle}>
//           <Sparkles size={32} style={{ color: '#f093fb' }} />
//           Create New Project
//         </h1>
//       </div>

//       <div style={formContainerStyle}>
//         <form onSubmit={handleSubmit} autoComplete="off">
//           {/* Title */}
//           <div style={formGroupStyle}>
//             <label htmlFor="title" style={labelStyle}>📋 Project Title *</label>
//             <input
//               type="text"
//               id="title"
//               name="title"
//               value={formData.title}
//               onChange={handleChange}
//               placeholder="Enter project title"
//               required
//               style={{
//                 ...inputStyle,
//                 '::placeholder': { color: 'rgba(255, 255, 255, 0.6)' }
//               }}
//             />
//           </div>

//           {/* Description */}
//           <div style={formGroupStyle}>
//             <label htmlFor="description" style={labelStyle}> Description</label>
//             <textarea
//               id="description"
//               name="description"
//               value={formData.description}
//               onChange={handleChange}
//               placeholder="Enter project description"
//               style={textareaStyle}
//             />
//           </div>

//           {/* Departments - Searchable Dropdown with Multiple Selection */}
//           <div style={formGroupStyle}>
//             <label style={labelStyle}>
//               Departments *
//               {formData.departments.length > 0 && (
//                 <span style={{
//                   fontSize: '0.75rem',
//                   color: '#6b7280',
//                   fontWeight: 'normal',
//                   marginLeft: '0.5rem',
//                   padding: '0.25rem 0.5rem',
//                   backgroundColor: '#f3f4f6',
//                   borderRadius: '0.375rem',
//                   border: '1px solid #d1d5db'
//                 }}>
//                   {formData.departments.length} selected
//                 </span>
//               )}
//             </label>

//             {/* Search Input with Dropdown Toggle */}
//             <div style={{ position: 'relative' }} ref={dropdownRef}>
//               <div style={{ display: 'flex', alignItems: 'center' }}>
//                 <input
//                   type="text"
//                   placeholder="Search departments..."
//                   value={departmentSearchTerm}
//                   onChange={(e) => setDepartmentSearchTerm(e.target.value)}
//                   onFocus={() => setShowDepartmentDropdown(true)}
//                   style={{
//                     ...inputStyle,
//                     paddingRight: '2.5rem'
//                   }}
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowDepartmentDropdown(!showDepartmentDropdown)}
//                   style={{
//                     position: 'absolute',
//                     right: '0.5rem',
//                     background: 'none',
//                     border: 'none',
//                     cursor: 'pointer',
//                     padding: '0.25rem',
//                     color: '#6b7280',
//                     fontSize: '1rem'
//                   }}
//                 >
//                   {showDepartmentDropdown ? '–' : '–'}
//                 </button>
//               </div>

//               {/* Dropdown List */}
//               {showDepartmentDropdown && (
//                 <div style={{
//                   position: 'absolute',
//                   top: '100%',
//                   left: 0,
//                   right: 0,
//                   backgroundColor: 'white',
//                   border: '1px solid #d1d5db',
//                   borderRadius: '0.375rem',
//                   boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//                   zIndex: 1000,
//                   maxHeight: '200px',
//                   overflowY: 'auto'
//                 }}>
//                   {filteredDepartments.length > 0 ? (
//                     filteredDepartments.map((dept) => (
//                       <div
//                         key={dept._id}
//                         onClick={() => handleDepartmentToggle(dept._id)}
//                         style={{
//                           padding: '0.75rem',
//                           cursor: 'pointer',
//                           backgroundColor: formData.departments.includes(dept._id) ? '#f0f9ff' : 'white',
//                           borderBottom: '1px solid #f3f4f6',
//                           display: 'flex',
//                           alignItems: 'center',
//                           gap: '0.5rem',
//                           transition: 'background-color 0.2s ease'
//                         }}
//                         onMouseEnter={(e) => {
//                           if (!formData.departments.includes(dept._id)) {
//                             e.target.style.backgroundColor = '#f9fafb';
//                           }
//                         }}
//                         onMouseLeave={(e) => {
//                           if (!formData.departments.includes(dept._id)) {
//                             e.target.style.backgroundColor = 'white';
//                           }
//                         }}
//                       >
//                         <input
//                           type="checkbox"
//                           checked={formData.departments.includes(dept._id)}
//                           onChange={() => { }}
//                           style={{ cursor: 'pointer' }}
//                         />
//                         <span style={{
//                           fontSize: '0.875rem',
//                           color: formData.departments.includes(dept._id) ? '#0c4a6e' : '#374151',
//                           fontWeight: formData.departments.includes(dept._id) ? '500' : 'normal'
//                         }}>
//                           {dept.name}
//                         </span>
//                       </div>
//                     ))
//                   ) : (
//                     <div style={{
//                       padding: '0.75rem',
//                       textAlign: 'center',
//                       color: '#6b7280',
//                       fontSize: '0.875rem'
//                     }}>
//                       {departmentSearchTerm ? 'No departments found' : 'No departments available'}
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>

//             {/* Selected Departments Display */}
//             {formData.departments.length > 0 && (
//               <div style={{ marginTop: '0.75rem' }}>
//                 <div style={{ fontSize: '0.875rem', color: '#374151', marginBottom: '0.75rem', fontWeight: '500' }}>
//                   Selected Departments ({formData.departments.length}):
//                 </div>
//                 <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
//                   {formData.departments.map(deptId => {
//                     const dept = departments.find(d => d._id === deptId);
//                     return (
//                       <span key={deptId} style={{
//                         fontSize: '0.875rem',
//                         padding: '0.5rem 0.75rem',
//                         backgroundColor: '#e0f2fe',
//                         color: '#0c4a6e',
//                         borderRadius: '0.5rem',
//                         border: '1px solid #bae6fd',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '0.5rem',
//                         boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//                         transition: 'all 0.2s ease'
//                       }}>
//                         <span style={{ fontWeight: '500' }}>{dept?.name || 'Unknown Department'}</span>
//                         <button
//                           type="button"
//                           onClick={() => handleDepartmentToggle(deptId)}
//                           style={{
//                             background: 'none',
//                             border: 'none',
//                             color: '#0c4a6e',
//                             cursor: 'pointer',
//                             padding: '0.25rem',
//                             fontSize: '0.875rem',
//                             fontWeight: 'bold',
//                             borderRadius: '0.25rem',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             width: '20px',
//                             height: '20px',
//                             transition: 'background-color 0.2s ease'
//                           }}
//                           onMouseEnter={(e) => {
//                             e.target.style.backgroundColor = 'rgba(12, 74, 110, 0.1)';
//                           }}
//                           onMouseLeave={(e) => {
//                             e.target.style.backgroundColor = 'transparent';
//                           }}
//                           title="Remove department"
//                         >
//                           ×
//                         </button>
//                       </span>
//                     );
//                   })}
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Team Members - Dropdown */}
//           <div style={formGroupStyle}>
//             <label style={labelStyle}>
//               👥 Team Members
//               {selectedTeamMembers.length > 0 && (
//                 <span style={{
//                   fontSize: '0.75rem',
//                   color: '#6b7280',
//                   fontWeight: 'normal',
//                   marginLeft: '0.5rem',
//                   padding: '0.25rem 0.5rem',
//                   backgroundColor: '#f3f4f6',
//                   borderRadius: '0.375rem',
//                   border: '1px solid #d1d5db'
//                 }}>
//                   {selectedTeamMembers.length} selected
//                 </span>
//               )}
//             </label>

//             {/* Employee Selection Dropdown */}
//             {formData.departments.length > 0 ? (
//               <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-end' }}>
//                 <div style={{ flex: 1 }}>
//                   <select
//                     name="selectedEmployeeId"
//                     value={formData.selectedEmployeeId}
//                     onChange={handleChange}
//                     style={selectStyle}
//                   >
//                     <option value="">Select an employee to add</option>
//                     {Object.keys(employeesByDepartment)
//                       .filter(deptId => formData.departments.includes(deptId))
//                       .map(deptId => {
//                         const deptGroup = employeesByDepartment[deptId];
//                         return (
//                           <optgroup key={deptId} label={deptGroup.name}>
//                             {deptGroup.employees.map(emp => (
//                               <option key={emp._id} value={emp._id}>
//                                 {emp.name} ({emp.email})
//                               </option>
//                             ))}
//                           </optgroup>
//                         );
//                       })}
//                   </select>
//                 </div>
//                 <button
//                   type="button"
//                   onClick={handleAddTeamMember}
//                   disabled={!formData.selectedEmployeeId}
//                   style={{
//                     ...btnPrimaryStyle,
//                     opacity: formData.selectedEmployeeId ? 1 : 0.5,
//                     cursor: formData.selectedEmployeeId ? 'pointer' : 'not-allowed'
//                   }}
//                 >
//                   <Users size={16} />
//                   Add
//                 </button>
//               </div>
//             ) : (
//               <div style={{
//                 padding: '1rem',
//                 backgroundColor: '#fef3c7',
//                 border: '1px solid #f59e0b',
//                 borderRadius: '0.375rem',
//                 color: '#92400e',
//                 fontSize: '0.875rem'
//               }}>
//                 Please select at least one department first to see available employees.
//               </div>
//             )}

//             {/* Selected Team Members Display */}
//             {selectedTeamMembers.length > 0 && (
//               <div style={selectedEmployeesContainer}>
//                 {selectedTeamMembers.map((member) => (
//                   <div key={member._id} style={selectedEmployeeChip}>
//                     <span style={{ fontWeight: '500' }}>{member.name}</span>
//                     <span style={{ fontSize: '0.8rem', opacity: 0.8 }}>({member.email})</span>
//                     <button
//                       type="button"
//                       onClick={() => handleRemoveTeamMember(member._id)}
//                       style={{
//                         background: 'none',
//                         border: 'none',
//                         color: '#0c4a6e',
//                         cursor: 'pointer',
//                         padding: '0.25rem',
//                         fontSize: '1rem',
//                         fontWeight: 'bold',
//                         borderRadius: '0.25rem',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         width: '20px',
//                         height: '20px',
//                         transition: 'background-color 0.2s ease'
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.backgroundColor = 'rgba(12, 74, 110, 0.1)';
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.backgroundColor = 'transparent';
//                       }}
//                       title="Remove team member"
//                     >
//                       <X size={14} />
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//           {/* Status Management */}
//           <div style={formGroupStyle}>
//             <label style={labelStyle}>
//               📊 Project Status *
//               <button
//                 type="button"
//                 onClick={handleOpenStatusForm}
//                 style={{
//                   marginLeft: '0.5rem',
//                   padding: '0.25rem 0.5rem',
//                   fontSize: '0.75rem',
//                   backgroundColor: '#f3f4f6',
//                   border: '1px solid #d1d5db',
//                   borderRadius: '0.25rem',
//                   cursor: 'pointer',
//                   color: '#374151'
//                 }}
//               >
//                 + Add Status
//               </button>
//             </label>

//             <select
//               name="status"
//               value={formData.status}
//               onChange={handleChange}
//               required
//               style={selectStyle}
//             >
//               <option value="">Select project status</option>
//               {statusOptions.map((status, index) => (
//                 <option key={index} value={status}>{status}</option>
//               ))}
//             </select>

//             {/* Status Management Modal */}
//             {showStatusForm && (
//               <div style={{
//                 position: 'fixed',
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 bottom: 0,
//                 backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 zIndex: 1000
//               }}>
//                 <div style={{
//                   backgroundColor: 'white',
//                   padding: '2rem',
//                   borderRadius: '0.5rem',
//                   width: '90%',
//                   maxWidth: '500px',
//                   maxHeight: '80vh',
//                   overflowY: 'auto'
//                 }}>
//                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
//                     <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 600 }}>Manage Project Statuses</h3>
//                     <button
//                       type="button"
//                       onClick={handleCloseStatusForm}
//                       style={{
//                         background: 'none',
//                         border: 'none',
//                         fontSize: '1.5rem',
//                         cursor: 'pointer',
//                         color: '#6b7280'
//                       }}
//                     >
//                       ×
//                     </button>
//                   </div>

//                   {/* Add New Status */}
//                   <div style={{ marginBottom: '1.5rem' }}>
//                     <label style={labelStyle}>Add New Status</label>
//                     <div style={{ display: 'flex', gap: '0.5rem' }}>
//                       <input
//                         type="text"
//                         value={newStatus}
//                         onChange={(e) => setNewStatus(e.target.value)}
//                         placeholder="Enter status name"
//                         style={{ ...inputStyle, flex: 1 }}
//                         onKeyPress={(e) => {
//                           if (e.key === 'Enter') {
//                             e.preventDefault();
//                             handleAddStatus();
//                           }
//                         }}
//                       />
//                       <button
//                         type="button"
//                         onClick={handleAddStatus}
//                         disabled={!newStatus.trim()}
//                         style={{
//                           ...btnPrimaryStyle,
//                           opacity: newStatus.trim() ? 1 : 0.5,
//                           cursor: newStatus.trim() ? 'pointer' : 'not-allowed'
//                         }}
//                       >
//                         Add
//                       </button>
//                     </div>
//                   </div>

//                   {/* Current Statuses */}
//                   <div>
//                     <label style={labelStyle}>Current Statuses ({statusOptions.length})</label>
//                     {statusOptions.length > 0 ? (
//                       <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                         {statusOptions.map((status, index) => (
//                           <div key={index} style={{
//                             display: 'flex',
//                             justifyContent: 'space-between',
//                             alignItems: 'center',
//                             padding: '0.75rem',
//                             backgroundColor: '#f9fafb',
//                             border: '1px solid #e5e7eb',
//                             borderRadius: '0.375rem'
//                           }}>
//                             <span style={{ fontSize: '0.875rem', fontWeight: '500' }}>{status}</span>
//                             <div style={{ display: 'flex', gap: '0.5rem' }}>
//                               <button
//                                 type="button"
//                                 onClick={() => handleRemoveStatus(status)}
//                                 style={{
//                                   padding: '0.25rem 0.5rem',
//                                   fontSize: '0.75rem',
//                                   backgroundColor: '#fef2f2',
//                                   color: '#dc2626',
//                                   border: '1px solid #fecaca',
//                                   borderRadius: '0.25rem',
//                                   cursor: 'pointer'
//                                 }}
//                                 title="Remove from list (local only)"
//                               >
//                                 Remove
//                               </button>
//                               <button
//                                 type="button"
//                                 onClick={() => handleDeleteStatus(status)}
//                                 style={{
//                                   padding: '0.25rem 0.5rem',
//                                   fontSize: '0.75rem',
//                                   backgroundColor: '#7f1d1d',
//                                   color: 'white',
//                                   border: '1px solid #7f1d1d',
//                                   borderRadius: '0.25rem',
//                                   cursor: 'pointer'
//                                 }}
//                                 title="Delete from database permanently"
//                               >
//                                 Delete
//                               </button>
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     ) : (
//                       <div style={{
//                         padding: '1rem',
//                         textAlign: 'center',
//                         color: '#6b7280',
//                         backgroundColor: '#f9fafb',
//                         border: '1px solid #e5e7eb',
//                         borderRadius: '0.375rem',
//                         fontSize: '0.875rem'
//                       }}>
//                         No statuses available. Add your first status above.
//                       </div>
//                     )}
//                   </div>

//                   <div style={{ marginTop: '1.5rem', textAlign: 'right' }}>
//                     <button
//                       type="button"
//                       onClick={handleCloseStatusForm}
//                       style={btnSecondaryStyle}
//                     >
//                       Close
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Dates and Budget Row */}
//           <div style={formRowStyle}>
//             <div style={formGroupStyle}>
//               <label htmlFor="startDate" style={labelStyle}>… Start Date *</label>
//               <input
//                 type="date"
//                 id="startDate"
//                 name="startDate"
//                 value={formData.startDate}
//                 onChange={handleChange}
//                 required
//                 style={inputStyle}
//               />
//             </div>
//             <div style={formGroupStyle}>
//               <label htmlFor="dueDate" style={labelStyle}> Due Date *</label>
//               <input
//                 type="date"
//                 id="dueDate"
//                 name="dueDate"
//                 value={formData.dueDate}
//                 onChange={handleChange}
//                 required
//                 style={inputStyle}
//               />
//             </div>
//           </div>

//           <div style={formRowStyle}>
//             <div style={formGroupStyle}>
//               <label htmlFor="budget" style={labelStyle}>💰 Budget</label>
//               <input
//                 type="number"
//                 id="budget"
//                 name="budget"
//                 value={formData.budget}
//                 onChange={handleChange}
//                 placeholder="Enter budget amount"
//                 min="0"
//                 step="0.01"
//                 style={inputStyle}
//               />
//             </div>
//             <div style={formGroupStyle}>
//               <label htmlFor="progress" style={labelStyle}>📈 Progress (%)</label>
//               <input
//                 type="number"
//                 id="progress"
//                 name="progress"
//                 value={formData.progress}
//                 onChange={handleChange}
//                 placeholder="0"
//                 min="0"
//                 max="100"
//                 style={inputStyle}
//               />
//             </div>
//           </div>

//           {/* Project Head */}
//           <div style={formGroupStyle}>
//             <label htmlFor="projectHead" style={labelStyle}>Project Head</label>
//             <select
//               id="projectHead"
//               name="projectHead"
//               value={formData.projectHead}
//               onChange={handleChange}
//               style={selectStyle}
//             >
//               <option value="">Select project head</option>
//               {employees.map((emp) => (
//                 <option key={emp._id} value={emp._id}>
//                   {emp.name} ({emp.email})
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Client Information Section */}
//           <div style={{ marginTop: '2rem', marginBottom: '1.5rem' }}>
//             <h3 style={{
//               fontSize: '1.25rem',
//               fontWeight: 600,
//               color: '#1f2937',
//               margin: 0,
//               marginBottom: '1rem',
//               paddingBottom: '0.5rem',
//               borderBottom: '2px solid #e5e7eb'
//             }}>
//               Client Information
//             </h3>
//           </div>

//           <div style={formRowStyle}>
//             <div style={formGroupStyle}>
//               <label htmlFor="clientName" style={labelStyle}>Client Name</label>
//               <input
//                 type="text"
//                 id="clientName"
//                 name="clientName"
//                 value={formData.clientName}
//                 onChange={handleChange}
//                 placeholder="Enter client name"
//                 style={inputStyle}
//               />
//             </div>
//             <div style={formGroupStyle}>
//               <label htmlFor="clientCompany" style={labelStyle}>Client Company</label>
//               <input
//                 type="text"
//                 id="clientCompany"
//                 name="clientCompany"
//                 value={formData.clientCompany}
//                 onChange={handleChange}
//                 placeholder="Enter client company"
//                 style={inputStyle}
//               />
//             </div>
//           </div>

//           <div style={formRowStyle}>
//             <div style={formGroupStyle}>
//               <label htmlFor="clientEmail" style={labelStyle}> Client Email</label>
//               <input
//                 type="email"
//                 id="clientEmail"
//                 name="clientEmail"
//                 value={formData.clientEmail}
//                 onChange={handleChange}
//                 placeholder="Enter client email"
//                 style={inputStyle}
//               />
//             </div>
//             <div style={formGroupStyle}>
//               <label htmlFor="clientMobileNo" style={labelStyle}>📱 Client Mobile</label>
//               <input
//                 type="tel"
//                 id="clientMobileNo"
//                 name="clientMobileNo"
//                 value={formData.clientMobileNo}
//                 onChange={handleChange}
//                 placeholder="Enter 10-digit mobile number"
//                 style={inputStyle}
//               />
//             </div>
//           </div>

//           {/* Client Address with Google Places Autocomplete */}
//           <div style={formGroupStyle}>
//             <label htmlFor="clientAddress" style={labelStyle}>Client Address</label>
//             <input
//               type="text"
//               id="clientAddress"
//               name="clientAddress"
//               value={formData.clientAddress}
//               onChange={handleChange}
//               placeholder="Enter client address (autocomplete enabled)"
//               style={inputStyle}
//             />
//           </div>

//           {/* Client City and State */}
//           <div style={formRowStyle}>
//             <div style={formGroupStyle}>
//               <label htmlFor="clientCity" style={labelStyle}>™ï Client City</label>
//               <input
//                 type="text"
//                 id="clientCity"
//                 name="clientCity"
//                 value={formData.clientCity}
//                 onChange={handleChange}
//                 placeholder="Enter client city"
//                 style={inputStyle}
//               />
//             </div>
//             <div style={formGroupStyle}>
//               <label htmlFor="clientState" style={labelStyle}>—ï Client State</label>
//               <select
//                 id="clientState"
//                 name="clientState"
//                 value={formData.clientState}
//                 onChange={handleChange}
//                 style={selectStyle}
//               >
//                 <option value="">Select state</option>
//                 {indianStates.map((state) => (
//                   <option key={state} value={state}>
//                     {state}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Custom Fields Section */}
//           <div style={{ marginTop: '2rem', marginBottom: '1.5rem' }}>
//             <h3 style={{
//               fontSize: '1.25rem',
//               fontWeight: 600,
//               color: '#1f2937',
//               margin: 0,
//               marginBottom: '1rem',
//               paddingBottom: '0.5rem',
//               borderBottom: '2px solid #e5e7eb'
//             }}>
//               š™ï Custom Fields
//             </h3>
//           </div>

//           {/* Add Custom Field */}
//           <div style={formGroupStyle}>
//             <label style={labelStyle}>Add Custom Field</label>
//             <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-end' }}>
//               <div style={{ flex: 1 }}>
//                 <input
//                   type="text"
//                   placeholder="Field name"
//                   value={newCustomField.key}
//                   onChange={(e) => handleCustomFieldChange('key', e.target.value)}
//                   style={inputStyle}
//                 />
//               </div>
//               <div style={{ flex: 1 }}>
//                 <input
//                   type="text"
//                   placeholder="Field value"
//                   value={newCustomField.value}
//                   onChange={(e) => handleCustomFieldChange('value', e.target.value)}
//                   style={inputStyle}
//                 />
//               </div>
//               <button
//                 type="button"
//                 onClick={handleAddCustomField}
//                 disabled={!newCustomField.key.trim() || !newCustomField.value.trim()}
//                 style={{
//                   ...btnPrimaryStyle,
//                   opacity: (newCustomField.key.trim() && newCustomField.value.trim()) ? 1 : 0.5,
//                   cursor: (newCustomField.key.trim() && newCustomField.value.trim()) ? 'pointer' : 'not-allowed'
//                 }}
//               >
//                 Add
//               </button>
//             </div>
//           </div>

//           {/* Display Custom Fields */}
//           {formData.customFields.length > 0 && (
//             <div style={formGroupStyle}>
//               <label style={labelStyle}>Custom Fields ({formData.customFields.length})</label>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                 {formData.customFields.map((field, index) => (
//                   <div key={index} style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     padding: '0.75rem',
//                     backgroundColor: '#f9fafb',
//                     border: '1px solid #e5e7eb',
//                     borderRadius: '0.375rem'
//                   }}>
//                     <div style={{ display: 'flex', gap: '1rem' }}>
//                       <span style={{ fontSize: '0.875rem', fontWeight: '500' }}>{field.key}:</span>
//                       <span style={{ fontSize: '0.875rem' }}>{field.value}</span>
//                     </div>
//                     <button
//                       type="button"
//                       onClick={() => handleRemoveCustomField(index)}
//                       style={{
//                         background: 'none',
//                         border: 'none',
//                         color: '#dc2626',
//                         cursor: 'pointer',
//                         padding: '0.25rem',
//                         fontSize: '1rem',
//                         fontWeight: 'bold'
//                       }}
//                       title="Remove custom field"
//                     >
//                       <X size={16} />
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Form Actions */}
//           <div style={formActionsStyle}>
//             <button
//               type="button"
//               onClick={() => onNavigate ? onNavigate('/projects', 'Projects') : navigate('/projects')}
//               style={btnSecondaryStyle}
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={loading}
//               style={{
//                 ...btnPrimaryStyle,
//                 opacity: loading ? 0.7 : 1,
//                 cursor: loading ? 'not-allowed' : 'pointer'
//               }}
//             >
//               <FolderPlus size={20} />
//               {loading ? 'Creating...' : 'Create Project'}
//             </button>
//           </div>
//         </form>
//       </div>

//       {showAlert && (
//         <AlertBox
//           message={showAlert}
//           onClose={handleAlertClose}
//         />
//       )}
//     </div>
//   );
// };

// export default AddProject;

// // // import React, { useState, useEffect, useRef } from 'react';
// // // import { useNavigate } from 'react-router-dom';
// // // import { FolderPlus, ArrowLeft, Users, X, Sparkles } from 'lucide-react';
// // // import { jwtDecode } from "jwt-decode";
// // // import AlertBox from '../../Components/AlertBox';
// // // const AddProject = ({ projects, setProjects, onNavigate }) => {
// // //   const navigate = useNavigate();
// // //   const [isLoaded, setIsLoaded] = useState(false);
// // //   const [showAlert, setShowAlert] = useState(null);

// // //   useEffect(() => {
// // //     setIsLoaded(true);
// // //   }, []);

// // //   // ---------------- Simple Styles ----------------
// // //   const addProjectStyle = {
// // //     minHeight: '100vh',
// // //     backgroundColor: '#f8fafc',
// // //     padding: '2rem',
// // //     fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
// // //   };

// // //   const pageHeaderStyle = {
// // //     display: 'flex',
// // //     justifyContent: 'space-between',
// // //     alignItems: 'center',
// // //     marginBottom: '2rem',
// // //     padding: '1.5rem',
// // //     backgroundColor: 'white',
// // //     borderRadius: '0.5rem',
// // //     border: '1px solid #e5e7eb',
// // //     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
// // //   };

// // //   const headerTitleStyle = {
// // //     fontSize: '1.875rem',
// // //     fontWeight: 700,
// // //     color: '#1f2937',
// // //     margin: 0,
// // //     display: 'flex',
// // //     alignItems: 'center',
// // //     gap: '0.5rem'
// // //   };

// // //   const btnStyle = {
// // //     display: 'inline-flex',
// // //     alignItems: 'center',
// // //     padding: '0.5rem 1rem',
// // //     border: '1px solid #d1d5db',
// // //     borderRadius: '0.375rem',
// // //     fontWeight: 500,
// // //     cursor: 'pointer',
// // //     gap: '0.5rem',
// // //     transition: 'all 0.2s ease',
// // //     fontSize: '0.875rem',
// // //     backgroundColor: 'white'
// // //   };

// // //   const btnSecondaryStyle = {
// // //     ...btnStyle,
// // //     backgroundColor: '#6b7280',
// // //     color: 'white',
// // //     borderColor: '#6b7280'
// // //   };

// // //   const btnPrimaryStyle = {
// // //     ...btnStyle,
// // //     backgroundColor: '#3b82f6',
// // //     color: 'white',
// // //     borderColor: '#3b82f6'
// // //   };

// // //   const formContainerStyle = { 
// // //     maxWidth: '800px', 
// // //     margin: '0 auto',
// // //     backgroundColor: 'white',
// // //     borderRadius: '0.5rem',
// // //     padding: '2rem',
// // //     border: '1px solid #e5e7eb',
// // //     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
// // //   };
// // //   const formGroupStyle = { marginBottom: '2rem' , marginRight: '1.5rem' };
// // //   const labelStyle = { 
// // //     display: 'block', 
// // //     marginBottom: '0.5rem', 
// // //     fontWeight: 500, 
// // //     color: '#374151',
// // //     fontSize: '0.875rem'
// // //   };

// // //   const inputStyle = {
// // //     width: '100%',
// // //     padding: '0.75rem',
// // //     backgroundColor: 'white',
// // //     border: '1px solid #d1d5db',
// // //     borderRadius: '0.375rem',
// // //     fontSize: '0.875rem',
// // //     outline: 'none',
// // //     color: '#1f2937',
// // //     transition: 'border-color 0.2s ease'
// // //   };

// // //   const textareaStyle = { ...inputStyle, resize: 'vertical', minHeight: '100px' };
// // //   const selectStyle = { ...inputStyle, cursor: 'pointer' };
// // //   const formRowStyle = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' };
// // //   const formActionsStyle = { display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '2rem' };

// // //   const selectedEmployeesContainer = {
// // //     display: 'flex',
// // //     flexWrap: 'wrap',
// // //     gap: '0.5rem',
// // //     marginTop: '0.5rem'
// // //   };

// // //   const selectedEmployeeChip = {
// // //     display: 'flex',
// // //     alignItems: 'center',
// // //     background: '#f0f9ff',
// // //     padding: '0.75rem 1rem',
// // //     borderRadius: '0.5rem',
// // //     fontSize: '0.9rem',
// // //     gap: '0.75rem',
// // //     minHeight: 'auto',
// // //     border: '1px solid #bae6fd',
// // //     color: '#0c4a6e',
// // //     boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
// // //     transition: 'all 0.2s ease'
// // //   };

// // //   // ---------------- States ----------------
// // //   const [employees, setEmployees] = useState([]);
// // //   const [departments, setDepartments] = useState([]);
// // //   const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [departmentSearchTerm, setDepartmentSearchTerm] = useState('');
// // //   const [showDepartmentDropdown, setShowDepartmentDropdown] = useState(false);
// // //   const dropdownRef = useRef(null);
// // //   const [newCustomField, setNewCustomField] = useState({ key: '', value: '' });
// // //   // Status management - using API
// // //   const [statusOptions, setStatusOptions] = useState([]);
// // //   const [newStatus, setNewStatus] = useState('');
// // //   const [showStatusForm, setShowStatusForm] = useState(false);

// // //   // Function to fetch custom statuses from API
// // //   const fetchCustomStatuses = async () => {
// // //     try {
// // //       const token = localStorage.getItem('authToken');
// // //       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
// // //         headers: {
// // //           'Authorization': `Bearer ${token}`,
// // //           'Content-Type': 'application/json'
// // //         }
// // //       });

// // //       if (response.ok) {
// // //         const statuses = await response.json();

// // //         // Handle wrapped response format {statuses: Array}
// // //         let statusArray = [];
// // //         if (Array.isArray(statuses)) {
// // //           statusArray = statuses;
// // //         } else if (statuses && statuses.statuses && Array.isArray(statuses.statuses)) {
// // //           statusArray = statuses.statuses;
// // //         } else {
// // //           console.log('AddProject - Invalid response format:', statuses);
// // //           setStatusOptions([]);
// // //           return;
// // //         }

// // //         if (statusArray.length > 0) {
// // //           // Extract status names from the array
// // //           const statusNames = statusArray.map(status => {
// // //             // Try to get the name field
// // //             if (status && typeof status === 'object' && status.name) {
// // //               return status.name;
// // //             }
// // //             console.log('AddProject - No name field found');
// // //             return null;
// // //           }).filter(name => name); // Remove null values

// // //           setStatusOptions(statusNames);
// // //         } else {
// // //           setStatusOptions([]);
// // //         }
// // //       } else {
// // //         console.error('AddProject - API Error:', response.status);
// // //         setStatusOptions([]);
// // //       }
// // //     } catch (error) {
// // //       console.error('AddProject - Fetch Error:', error);
// // //       setStatusOptions([]);
// // //     }
// // //   };

// // //   // Fetch custom statuses on component mount
// // //   useEffect(() => {
// // //     fetchCustomStatuses();
// // //   }, []);

// // //   // Test function to create a status if none exist
// // //   const createTestStatus = async () => {
// // //     try {
// // //       const token = localStorage.getItem('authToken');
// // //       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
// // //         method: 'POST',
// // //         headers: {
// // //           'Authorization': `Bearer ${token}`,
// // //           'Content-Type': 'application/json'
// // //         },
// // //         body: JSON.stringify({
// // //           company: COMPANY_ID,
// // //           name: 'Planning'
// // //         })
// // //       });

// // //       if (response.ok) {
// // //         fetchCustomStatuses(); // Refresh the list
// // //       } else {
// // //       }
// // //     } catch (error) {
// // //       console.log('AddProject - Error creating test status:', error);
// // //     }
// // //   };


// // //   // Utility function to format date as DD/MM/YYYY
// // //   const formatDateToDDMMYYYY = (date) => {
// // //     if (!date) return '';
// // //     const d = new Date(date);
// // //     const day = String(d.getDate()).padStart(2, '0');
// // //     const month = String(d.getMonth() + 1).padStart(2, '0');
// // //     const year = d.getFullYear();
// // //     return `${day}/${month}/${year}`;
// // //   };

// // //   // Get current date in YYYY-MM-DD format for input field
// // //   const getCurrentDateForInput = () => {
// // //     const today = new Date();
// // //     const year = today.getFullYear();
// // //     const month = String(today.getMonth() + 1).padStart(2, '0');
// // //     const day = String(today.getDate()).padStart(2, '0');
// // //     return `${year}-${month}-${day}`;
// // //   };

// // //   const [formData, setFormData] = useState({
// // //     company: '',
// // //     title: '',
// // //     description: '',
// // //     status: '',
// // //     startDate: getCurrentDateForInput(),
// // //     dueDate: '',
// // //     budget: '',
// // //     progress: 0,
// // //     clientName: '',
// // //     clientCompany: '',
// // //     clientEmail: '',
// // //     clientMobileNo: '',
// // //     clientAddress: '',
// // //     clientCity: '',
// // //     clientState: '',
// // //     projectHead: '',
// // //     departments: [], // Changed to array for multiple departments
// // //     selectedEmployeeId: '', // for dropdown
// // //     customFields: [] // Array of {key, value} objects
// // //   });

// // //  // Get token from localStorage
// // //  const token = localStorage.getItem('authToken');

// // //  let COMPANY_ID = '';
// // //  if (token) {
// // //    try {
// // //      const decodedToken = jwtDecode(token); // Decode JWT
// // //      // Handle both company and employee login types
// // //      COMPANY_ID = decodedToken.role === 'company' 
// // //        ? (decodedToken.companyId || decodedToken.id) 
// // //        : decodedToken.companyId;
// // //    } catch (err) {
// // //      console.error("Error decoding token:", err);
// // //    }
// // //  }
// // //   // ---------------- Fetch Employees ----------------
// // //   useEffect(() => {
// // //     const fetchEmployees = async () => {
// // //       try {
// // //         const token = localStorage.getItem('authToken');


// // //         const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/employees/company/${COMPANY_ID}`, {
// // //           headers: {
// // //             'Authorization': `Bearer ${token}`,
// // //             'Content-Type': 'application/json',
// // //           },
// // //         });

// // //         if (res.ok) {
// // //           const data = await res.json();

// // //           // Log department-wise employee distribution
// // //           if (data && data.length > 0) {  
// // //             const departmentGroups = {};
// // //             data.forEach(emp => {
// // //               const deptId = emp.department?._id || emp.department || 'No Department';
// // //               const deptName = emp.department?.name || 'Unknown Department';
// // //               if (!departmentGroups[deptId]) {
// // //                 departmentGroups[deptId] = { name: deptName, employees: [] };
// // //               }
// // //               departmentGroups[deptId].employees.push(emp);
// // //             });

// // //             Object.keys(departmentGroups).forEach(deptId => {
// // //               const group = departmentGroups[deptId];
// // //             });
// // //           }

// // //           setEmployees(data ? data.filter(emp => emp.isActive !== false) : []);
// // //         } else {
// // //           console.error('AddProject - Failed to fetch employees - Status:', res.status);

// // //           // Try multiple fallback endpoints for company login
// // //           let fallbackData = null;

// // //           // Try general employees endpoint with auth
// // //           try {
// // //             const fallbackRes = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/employees', {
// // //               headers: {
// // //                 'Authorization': `Bearer ${token}`,
// // //                 'Content-Type': 'application/json',
// // //               },
// // //             });
// // //             if (fallbackRes.ok) {
// // //               fallbackData = await fallbackRes.json();
// // //             }
// // //           } catch (error) {
// // //             console.log("AddProject - Auth fallback failed, trying no-auth");
// // //           }

// // //           // Try no-auth fallback for company access
// // //           if (!fallbackData) {
// // //             try {
// // //               const noAuthRes = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/employees');
// // //               if (noAuthRes.ok) {
// // //                 fallbackData = await noAuthRes.json();
// // //               }
// // //             } catch (error) {
// // //               console.log("AddProject - No-auth fallback failed");
// // //             }
// // //           }

// // //           setEmployees(fallbackData || []);
// // //         }
// // //       } catch (error) {
// // //         console.error('Error fetching employees:', error);
// // //         setEmployees([]);
// // //       }
// // //     };
// // //     fetchEmployees();
// // //   }, []);


// // //   // ---------------- Fetch Departments ----------------
// // //   useEffect(() => {
// // //     const fetchDepartments = async () => {
// // //       try {
// // //         const token = localStorage.getItem('authToken');

// // //         let departmentData = null;

// // //         // First try: with company ID and auth
// // //         try {
// // //           const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${COMPANY_ID}`, {
// // //             headers: {
// // //               'Authorization': `Bearer ${token}`,
// // //               'Content-Type': 'application/json',
// // //             },
// // //           });
// // //           if (res.ok) {
// // //             departmentData = await res.json();
// // //           }
// // //         } catch (error) {
// // //           console.log("AddProject - Auth department fetch failed, trying alternatives");
// // //         }

// // //         // Second try: without auth for company access
// // //         if (!departmentData) {
// // //           try {
// // //             const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${COMPANY_ID}`);
// // //             if (res.ok) {
// // //               departmentData = await res.json();
// // //             }
// // //           } catch (error) {
// // //             console.log("AddProject - No-auth department fetch failed");
// // //           }
// // //         }

// // //         // Third try: general departments endpoint
// // //         if (!departmentData) {
// // //           try {
// // //             const res = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/departments', {
// // //               headers: {
// // //                 'Authorization': `Bearer ${token}`,
// // //                 'Content-Type': 'application/json',
// // //               },
// // //             });
// // //             if (res.ok) {
// // //               departmentData = await res.json();
// // //             }
// // //           } catch (error) {
// // //             console.log("AddProject - General department fetch failed");
// // //           }
// // //         }

// // //         setDepartments(departmentData || []);
// // //       } catch (error) {
// // //         console.error('AddProject - Error fetching departments:', error);
// // //         setDepartments([]);
// // //       }
// // //     };
// // //     fetchDepartments();
// // //   }, []);

// // //   // ---------------- Click Outside Handler ----------------
// // //   useEffect(() => {
// // //     const handleClickOutside = (event) => {
// // //       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
// // //         setShowDepartmentDropdown(false);
// // //       }
// // //     };

// // //     document.addEventListener('mousedown', handleClickOutside);
// // //     return () => {
// // //       document.removeEventListener('mousedown', handleClickOutside);
// // //     };
// // //   }, []);

// // //   // ---------------- Validation Helpers ----------------
// // //   const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
// // //   const isValidPhone = (phone) => /^[6-9]\d{9}$/.test(phone);

// // //   // ---------------- Computed Values ----------------
// // //   // Filter departments based on search term
// // //   const filteredDepartments = departments.filter(dept =>
// // //     dept.name.toLowerCase().includes(departmentSearchTerm.toLowerCase())
// // //   );

// // //   // Group employees by department
// // //   const employeesByDepartment = employees.reduce((acc, emp) => {
// // //     const deptId = emp.department?._id || emp.department || 'no-department';
// // //     const deptName = emp.department?.name || 'No Department';

// // //     if (!acc[deptId]) {
// // //       acc[deptId] = {
// // //         id: deptId,
// // //         name: deptName,
// // //         employees: []
// // //       };
// // //     }
// // //     acc[deptId].employees.push(emp);
// // //     return acc;
// // //   }, {});

// // //   // Filter employees based on selected departments
// // //   const filteredEmployees = employees.filter(emp => {
// // //     if (!formData.departments || formData.departments.length === 0) return false; // Show none if no departments selected
// // //     return formData.departments.some(deptId => 
// // //       String(emp.department) === String(deptId) || 
// // //       String(emp.department?._id) === String(deptId)
// // //     );
// // //   });

// // //   // Get department-wise filtered employees for display
// // //   const departmentWiseEmployees = formData.departments.reduce((acc, deptId) => {
// // //     const deptEmployees = employees.filter(emp => 
// // //       String(emp.department) === String(deptId) || 
// // //       String(emp.department?._id) === String(deptId)
// // //     );

// // //     if (deptEmployees.length > 0) {
// // //       const dept = departments.find(d => d._id === deptId);
// // //       acc[deptId] = {
// // //         name: dept?.name || 'Unknown Department',
// // //         employees: deptEmployees
// // //       };
// // //     }
// // //     return acc;
// // //   }, {});

// // //   // ---------------- Handlers ----------------
// // //   const handleChange = (e) => {
// // //     const { name, value } = e.target;
// // //     setFormData((prev) => ({ ...prev, [name]: value }));
// // //   };

// // //   const handleDepartmentToggle = (departmentId) => {
// // //     const id = typeof departmentId === "object" ? departmentId._id : departmentId;

// // //     setFormData(prev => {
// // //       const isSelected = prev.departments.includes(id);
// // //       const updatedDepartments = isSelected
// // //         ? prev.departments.filter(depId => depId !== id)
// // //         : [...prev.departments, id];

// // //       return {
// // //         ...prev,
// // //         departments: updatedDepartments,
// // //         selectedEmployeeId: ''
// // //       };
// // //     });

// // //     setSelectedTeamMembers([]); // Clear team members when departments change
// // //   };



// // //   const handleAddTeamMember = () => {
// // //     const selectedEmployee = employees.find(emp => emp._id === formData.selectedEmployeeId);
// // //     if (selectedEmployee && !selectedTeamMembers.some(member => member._id === selectedEmployee._id)) {
// // //       setSelectedTeamMembers(prev => [...prev, selectedEmployee]);
// // //     }
// // //     setFormData(prev => ({ ...prev, selectedEmployeeId: '' })); // reset dropdown
// // //   };

// // //   const handleRemoveTeamMember = (id) => {
// // //     setSelectedTeamMembers(prev => prev.filter(member => member._id !== id));
// // //   };

// // //   // Custom Fields Handlers
// // //   const handleAddCustomField = () => {
// // //     if (newCustomField.key.trim() && newCustomField.value.trim()) {
// // //       setFormData(prev => ({
// // //         ...prev,
// // //         customFields: [...prev.customFields, { ...newCustomField }]
// // //       }));
// // //       setNewCustomField({ key: '', value: '' });
// // //     }
// // //   };

// // //   const handleRemoveCustomField = (index) => {
// // //     setFormData(prev => ({
// // //       ...prev,
// // //       customFields: prev.customFields.filter((_, i) => i !== index)
// // //     }));
// // //   };

// // //   const handleCustomFieldChange = (field, value) => {
// // //     setNewCustomField(prev => ({ ...prev, [field]: value }));
// // //   };

// // //   // Add single status to the dropdown list using API
// // //   const handleAddStatus = async () => {
// // //     const label = (newStatus || '').trim();
// // //     if (!label) return;

// // //     const exists = statusOptions.some(s => s.toLowerCase() === label.toLowerCase());
// // //     if (exists) {
// // //       setShowAlert('This status already exists in your local list!');
// // //       setNewStatus('');
// // //       return;
// // //     }

// // //     try {
// // //       const token = localStorage.getItem('authToken');
// // //       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
// // //         method: 'POST',
// // //         headers: {
// // //           'Authorization': `Bearer ${token}`,
// // //           'Content-Type': 'application/json'
// // //         },
// // //         body: JSON.stringify({
// // //           company: COMPANY_ID,
// // //           name: label
// // //         })
// // //       });

// // //       if (response.ok) {
// // //         const newStatus = await response.json();

// // //         // Refresh the status list from server to ensure we have latest data
// // //         await fetchCustomStatuses();

// // //         // Set the new status as selected
// // //         setFormData(prev => ({ ...prev, status: label }));

// // //         setNewStatus('');
// // //         // Keep modal open so user can add more statuses
// // //         // setShowStatusForm(false);
// // //         setShowAlert(`Status "${label}" added successfully! You can add more statuses or close the modal.`);
// // //       } else {
// // //         const errorData = await response.json().catch(() => ({}));
// // //         console.error('AddProject - Failed to create status:', errorData);

// // //         // Handle specific error messages from server
// // //         if (errorData.message && errorData.message.includes('unique')) {
// // //           setShowAlert(`Status "${label}" already exists for your company. Please choose a different name.`);
// // //         } else {
// // //           setShowAlert(`Failed to create status: ${errorData.message || 'Please try again.'}`);
// // //         }

// // //         setNewStatus('');
// // //       }
// // //     } catch (error) {
// // //       console.error('AddProject - Error creating status:', error);
// // //       setShowAlert('Error creating status. Please check your connection and try again.');
// // //       setNewStatus('');
// // //     }
// // //   };

// // //   // Open status form
// // //   const handleOpenStatusForm = () => {
// // //     setShowStatusForm(true);
// // //   };

// // //   // Close status form
// // //   const handleCloseStatusForm = () => {
// // //     setShowStatusForm(false);
// // //     setNewStatus('');
// // //   };

// // //   // Remove a status from the list (local only - for project-specific use)
// // //   const handleRemoveStatus = (statusToRemove) => {
// // //     const updated = statusOptions.filter(status => status !== statusToRemove);
// // //     setStatusOptions(updated);
// // //     // Note: Status options are project-specific and not saved globally

// // //     // If the removed status was selected, change to the first remaining status or empty
// // //     if (formData.status === statusToRemove) {
// // //       setFormData(prev => ({ ...prev, status: updated.length > 0 ? updated[0] : '' }));
// // //     }
// // //   };

// // //   // Delete a status from MongoDB database
// // //   const handleDeleteStatus = async (statusToDelete) => {
// // //     try {
// // //       const token = localStorage.getItem('authToken');

// // //       // First, find the status ID from the API to delete it
// // //       const fetchResponse = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
// // //         headers: {
// // //           'Authorization': `Bearer ${token}`,
// // //           'Content-Type': 'application/json'
// // //         }
// // //       });

// // //       if (!fetchResponse.ok) {
// // //         throw new Error('Failed to fetch statuses for deletion');
// // //       }

// // //       const statuses = await fetchResponse.json();
// // //       let statusArray = [];

// // //       // Handle wrapped response format
// // //       if (Array.isArray(statuses)) {
// // //         statusArray = statuses;
// // //       } else if (statuses && statuses.statuses && Array.isArray(statuses.statuses)) {
// // //         statusArray = statuses.statuses;
// // //       }

// // //       // Find the status object to get its ID
// // //       const statusToDeleteObj = statusArray.find(status => status.name === statusToDelete);

// // //       if (!statusToDeleteObj) {
// // //         setShowAlert(`Status "${statusToDelete}" not found in database.`);
// // //         return;
// // //       }

// // //       // Make DELETE request to remove from MongoDB
// // //       const deleteResponse = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/${statusToDeleteObj._id}`, {
// // //         method: 'DELETE',
// // //         headers: {
// // //           'Authorization': `Bearer ${token}`,
// // //           'Content-Type': 'application/json'
// // //         }
// // //       });

// // //       if (deleteResponse.ok) {

// // //         // Refresh the status list from server
// // //         await fetchCustomStatuses();

// // //         // If the deleted status was selected, change to the first remaining status or empty
// // //         if (formData.status === statusToDelete) {
// // //           const updatedOptions = statusOptions.filter(status => status !== statusToDelete);
// // //           setFormData(prev => ({ ...prev, status: updatedOptions.length > 0 ? updatedOptions[0] : '' }));
// // //         }

// // //         setShowAlert(`Status "${statusToDelete}" deleted successfully from database!`);
// // //       } else {
// // //         const errorData = await deleteResponse.json().catch(() => ({}));
// // //         console.error('AddProject - Failed to delete status:', errorData);
// // //         setShowAlert(`Failed to delete status: ${errorData.message || 'Please try again.'}`);
// // //       }
// // //     } catch (error) {
// // //       console.error('AddProject - Error deleting status:', error);
// // //       setShowAlert('Error deleting status from database. Please check your connection and try again.');
// // //     }
// // //   };


// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();

// // //     // Validation
// // //     if (!formData.title || !formData.startDate || !formData.dueDate || formData.departments.length === 0) {
// // //       setShowAlert('Please fill in all required fields (Title, Start Date, Due Date, Departments)');
// // //       return;
// // //     }
// // //     if (statusOptions.length === 0 || !formData.status) {
// // //       setShowAlert('Please add at least one status and select it for the project.');
// // //       return;
// // //     }
// // //     if (formData.clientEmail && !isValidEmail(formData.clientEmail)) {
// // //       setShowAlert('Please enter a valid email address.');
// // //       return;
// // //     }
// // //     if (formData.clientMobileNo && !isValidPhone(formData.clientMobileNo)) {
// // //       setShowAlert('Please enter a valid 10-digit mobile number.');
// // //       return;
// // //     }

// // //     setLoading(true);

// // //     try {
// // //       const token = localStorage.getItem('authToken'); // or wherever you store your token

// // //       const projectData = {
// // //         company: formData.company || COMPANY_ID,
// // //         title: formData.title,
// // //         description: formData.description,
// // //         status: formData.status,
// // //         startDate: formData.startDate,
// // //         dueDate: formData.dueDate,
// // //         budget: formData.budget ? parseFloat(formData.budget) : 0,
// // //         progress: parseInt(formData.progress) || 0,
// // //         teamMembers: selectedTeamMembers.map((emp) => emp._id),
// // //         projectHead: formData.projectHead || null,
// // //         clientName: formData.clientName,
// // //         clientCompany: formData.clientCompany,
// // //         clientEmail: formData.clientEmail,
// // //         clientMobileNo: formData.clientMobileNo,
// // //         clientAddress: formData.clientAddress,
// // //         clientCity: formData.clientCity,
// // //         clientState: formData.clientState,
// // //         department: formData.departments,
// // //         customFields: formData.customFields,
// // //         statusOptions: statusOptions, // Save custom statuses with project
// // //       };

// // //       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/projectsmgnt', {
// // //         method: 'POST',
// // //         headers: { 
// // //           'Content-Type': 'application/json',
// // //           'Authorization': `Bearer ${token}`  // <-- Add this header
// // //         },
// // //         body: JSON.stringify(projectData)
// // //       });

// // //       if (response.ok) {
// // //         const savedProject = await response.json();
// // //         // setProjects([...projects, savedProject]);

// // //         // Trigger refresh of ProjectList and ProjectTracker components
// // //         if (window.refreshProjects) {
// // //           await window.refreshProjects();
// // //         }

// // //         // Also refresh ProjectTracker if available
// // //         if (window.refreshProjectTracker) {
// // //           await window.refreshProjectTracker();
// // //         }

// // //         // Add small delay before navigation to ensure refresh completes
// // //         setTimeout(() => {
// // //           if (onNavigate) {
// // //             onNavigate('/projects', 'Projects');
// // //           } else {
// // //             navigate('/projects');
// // //           }
// // //         }, 500);
// // //       } else {
// // //         const errorData = await response.json();
// // //         setShowAlert(`Error creating project: ${errorData.message || 'Unknown error'}`);
// // //       }
// // //     } catch (error) {
// // //       console.error('Error creating project:', error);
// // //       setShowAlert('Error creating project. Please try again.');
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };


// // //   // ---------------- UI ----------------
// // //   return (
// // //     <div style={addProjectStyle}>
// // //       <div style={pageHeaderStyle}>
// // //         <button onClick={() => onNavigate ? onNavigate('/projects', 'Projects') : navigate('/projects')} style={btnSecondaryStyle}>
// // //           <ArrowLeft size={20} />
// // //           Back to Projects
// // //         </button>
// // //         <h1 style={headerTitleStyle}>
// // //           <Sparkles size={32} style={{ color: '#f093fb' }} />
// // //           Create New Project
// // //         </h1>
// // //       </div>

// // //       <div style={formContainerStyle}>
// // //         <form onSubmit={handleSubmit}>
// // //           {/* Title */}
// // //           <div style={formGroupStyle}>
// // //             <label htmlFor="title" style={labelStyle}>📋 Project Title *</label>
// // //             <input
// // //               type="text"
// // //               id="title"
// // //               name="title"
// // //               value={formData.title}
// // //               onChange={handleChange}
// // //               placeholder="Enter project title"
// // //               required
// // //               style={{
// // //                 ...inputStyle,
// // //                 '::placeholder': { color: 'rgba(255, 255, 255, 0.6)' }
// // //               }}
// // //             />
// // //           </div>

// // //           {/* Departments - Searchable Dropdown with Multiple Selection */}
// // //           <div style={formGroupStyle}>
// // //             <label style={labelStyle}>
// // //               Departments * 
// // //               {formData.departments.length > 0 && (
// // //                 <span style={{ 
// // //                   fontSize: '0.75rem', 
// // //                   color: '#6b7280', 
// // //                   fontWeight: 'normal',
// // //                   marginLeft: '0.5rem',
// // //                   padding: '0.25rem 0.5rem',
// // //                   backgroundColor: '#f3f4f6',
// // //                   borderRadius: '0.375rem',
// // //                   border: '1px solid #d1d5db'
// // //                 }}>
// // //                   {formData.departments.length} selected
// // //                 </span>
// // //               )}
// // //             </label>

// // //             {/* Search Input with Dropdown Toggle */}
// // //             <div style={{ position: 'relative' }} ref={dropdownRef}>
// // //               <div style={{ display: 'flex', alignItems: 'center' }}>
// // //                 <input
// // //                   type="text"
// // //                   placeholder="Search departments..."
// // //                   value={departmentSearchTerm}
// // //                   onChange={(e) => setDepartmentSearchTerm(e.target.value)}
// // //                   onFocus={() => setShowDepartmentDropdown(true)}
// // //                   style={{
// // //                     ...inputStyle,
// // //                     paddingRight: '2.5rem'
// // //                   }}
// // //                 />
// // //                 <button
// // //                   type="button"
// // //                   onClick={() => setShowDepartmentDropdown(!showDepartmentDropdown)}
// // //                   style={{
// // //                     position: 'absolute',
// // //                     right: '0.5rem',
// // //                     background: 'none',
// // //                     border: 'none',
// // //                     cursor: 'pointer',
// // //                     padding: '0.25rem',
// // //                     color: '#6b7280',
// // //                     fontSize: '1rem'
// // //                   }}
// // //                 >
// // //                   {showDepartmentDropdown ? '–' : '–'}
// // //                 </button>
// // //               </div>

// // //               {/* Dropdown List */}
// // //               {showDepartmentDropdown && (
// // //                 <div style={{
// // //                   position: 'absolute',
// // //                   top: '100%',
// // //                   left: 0,
// // //                   right: 0,
// // //                   backgroundColor: 'white',
// // //                   border: '1px solid #d1d5db',
// // //                   borderRadius: '0.375rem',
// // //                   boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
// // //                   zIndex: 1000,
// // //                   maxHeight: '200px',
// // //                   overflowY: 'auto'
// // //                 }}>
// // //                   {filteredDepartments.length > 0 ? (
// // //                     filteredDepartments.map((dept) => (
// // //                       <div
// // //                         key={dept._id}
// // //                         onClick={() => handleDepartmentToggle(dept._id)}
// // //                         style={{
// // //                           padding: '0.75rem',
// // //                           cursor: 'pointer',
// // //                           backgroundColor: formData.departments.includes(dept._id) ? '#f0f9ff' : 'white',
// // //                           borderBottom: '1px solid #f3f4f6',
// // //                           display: 'flex',
// // //                           alignItems: 'center',
// // //                           gap: '0.5rem',
// // //                           transition: 'background-color 0.2s ease'
// // //                         }}
// // //                         onMouseEnter={(e) => {
// // //                           if (!formData.departments.includes(dept._id)) {
// // //                             e.target.style.backgroundColor = '#f9fafb';
// // //                           }
// // //                         }}
// // //                         onMouseLeave={(e) => {
// // //                           if (!formData.departments.includes(dept._id)) {
// // //                             e.target.style.backgroundColor = 'white';
// // //                           }
// // //                         }}
// // //                       >
// // //                         <input
// // //                           type="checkbox"
// // //                           checked={formData.departments.includes(dept._id)}
// // //                           onChange={() => {}}
// // //                           style={{ cursor: 'pointer' }}
// // //                         />
// // //                         <span style={{
// // //                           fontSize: '0.875rem',
// // //                           color: formData.departments.includes(dept._id) ? '#0c4a6e' : '#374151',
// // //                           fontWeight: formData.departments.includes(dept._id) ? '500' : 'normal'
// // //                         }}>
// // //                           {dept.name}
// // //                         </span>
// // //                       </div>
// // //                     ))
// // //                   ) : (
// // //                     <div style={{
// // //                       padding: '0.75rem',
// // //                       textAlign: 'center',
// // //                       color: '#6b7280',
// // //                       fontSize: '0.875rem'
// // //                     }}>
// // //                       {departmentSearchTerm ? 'No departments found' : 'No departments available'}
// // //                     </div>
// // //                   )}
// // //                 </div>
// // //               )}
// // //             </div>

// // //             {/* Selected Departments Display */}
// // //             {formData.departments.length > 0 && (
// // //               <div style={{ marginTop: '0.75rem' }}>
// // //                 <div style={{ fontSize: '0.75rem', color: '#6b7280', marginBottom: '0.5rem' }}>
// // //                   Selected Departments:
// // //                 </div>
// // //                 <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
// // //                   {formData.departments.map(deptId => {
// // //                      const id = typeof deptId === "object" ? deptId._id : deptId;
// // //                      const dept = departments.find(d => String(d._id) === String(id));
// // //                     return dept ? (
// // //                       <span key={deptId} style={{
// // //                         fontSize: '0.75rem',
// // //                         padding: '0.25rem 0.5rem',
// // //                         backgroundColor: '#e0f2fe',
// // //                         color: '#0c4a6e',
// // //                         borderRadius: '0.375rem',
// // //                         border: '1px solid #bae6fd',
// // //                         display: 'flex',
// // //                         alignItems: 'center',
// // //                         gap: '0.25rem'
// // //                       }}>
// // //                         {dept.name}
// // //                         <button
// // //                           type="button"
// // //                           onClick={() => handleDepartmentToggle(deptId)}
// // //                           style={{
// // //                             background: 'none',
// // //                             border: 'none',
// // //                             color: '#0c4a6e',
// // //                             cursor: 'pointer',
// // //                             padding: '0',
// // //                             fontSize: '0.75rem',
// // //                             fontWeight: 'bold'
// // //                           }}
// // //                         >
// // //                           ×
// // //                         </button>
// // //                       </span>
// // //                     ) : null;
// // //                   })}
// // //                 </div>
// // //               </div>
// // //             )}
// // //           </div>

// // //           {/* Team Members - Dropdown */}
// // //           <div style={formGroupStyle}>
// // //             {(() => {

// // //               // Filter employees based on selected departments
// // //               const filteredEmployees = employees.filter(emp => {
// // //                 if (formData.departments.length === 0) return false;

// // //                 // Handle different department formats
// // //                 let empDeptIds = [];

// // //                 if (emp.department) {
// // //                   if (Array.isArray(emp.department)) {
// // //                     // Employee department is an array of department IDs
// // //                     empDeptIds = emp.department.map(dept => {
// // //                       if (typeof dept === 'object') {
// // //                         return dept._id || dept.id;
// // //                       }
// // //                       return dept;
// // //                     }).filter(Boolean);
// // //                   } else if (typeof emp.department === 'object') {
// // //                     // Employee department is a single object
// // //                     const deptId = emp.department._id || emp.department.id;
// // //                     if (deptId) empDeptIds = [deptId];
// // //                   } else if (typeof emp.department === 'string') {
// // //                     // Employee department is a single string ID
// // //                     empDeptIds = [emp.department];
// // //                   }
// // //                 }

// // //                 // Check if any of employee's departments match any selected department
// // //                 const matches = empDeptIds.length > 0 && empDeptIds.some(empDeptId => 
// // //                   formData.departments.some(selectedDeptId => 
// // //                     String(empDeptId) === String(selectedDeptId)
// // //                   )
// // //                 );

// // //                 return matches;
// // //               });



// // //               // Group employees by department for better display
// // //               const departmentWiseEmployees = {};
// // //               filteredEmployees.forEach(emp => {
// // //                 // Handle employees with multiple departments
// // //                 if (Array.isArray(emp.department)) {
// // //                   emp.department.forEach(dept => {
// // //                     let deptId, deptName;

// // //                     if (typeof dept === 'object') {
// // //                       deptId = dept._id || dept.id;
// // //                       deptName = dept.name || dept.departmentName;
// // //                     } else {
// // //                       deptId = dept;
// // //                       // Find department name from departments array
// // //                       const foundDept = departments.find(d => String(d._id) === String(dept));
// // //                       deptName = foundDept?.name || foundDept?.departmentName || `Department ${dept}`;
// // //                     }

// // //                     // Only group if this department is selected
// // //                     if (formData.departments.includes(deptId)) {
// // //                       if (!departmentWiseEmployees[deptId]) {
// // //                         departmentWiseEmployees[deptId] = {
// // //                           name: deptName,
// // //                           employees: []
// // //                         };
// // //                       }

// // //                       // Avoid duplicate employees in same department
// // //                       if (!departmentWiseEmployees[deptId].employees.find(e => e._id === emp._id)) {
// // //                         departmentWiseEmployees[deptId].employees.push(emp);
// // //                       }
// // //                     }
// // //                   });
// // //                 } else {
// // //                   // Handle single department
// // //                   let deptId, deptName;

// // //                   if (typeof emp.department === 'object') {
// // //                     deptId = emp.department._id || emp.department.id;
// // //                     deptName = emp.department.name || emp.department.departmentName;
// // //                   } else {
// // //                     deptId = emp.department;
// // //                     const foundDept = departments.find(d => String(d._id) === String(emp.department));
// // //                     deptName = foundDept?.name || foundDept?.departmentName || `Department ${emp.department}`;
// // //                   }

// // //                   if (!departmentWiseEmployees[deptId]) {
// // //                     departmentWiseEmployees[deptId] = {
// // //                       name: deptName,
// // //                       employees: []
// // //                     };
// // //                   }
// // //                   departmentWiseEmployees[deptId].employees.push(emp);
// // //                 }
// // //               });

// // //               return (
// // //                 <>
// // //                   <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
// // //                     <Users size={20} /> Assign Team Members
// // //                     {formData.departments.length > 0 && (
// // //                       <span style={{ 
// // //                         fontSize: '0.75rem', 
// // //                         color: '#6b7280', 
// // //                         fontWeight: 'normal',
// // //                         marginLeft: '0.5rem',
// // //                         padding: '0.25rem 0.5rem',
// // //                         backgroundColor: '#f3f4f6',
// // //                         borderRadius: '0.375rem',
// // //                         border: '1px solid #d1d5db'
// // //                       }}>
// // //                         {filteredEmployees.length} employee{filteredEmployees.length !== 1 ? 's' : ''} available
// // //                       </span>
// // //                     )}
// // //                   </label>
// // //             <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
// // //               <select
// // //                 value={formData.selectedEmployeeId}
// // //                 onChange={handleChange}
// // //                 name="selectedEmployeeId"
// // //                 style={selectStyle}
// // //                 disabled={formData.departments.length === 0}
// // //               >
// // //                 <option value="">
// // //                   {formData.departments.length === 0
// // //                     ? "Select departments first" 
// // //                     : filteredEmployees.length === 0 
// // //                       ? "No employees in selected departments"
// // //                       : "Select a team member"
// // //                   }
// // //                 </option>
// // //                 {Object.keys(departmentWiseEmployees).map(deptId => {
// // //                   const deptGroup = departmentWiseEmployees[deptId];
// // //                   return [
// // //                     <option key={`dept-${deptId}`} disabled style={{ fontWeight: 'bold', backgroundColor: '#f3f4f6' }}>
// // //                       {deptGroup.name} ({deptGroup.employees.length} employees) // // //                     </option>,
// // //                     ...deptGroup.employees.map(emp => (
// // //                       <option key={emp._id} value={emp._id} style={{ paddingLeft: '1rem' }}>
// // //                         &nbsp;&nbsp;&nbsp;&nbsp;{emp.teamMemberName || emp.name || 'Unnamed'} - {emp.role || 'No Position'}
// // //                       </option>
// // //                     ))
// // //                   ];
// // //                 }).flat()}
// // //               </select>
// // //               <button
// // //                 type="button"
// // //                 onClick={handleAddTeamMember}
// // //                 style={{ 
// // //                   ...btnPrimaryStyle, 
// // //                   padding: '0.5rem 1rem',
// // //                   opacity: formData.departments.length === 0 || filteredEmployees.length === 0 ? 0.5 : 1,
// // //                   cursor: formData.departments.length === 0 || filteredEmployees.length === 0 ? 'not-allowed' : 'pointer'
// // //                 }}
// // //                 disabled={formData.departments.length === 0 || filteredEmployees.length === 0}
// // //               >
// // //                 Add
// // //               </button>
// // //             </div>

// // //                   {/* Selected Members */}
// // //                   {selectedTeamMembers.length > 0 && (
// // //                     <div style={selectedEmployeesContainer}>
// // //                       {selectedTeamMembers.map((member) => (
// // //                         <div key={member._id} style={selectedEmployeeChip}>
// // //                           <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
// // //                             <span style={{ fontWeight: '500' }}>
// // //                               {member.teamMemberName || member.name || 'Unnamed'}
// // //                             </span>
// // //                             <span style={{ fontSize: '0.75rem', color: '#64748b', fontStyle: 'italic' }}>
// // //                               {member.role || 'No Position'}
// // //                             </span>
// // //                           </div>
// // //                           <X
// // //                             size={14}
// // //                             style={{ cursor: 'pointer', marginLeft: '0.5rem' }}
// // //                             onClick={() => handleRemoveTeamMember(member._id)}
// // //                           />
// // //                         </div>
// // //                       ))}
// // //                     </div>
// // //                   )}
// // //                 </>
// // //               );
// // //             })()}
// // //           </div>

// // //           {/* Project Head */}
// // //           <div style={formGroupStyle}>
// // //             <label htmlFor="projectHead" style={labelStyle}>💼 Project Head</label>
// // //             <select
// // //               id="projectHead"
// // //               name="projectHead"
// // //               value={formData.projectHead}
// // //               onChange={handleChange}
// // //               style={selectStyle}
// // //             >
// // //               <option value="">Select Project Head</option>
// // //               {employees.map(emp => (
// // //                 <option key={emp._id} value={emp._id}>
// // //                   {emp.teamMemberName || emp.name || 'Unnamed'} - {emp.role || 'No Position'}
// // //                 </option>
// // //               ))}
// // //             </select>
// // //           </div>

// // //           {/* Description */}
// // //           <div style={formGroupStyle}>
// // //             <label htmlFor="description" style={labelStyle}> Description</label>
// // //             <textarea
// // //               id="description"
// // //               name="description"
// // //               value={formData.description}
// // //               onChange={handleChange}
// // //               placeholder="Project description..."
// // //               style={textareaStyle}
// // //             />
// // //           </div>

// // //           {/* Status */}
// // //           <div style={formGroupStyle}>
// // //             <label htmlFor="status" style={labelStyle}>📊 Status</label>
// // //             <select
// // //               id="status"
// // //               name="status"
// // //               value={formData.status}
// // //               onChange={handleChange}
// // //               style={selectStyle}
// // //             >
// // //               <option value="">-- Select Status (Add statuses first) --</option>
// // //               {statusOptions.map(opt => (
// // //                 <option key={opt} value={opt}>{opt}</option>
// // //               ))}
// // //             </select>
// // //             {/* Add Status Button */}
// // //             <div style={{ marginTop: '0.75rem' }}>
// // //               <button
// // //                 type="button"
// // //                 onClick={handleOpenStatusForm}
// // //                 style={{
// // //                   ...btnPrimaryStyle,
// // //                   whiteSpace: 'nowrap'
// // //                 }}
// // //               >
// // //                 ž• Add & Manage Statuses
// // //               </button>
// // //             </div>

// // //             {/* Status Form Modal */}
// // //             {showStatusForm && (
// // //               <div style={{
// // //                 position: 'fixed',
// // //                 top: 0,
// // //                 left: 0,
// // //                 right: 0,
// // //                 bottom: 0,
// // //                 backgroundColor: 'rgba(0, 0, 0, 0.5)',
// // //                 display: 'flex',
// // //                 justifyContent: 'center',
// // //                 alignItems: 'center',
// // //                 zIndex: 1000
// // //               }}>
// // //                 <div style={{
// // //                   backgroundColor: 'white',
// // //                   borderRadius: '1rem',
// // //                   padding: '2rem',
// // //                   width: '400px',
// // //                   maxWidth: '90vw',
// // //                   boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
// // //                 }}>
// // //                   <h3 style={{
// // //                     margin: '0 0 1.5rem 0',
// // //                     fontSize: '1.5rem',
// // //                     fontWeight: 600,
// // //                     color: '#1f2937',
// // //                     textAlign: 'center'
// // //                   }}>
// // //                     📊 Add & Manage Statuses
// // //                   </h3>

// // //                   <div style={{ marginBottom: '1.5rem' }}>
// // //                     <div style={{ marginBottom: '1rem' }}>
// // //                       <label style={{
// // //                         display: 'block',
// // //                         marginBottom: '0.5rem',
// // //                         fontWeight: 500,
// // //                         color: '#374151',
// // //                         fontSize: '0.875rem'
// // //                       }}>
// // //                         Status Name *
// // //                       </label>
// // //                       <input
// // //                         type="text"
// // //                         value={newStatus}
// // //                         onChange={(e) => setNewStatus(e.target.value)}
// // //                         placeholder="Enter status name (e.g., On Hold, Under Review, Testing)"
// // //                         style={{
// // //                           ...inputStyle,
// // //                           marginBottom: '0.5rem'
// // //                         }}
// // //                         autoFocus
// // //                       />
// // //                     </div>

// // //                     {/* Show current status count */}
// // //                     <div style={{
// // //                       padding: '0.75rem',
// // //                       backgroundColor: '#f0f9ff',
// // //                       borderRadius: '0.5rem',
// // //                       border: '1px solid #bae6fd',
// // //                       marginBottom: '0.5rem'
// // //                     }}>
// // //                       <div style={{
// // //                         fontSize: '0.75rem',
// // //                         color: '#0c4a6e',
// // //                         fontWeight: 500,
// // //                         marginBottom: '0.25rem'
// // //                       }}>
// // //                         📊 Current Status Count: {statusOptions.length}
// // //                       </div>
// // //                       <div style={{
// // //                         fontSize: '0.875rem',
// // //                         color: '#1f2937'
// // //                       }}>
// // //                         {newStatus.trim() ? (
// // //                           <span>
// // //                             Adding: <span style={{ 
// // //                               padding: '0.25rem 0.5rem', 
// // //                               backgroundColor: '#dbeafe', 
// // //                               borderRadius: '0.25rem',
// // //                               fontWeight: '500'
// // //                             }}>
// // //                               {newStatus.trim()}
// // //                             </span>
// // //                             <span style={{ color: '#6b7280', marginLeft: '0.5rem' }}>†Total will be {statusOptions.length + 1}</span>
// // //                           </span>
// // //                         ) : (
// // //                           <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>Enter status name to add</span>
// // //                         )}
// // //                       </div>
// // //                     </div>

// // //                     <div style={{
// // //                       fontSize: '0.75rem',
// // //                       color: '#6b7280',
// // //                       fontStyle: 'italic'
// // //                     }}>
// // //                       Examples: On Hold, Under Review, Testing, Cancelled, Paused, Approved
// // //                     </div>

// // //                     <div style={{
// // //                       fontSize: '0.75rem',
// // //                       color: '#059669',
// // //                       fontWeight: '500',
// // //                       marginTop: '0.5rem',
// // //                       padding: '0.5rem',
// // //                       backgroundColor: '#ecfdf5',
// // //                       borderRadius: '0.375rem',
// // //                       border: '1px solid #a7f3d0'
// // //                     }}>
// // //                       ¡ Tip: Add multiple statuses one by one. The modal will stay open until you click "Cancel".
// // //                     </div>
// // //                   </div>

// // //                   {/* Existing Statuses Management */}
// // //                   {statusOptions.length > 0 && (
// // //                     <div style={{ marginBottom: '1.5rem' }}>
// // //                       <div style={{
// // //                         fontSize: '0.875rem',
// // //                         fontWeight: 600,
// // //                         color: '#374151',
// // //                         marginBottom: '0.75rem',
// // //                         borderBottom: '1px solid #e5e7eb',
// // //                         paddingBottom: '0.5rem'
// // //                       }}>
// // //                         —ï Existing Statuses ({statusOptions.length})
// // //                       </div>

// // //                       <div style={{
// // //                         display: 'flex',
// // //                         flexDirection: 'column',
// // //                         gap: '0.5rem',
// // //                         maxHeight: '200px',
// // //                         overflowY: 'auto',
// // //                         padding: '0.5rem',
// // //                         backgroundColor: '#f8fafc',
// // //                         borderRadius: '0.5rem',
// // //                         border: '1px solid #e5e7eb'
// // //                       }}>
// // //                         {statusOptions.map((status, index) => (
// // //                           <div key={index} style={{
// // //                             display: 'flex',
// // //                             alignItems: 'center',
// // //                             justifyContent: 'space-between',
// // //                             padding: '0.5rem 0.75rem',
// // //                             backgroundColor: 'white',
// // //                             border: '1px solid #e5e7eb',
// // //                             borderRadius: '0.375rem'
// // //                           }}>
// // //                             <span style={{
// // //                               fontSize: '0.875rem',
// // //                               fontWeight: '500',
// // //                               color: '#1f2937'
// // //                             }}>
// // //                               {status}
// // //                             </span>

// // //                             <button
// // //                               type="button"
// // //                               onClick={() => {
// // //                                 if (window.confirm(`Delete "${status}" from database? This action cannot be undone.`)) {
// // //                                   handleDeleteStatus(status);
// // //                                 }
// // //                               }}
// // //                               style={{
// // //                                 backgroundColor: '#ef4444',
// // //                                 color: 'white',
// // //                                 border: 'none',
// // //                                 borderRadius: '0.25rem',
// // //                                 padding: '0.25rem 0.5rem',
// // //                                 cursor: 'pointer',
// // //                                 fontSize: '0.75rem',
// // //                                 fontWeight: '500'
// // //                               }}
// // //                               onMouseEnter={(e) => {
// // //                                 e.target.style.backgroundColor = '#dc2626';
// // //                               }}
// // //                               onMouseLeave={(e) => {
// // //                                 e.target.style.backgroundColor = '#ef4444';
// // //                               }}
// // //                             >
// // //                               —ï Delete
// // //                             </button>
// // //                           </div>
// // //                         ))}
// // //                       </div>
// // //                     </div>
// // //                   )}

// // //                   <div style={{
// // //                     display: 'flex',
// // //                     gap: '1rem',
// // //                     justifyContent: 'flex-end'
// // //                   }}>
// // //                     <button
// // //                       type="button"
// // //                       onClick={handleCloseStatusForm}
// // //                       style={{
// // //                         ...btnSecondaryStyle,
// // //                         padding: '0.75rem 1.5rem'
// // //                       }}
// // //                     >
// // //                       Cancel
// // //                     </button>
// // //                     <button
// // //                       type="button"
// // //                       onClick={handleAddStatus}
// // //                       style={{
// // //                         ...btnPrimaryStyle,
// // //                         padding: '0.75rem 1.5rem',
// // //                         opacity: (newStatus || '').trim() ? 1 : 0.5,
// // //                         cursor: (newStatus || '').trim() ? 'pointer' : 'not-allowed'
// // //                       }}
// // //                       disabled={!(newStatus || '').trim()}
// // //                     >
// // //                       ž• Add This Status
// // //                     </button>
// // //                   </div>
// // //                 </div>
// // //               </div>
// // //             )}

// // //           </div>

// // //           {/* Start Date & Due Date */}
// // //           <div style={formRowStyle}>
// // //             <div style={formGroupStyle}>
// // //               <label htmlFor="startDate" style={labelStyle}>… Start Date *</label>
// // //               <input
// // //                 type="date"
// // //                 id="startDate"
// // //                 name="startDate"
// // //                 value={formData.startDate}
// // //                 onChange={handleChange}
// // //                 required
// // //                 style={inputStyle}
// // //               />
// // //             </div>

// // //             <div style={formGroupStyle}>
// // //               <label htmlFor="dueDate" style={labelStyle}> Due Date *</label>
// // //               <input
// // //                 type="date"
// // //                 id="dueDate"
// // //                 name="dueDate"
// // //                 value={formData.dueDate}
// // //                 onChange={handleChange}
// // //                 required
// // //                 style={inputStyle}
// // //               />
// // //             </div>
// // //           </div>

// // //           {/* Budget */}
// // //           <div style={formGroupStyle}>
// // //             <label htmlFor="budget" style={labelStyle}>💰 Budget</label>
// // //             <input
// // //               type="number"
// // //               id="budget"
// // //               name="budget"
// // //               value={formData.budget}
// // //               onChange={handleChange}
// // //               placeholder="Enter budget"
// // //               min="0"
// // //               step="0.01"
// // //               style={inputStyle}
// // //             />
// // //           </div>

// // //           {/* Progress - Hidden for new projects */}
// // //           {/* <div style={formGroupStyle}>
// // //             <label htmlFor="progress" style={labelStyle}>📈 Progress (%)</label>
// // //             <input
// // //               type="number"
// // //               id="progress"
// // //               name="progress"
// // //               value={formData.progress}
// // //               onChange={handleChange}
// // //               min="0"
// // //               max="100"
// // //               style={inputStyle}
// // //             />
// // //           </div> */}


// // //           {/* Client Information */}
// // //           <div style={formGroupStyle}>
// // //             <h3 style={{ ...labelStyle, fontSize: '1.3rem', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
// // //               Client Information
// // //             </h3>
// // //             <div style={formRowStyle}>
// // //               <div style={formGroupStyle}>
// // //                 <label htmlFor="clientName" style={labelStyle}>ï Client Name</label>
// // //                 <input
// // //                   type="text"
// // //                   id="clientName"
// // //                   name="clientName"
// // //                   value={formData.clientName}
// // //                   onChange={handleChange}
// // //                   placeholder="Enter client name"
// // //                   style={inputStyle}
// // //                 />
// // //               </div>

// // //               <div style={formGroupStyle}>
// // //                 <label htmlFor="clientCompany" style={labelStyle}>Client Company</label>
// // //                 <input
// // //                   type="text"
// // //                   id="clientCompany"
// // //                   name="clientCompany"
// // //                   value={formData.clientCompany}
// // //                   onChange={handleChange}
// // //                   placeholder="Enter client company"
// // //                   style={inputStyle}
// // //                 />
// // //               </div>
// // //             </div>

// // //             <div style={formRowStyle}>
// // //               <div style={formGroupStyle}>
// // //                 <label htmlFor="clientEmail" style={labelStyle}> Client Email</label>
// // //                 <input
// // //                   type="email"
// // //                   id="clientEmail"
// // //                   name="clientEmail"
// // //                   value={formData.clientEmail}
// // //                   onChange={handleChange}
// // //                   placeholder="client@company.com"
// // //                   style={inputStyle}
// // //                 />
// // //               </div>

// // //               <div style={formGroupStyle}>
// // //                 <label htmlFor="clientMobileNo" style={labelStyle}>📱 Client Mobile Number</label>
// // //                 <input
// // //                   type="tel"
// // //                   id="clientMobileNo"
// // //                   name="clientMobileNo"
// // //                   value={formData.clientMobileNo}
// // //                   onChange={handleChange}
// // //                   placeholder="10-digit mobile number"
// // //                   style={inputStyle}
// // //                 />
// // //               </div>
// // //             </div>

// // //             {/* Client Address Information */}
// // //             <div style={formGroupStyle}>
// // //               <label htmlFor="clientAddress" style={labelStyle}>  Client Address</label>
// // //               <textarea
// // //                 id="clientAddress"
// // //                 name="clientAddress"
// // //                 value={formData.clientAddress}
// // //                 onChange={handleChange}
// // //                 placeholder="Enter client address"
// // //                 style={{...textareaStyle, minHeight: '80px'}}
// // //               />
// // //             </div>

// // //             <div style={formRowStyle}>
// // //               <div style={formGroupStyle}>
// // //                 <label htmlFor="clientCity" style={labelStyle}>™ï Client City</label>
// // //                 <input
// // //                   type="text"
// // //                   id="clientCity"
// // //                   name="clientCity"
// // //                   value={formData.clientCity}
// // //                   onChange={handleChange}
// // //                   placeholder="Enter client city"
// // //                   style={inputStyle}
// // //                 />
// // //               </div>

// // //               <div style={formGroupStyle}>
// // //                 <label htmlFor="clientState" style={labelStyle}>—ï Client State</label>
// // //                 <input
// // //                   type="text"
// // //                   id="clientState"
// // //                   name="clientState"
// // //                   value={formData.clientState}
// // //                   onChange={handleChange}
// // //                   placeholder="Enter client state"
// // //                   style={inputStyle}
// // //                 />
// // //               </div>
// // //             </div>
// // //           </div>

// // //           {/* Custom Fields */}
// // //           <div style={formGroupStyle}>
// // //             <h3 style={{ ...labelStyle, fontSize: '1.3rem', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
// // //               š™ï Other Information
// // //             </h3>

// // //             {/* Add New Custom Field */}
// // //             <div style={{ marginBottom: '1rem' }}>
// // //               <div style={formRowStyle}>
// // //                 <div style={formGroupStyle}>
// // //                   <label style={labelStyle}>ï Name</label>
// // //                   <input
// // //                     type="text"
// // //                     value={newCustomField.key}
// // //                     onChange={(e) => handleCustomFieldChange('key', e.target.value)}
// // //                     placeholder="Enter field name"
// // //                     style={inputStyle}
// // //                   />
// // //                 </div>
// // //                 <div style={formGroupStyle}>
// // //                   <label style={labelStyle}>¡ Particular</label>
// // //                   <input
// // //                     type="text"
// // //                     value={newCustomField.value}
// // //                     onChange={(e) => handleCustomFieldChange('value', e.target.value)}
// // //                     placeholder="Enter field value"
// // //                     style={inputStyle}
// // //                   />
// // //                 </div>
// // //               </div>
// // //               <button
// // //                 type="button"
// // //                 onClick={handleAddCustomField}
// // //                 style={{
// // //                   ...btnPrimaryStyle,
// // //                   marginTop: '0.5rem',
// // //                   opacity: (!newCustomField.key.trim() || !newCustomField.value.trim()) ? 0.5 : 1,
// // //                   cursor: (!newCustomField.key.trim() || !newCustomField.value.trim()) ? 'not-allowed' : 'pointer'
// // //                 }}
// // //                 disabled={!newCustomField.key.trim() || !newCustomField.value.trim()}
// // //               >
// // //                 ž• Add Other Field
// // //               </button>
// // //             </div>

// // //             {/* Display Custom Fields */}
// // //             {formData.customFields.length > 0 && (
// // //               <div style={{ marginTop: '1rem' }}>
// // //                 <div style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.5rem' }}>
// // //                   Other Fields ({formData.customFields.length}):
// // //                 </div>
// // //                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
// // //                   {formData.customFields.map((field, index) => (
// // //                     <div key={index} style={{
// // //                       display: 'flex',
// // //                       alignItems: 'center',
// // //                       justifyContent: 'space-between',
// // //                       padding: '0.75rem',
// // //                       backgroundColor: '#f8fafc',
// // //                       border: '1px solid #e5e7eb',
// // //                       borderRadius: '0.375rem',
// // //                       gap: '1rem'
// // //                     }}>
// // //                       <div style={{ display: 'flex', gap: '1rem', flex: 1 }}>
// // //                         <div style={{ flex: 1 }}>
// // //                           <span style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500' }}>Field:</span>
// // //                           <div style={{ fontSize: '0.875rem', color: '#1f2937', fontWeight: '500' }}>{field.key}</div>
// // //                         </div>
// // //                         <div style={{ flex: 1 }}>
// // //                           <span style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500' }}>Value:</span>
// // //                           <div style={{ fontSize: '0.875rem', color: '#1f2937' }}>{field.value}</div>
// // //                         </div>
// // //                       </div>
// // //                       <button
// // //                         type="button"
// // //                         onClick={() => handleRemoveCustomField(index)}
// // //                         style={{
// // //                           background: '#ef4444',
// // //                           color: 'white',
// // //                           border: 'none',
// // //                           borderRadius: '0.25rem',
// // //                           padding: '0.25rem 0.5rem',
// // //                           cursor: 'pointer',
// // //                           fontSize: '0.75rem',
// // //                           fontWeight: '500'
// // //                         }}
// // //                       >
// // //                         ✅• Remove
// // //                       </button>
// // //                     </div>
// // //                   ))}
// // //                 </div>
// // //               </div>
// // //             )}
// // //           </div>

// // //           {/* Form Actions */}
// // //           <div style={formActionsStyle}>
// // //             <button type="button" onClick={() => onNavigate ? onNavigate('/projects', 'Projects') : navigate('/projects')} style={btnSecondaryStyle}>
// // //               Cancel
// // //             </button>
// // //             <button
// // //               type="submit"
// // //               disabled={loading}
// // //               style={{
// // //                 ...btnPrimaryStyle,
// // //                 opacity: loading ? 0.6 : 1,
// // //                 cursor: loading ? 'not-allowed' : 'pointer'
// // //               }}
// // //             >
// // //               <FolderPlus size={20} />
// // //               {loading ? 'Creating...' : 'Create Project'}
// // //             </button>
// // //           </div>
// // //         </form>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default AddProject;



// // import React, { useState, useEffect, useRef } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import { FolderPlus, ArrowLeft, Users, X, Sparkles } from 'lucide-react';
// // import { jwtDecode } from "jwt-decode";
// // import AlertBox from '../../Components/AlertBox';

// // const AddProject = ({ projects, setProjects, onNavigate }) => {
// //   const navigate = useNavigate();
// //   const [isLoaded, setIsLoaded] = useState(false);
// //   const [showAlert, setShowAlert] = useState(null);

// //   useEffect(() => {
// //     setIsLoaded(true);
// //   }, []);

// //   // ---------------- Simple Styles ----------------
// //   const addProjectStyle = {
// //     minHeight: '100vh',
// //     backgroundColor: '#f8fafc',
// //     padding: '2rem',
// //     fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
// //   };

// //   const pageHeaderStyle = {
// //     display: 'flex',
// //     justifyContent: 'space-between',
// //     alignItems: 'center',
// //     marginBottom: '2rem',
// //     padding: '1.5rem',
// //     backgroundColor: 'white',
// //     borderRadius: '0.5rem',
// //     border: '1px solid #e5e7eb',
// //     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
// //   };

// //   const headerTitleStyle = {
// //     fontSize: '1.875rem',
// //     fontWeight: 700,
// //     color: '#1f2937',
// //     margin: 0,
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '0.5rem'
// //   };

// //   const btnStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     padding: '0.5rem 1rem',
// //     border: '1px solid #d1d5db',
// //     borderRadius: '0.375rem',
// //     fontWeight: 500,
// //     cursor: 'pointer',
// //     gap: '0.5rem',
// //     transition: 'all 0.2s ease',
// //     fontSize: '0.875rem',
// //     backgroundColor: 'white'
// //   };

// //   const btnSecondaryStyle = {
// //     ...btnStyle,
// //     backgroundColor: '#6b7280',
// //     color: 'white',
// //     borderColor: '#6b7280'
// //   };

// //   const btnPrimaryStyle = {
// //     ...btnStyle,
// //     backgroundColor: '#3b82f6',
// //     color: 'white',
// //     borderColor: '#3b82f6'
// //   };

// //   const formContainerStyle = { 
// //     maxWidth: '800px', 
// //     margin: '0 auto',
// //     backgroundColor: 'white',
// //     borderRadius: '0.5rem',
// //     padding: '2rem',
// //     border: '1px solid #e5e7eb',
// //     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
// //   };
// //   const formGroupStyle = { marginBottom: '2rem' , marginRight: '1.5rem' };
// //   const labelStyle = { 
// //     display: 'block', 
// //     marginBottom: '0.5rem', 
// //     fontWeight: 500, 
// //     color: '#374151',
// //     fontSize: '0.875rem'
// //   };

// //   const requiredLabelStyle = {
// //     ...labelStyle,
// //     position: 'relative'
// //   };

// //   const requiredStarStyle = {
// //     color: '#ef4444',
// //     marginLeft: '0.25rem'
// //   };

// //   const inputStyle = {
// //     width: '100%',
// //     padding: '0.75rem',
// //     backgroundColor: 'white',
// //     border: '1px solid #d1d5db',
// //     borderRadius: '0.375rem',
// //     fontSize: '0.875rem',
// //     outline: 'none',
// //     color: '#1f2937',
// //     transition: 'border-color 0.2s ease'
// //   };

// //   const textareaStyle = { ...inputStyle, resize: 'vertical', minHeight: '100px' };
// //   const selectStyle = { ...inputStyle, cursor: 'pointer' };
// //   const formRowStyle = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' };
// //   const formActionsStyle = { display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '2rem' };

// //   const selectedEmployeesContainer = {
// //     display: 'flex',
// //     flexWrap: 'wrap',
// //     gap: '0.5rem',
// //     marginTop: '0.5rem'
// //   };

// //   const selectedEmployeeChip = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     background: '#f0f9ff',
// //     padding: '0.75rem 1rem',
// //     borderRadius: '0.5rem',
// //     fontSize: '0.9rem',
// //     gap: '0.75rem',
// //     minHeight: 'auto',
// //     border: '1px solid #bae6fd',
// //     color: '#0c4a6e',
// //     boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
// //     transition: 'all 0.2s ease'
// //   };

// //   // ---------------- States ----------------
// //   const [employees, setEmployees] = useState([]);
// //   const [departments, setDepartments] = useState([]);
// //   const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [departmentSearchTerm, setDepartmentSearchTerm] = useState('');
// //   const [showDepartmentDropdown, setShowDepartmentDropdown] = useState(false);
// //   const dropdownRef = useRef(null);
// //   const [newCustomField, setNewCustomField] = useState({ key: '', value: '' });
// //   // Status management - using API
// //   const [statusOptions, setStatusOptions] = useState([]);
// //   const [newStatus, setNewStatus] = useState('');
// //   const [showStatusForm, setShowStatusForm] = useState(false);

// //   // Function to fetch custom statuses from API
// //   const fetchCustomStatuses = async () => {
// //     try {
// //       const token = localStorage.getItem('authToken');
// //       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
// //         headers: {
// //           'Authorization': `Bearer ${token}`,
// //           'Content-Type': 'application/json'
// //         }
// //       });

// //       if (response.ok) {
// //         const statuses = await response.json();

// //         // Handle wrapped response format {statuses: Array}
// //         let statusArray = [];
// //         if (Array.isArray(statuses)) {
// //           statusArray = statuses;
// //         } else if (statuses && statuses.statuses && Array.isArray(statuses.statuses)) {
// //           statusArray = statuses.statuses;
// //         } else {
// //           console.log('AddProject - Invalid response format:', statuses);
// //           setStatusOptions([]);
// //           return;
// //         }

// //         if (statusArray.length > 0) {
// //           // Extract status names from the array
// //           const statusNames = statusArray.map(status => {
// //             // Try to get the name field
// //             if (status && typeof status === 'object' && status.name) {
// //               return status.name;
// //             }
// //             console.log('AddProject - No name field found');
// //             return null;
// //           }).filter(name => name); // Remove null values

// //           setStatusOptions(statusNames);
// //         } else {
// //           setStatusOptions([]);
// //         }
// //       } else {
// //         console.error('AddProject - API Error:', response.status);
// //         setStatusOptions([]);
// //       }
// //     } catch (error) {
// //       console.error('AddProject - Fetch Error:', error);
// //       setStatusOptions([]);
// //     }
// //   };

// //   // Fetch custom statuses on component mount
// //   useEffect(() => {
// //     fetchCustomStatuses();
// //   }, []);

// //   // Test function to create a status if none exist
// //   const createTestStatus = async () => {
// //     try {
// //       const token = localStorage.getItem('authToken');
// //       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
// //         method: 'POST',
// //         headers: {
// //           'Authorization': `Bearer ${token}`,
// //           'Content-Type': 'application/json'
// //         },
// //         body: JSON.stringify({
// //           company: COMPANY_ID,
// //           name: 'Planning'
// //         })
// //       });

// //       if (response.ok) {
// //         fetchCustomStatuses(); // Refresh the list
// //       } else {
// //       }
// //     } catch (error) {
// //       console.log('AddProject - Error creating test status:', error);
// //     }
// //   };


// //   // Utility function to format date as DD/MM/YYYY
// //   const formatDateToDDMMYYYY = (date) => {
// //     if (!date) return '';
// //     const d = new Date(date);
// //     const day = String(d.getDate()).padStart(2, '0');
// //     const month = String(d.getMonth() + 1).padStart(2, '0');
// //     const year = d.getFullYear();
// //     return `${day}/${month}/${year}`;
// //   };

// //   // Get current date in YYYY-MM-DD format for input field
// //   const getCurrentDateForInput = () => {
// //     const today = new Date();
// //     const year = today.getFullYear();
// //     const month = String(today.getMonth() + 1).padStart(2, '0');
// //     const day = String(today.getDate()).padStart(2, '0');
// //     return `${year}-${month}-${day}`;
// //   };

// //   const [formData, setFormData] = useState({
// //     company: '',
// //     title: '',
// //     description: '',
// //     status: '',
// //     startDate: getCurrentDateForInput(),
// //     dueDate: '',
// //     budget: '',
// //     progress: 0,
// //     clientName: '',
// //     clientCompany: '',
// //     clientEmail: '',
// //     clientMobileNo: '',
// //     clientAddress: '',
// //     clientCity: '',
// //     clientState: '',
// //     projectHead: '',
// //     departments: [], // Changed to array for multiple departments
// //     selectedEmployeeId: '', // for dropdown
// //     customFields: [] // Array of {key, value} objects
// //   });

// //  // Get token from localStorage
// //  const token = localStorage.getItem('authToken');

// //  let COMPANY_ID = '';
// //  if (token) {
// //    try {
// //      const decodedToken = jwtDecode(token); // Decode JWT
// //      // Handle both company and employee login types
// //      COMPANY_ID = decodedToken.role === 'company' 
// //        ? (decodedToken.companyId || decodedToken.id) 
// //        : decodedToken.companyId;
// //    } catch (err) {
// //      console.error("Error decoding token:", err);
// //    }
// //  }
// //   // ---------------- Fetch Employees ----------------
// //   useEffect(() => {
// //     const fetchEmployees = async () => {
// //       try {
// //         const token = localStorage.getItem('authToken');


// //         const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/employees/company/${COMPANY_ID}`, {
// //           headers: {
// //             'Authorization': `Bearer ${token}`,
// //             'Content-Type': 'application/json',
// //           },
// //         });

// //         if (res.ok) {
// //           const data = await res.json();

// //           // Log department-wise employee distribution
// //           if (data && data.length > 0) {  
// //             const departmentGroups = {};
// //             data.forEach(emp => {
// //               const deptId = emp.department?._id || emp.department || 'No Department';
// //               const deptName = emp.department?.name || 'Unknown Department';
// //               if (!departmentGroups[deptId]) {
// //                 departmentGroups[deptId] = { name: deptName, employees: [] };
// //               }
// //               departmentGroups[deptId].employees.push(emp);
// //             });

// //             Object.keys(departmentGroups).forEach(deptId => {
// //               const group = departmentGroups[deptId];
// //             });
// //           }

// //           setEmployees(data || []);
// //         } else {
// //           console.error('AddProject - Failed to fetch employees - Status:', res.status);

// //           // Try multiple fallback endpoints for company login
// //           let fallbackData = null;

// //           // Try general employees endpoint with auth
// //           try {
// //             const fallbackRes = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/employees', {
// //               headers: {
// //                 'Authorization': `Bearer ${token}`,
// //                 'Content-Type': 'application/json',
// //               },
// //             });
// //             if (fallbackRes.ok) {
// //               fallbackData = await fallbackRes.json();
// //             }
// //           } catch (error) {
// //             console.log("AddProject - Auth fallback failed, trying no-auth");
// //           }

// //           // Try no-auth fallback for company access
// //           if (!fallbackData) {
// //             try {
// //               const noAuthRes = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/employees');
// //               if (noAuthRes.ok) {
// //                 fallbackData = await noAuthRes.json();
// //               }
// //             } catch (error) {
// //               console.log("AddProject - No-auth fallback failed");
// //             }
// //           }

// //           setEmployees(fallbackData || []);
// //         }
// //       } catch (error) {
// //         console.error('Error fetching employees:', error);
// //         setEmployees([]);
// //       }
// //     };
// //     fetchEmployees();
// //   }, []);


// //   // ---------------- Fetch Departments ----------------
// //   useEffect(() => {
// //     const fetchDepartments = async () => {
// //       try {
// //         const token = localStorage.getItem('authToken');

// //         let departmentData = null;

// //         // First try: with company ID and auth
// //         try {
// //           const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${COMPANY_ID}`, {
// //             headers: {
// //               'Authorization': `Bearer ${token}`,
// //               'Content-Type': 'application/json',
// //             },
// //           });
// //           if (res.ok) {
// //             departmentData = await res.json();
// //           }
// //         } catch (error) {
// //           console.log("AddProject - Auth department fetch failed, trying alternatives");
// //         }

// //         // Second try: without auth for company access
// //         if (!departmentData) {
// //           try {
// //             const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${COMPANY_ID}`);
// //             if (res.ok) {
// //               departmentData = await res.json();
// //             }
// //           } catch (error) {
// //             console.log("AddProject - No-auth department fetch failed");
// //           }
// //         }

// //         // Third try: general departments endpoint
// //         if (!departmentData) {
// //           try {
// //             const res = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/departments', {
// //               headers: {
// //                 'Authorization': `Bearer ${token}`,
// //                 'Content-Type': 'application/json',
// //               },
// //             });
// //             if (res.ok) {
// //               departmentData = await res.json();
// //             }
// //           } catch (error) {
// //             console.log("AddProject - General department fetch failed");
// //           }
// //         }

// //         setDepartments(departmentData || []);
// //       } catch (error) {
// //         console.error('AddProject - Error fetching departments:', error);
// //         setDepartments([]);
// //       }
// //     };
// //     fetchDepartments();
// //   }, []);

// //   // ---------------- Click Outside Handler ----------------
// //   useEffect(() => {
// //     const handleClickOutside = (event) => {
// //       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
// //         setShowDepartmentDropdown(false);
// //       }
// //     };

// //     document.addEventListener('mousedown', handleClickOutside);
// //     return () => {
// //       document.removeEventListener('mousedown', handleClickOutside);
// //     };
// //   }, []);

// //   // ---------------- Validation Helpers ----------------
// //   const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
// //   const isValidPhone = (phone) => /^[6-9]\d{9}$/.test(phone);

// //   // ---------------- Computed Values ----------------
// //   // Filter departments based on search term
// //   const filteredDepartments = departments.filter(dept =>
// //     dept.name.toLowerCase().includes(departmentSearchTerm.toLowerCase())
// //   );

// //   // Group employees by department
// //   const employeesByDepartment = employees.reduce((acc, emp) => {
// //     const deptId = emp.department?._id || emp.department || 'no-department';
// //     const deptName = emp.department?.name || 'No Department';

// //     if (!acc[deptId]) {
// //       acc[deptId] = {
// //         id: deptId,
// //         name: deptName,
// //         employees: []
// //       };
// //     }
// //     acc[deptId].employees.push(emp);
// //     return acc;
// //   }, {});

// //   // Filter employees based on selected departments
// //   const filteredEmployees = employees.filter(emp => {
// //     if (!formData.departments || formData.departments.length === 0) return false; // Show none if no departments selected
// //     return formData.departments.some(deptId => 
// //       String(emp.department) === String(deptId) || 
// //       String(emp.department?._id) === String(deptId)
// //     );
// //   });

// //   // Get department-wise filtered employees for display
// //   const departmentWiseEmployees = formData.departments.reduce((acc, deptId) => {
// //     const deptEmployees = employees.filter(emp => 
// //       String(emp.department) === String(deptId) || 
// //       String(emp.department?._id) === String(deptId)
// //     );

// //     if (deptEmployees.length > 0) {
// //       const dept = departments.find(d => d._id === deptId);
// //       acc[deptId] = {
// //         name: dept?.name || 'Unknown Department',
// //         employees: deptEmployees
// //       };
// //     }
// //     return acc;
// //   }, {});

// //   // ---------------- Handlers ----------------
// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData((prev) => ({ ...prev, [name]: value }));
// //   };

// //   const handleDepartmentToggle = (departmentId) => {
// //     const id = typeof departmentId === "object" ? departmentId._id : departmentId;

// //     setFormData(prev => {
// //       const isSelected = prev.departments.includes(id);
// //       const updatedDepartments = isSelected
// //         ? prev.departments.filter(depId => depId !== id)
// //         : [...prev.departments, id];

// //       return {
// //         ...prev,
// //         departments: updatedDepartments,
// //         selectedEmployeeId: ''
// //       };
// //     });

// //     setSelectedTeamMembers([]); // Clear team members when departments change
// //   };



// //   const handleAddTeamMember = () => {
// //     const selectedEmployee = employees.find(emp => emp._id === formData.selectedEmployeeId);
// //     if (selectedEmployee && !selectedTeamMembers.some(member => member._id === selectedEmployee._id)) {
// //       setSelectedTeamMembers(prev => [...prev, selectedEmployee]);
// //     }
// //     setFormData(prev => ({ ...prev, selectedEmployeeId: '' })); // reset dropdown
// //   };

// //   const handleRemoveTeamMember = (id) => {
// //     setSelectedTeamMembers(prev => prev.filter(member => member._id !== id));
// //   };

// //   // Custom Fields Handlers
// //   const handleAddCustomField = () => {
// //     if (newCustomField.key.trim() && newCustomField.value.trim()) {
// //       setFormData(prev => ({
// //         ...prev,
// //         customFields: [...prev.customFields, { ...newCustomField }]
// //       }));
// //       setNewCustomField({ key: '', value: '' });
// //     }
// //   };

// //   const handleRemoveCustomField = (index) => {
// //     setFormData(prev => ({
// //       ...prev,
// //       customFields: prev.customFields.filter((_, i) => i !== index)
// //     }));
// //   };

// //   const handleCustomFieldChange = (field, value) => {
// //     setNewCustomField(prev => ({ ...prev, [field]: value }));
// //   };

// //   // Add single status to the dropdown list using API
// //   const handleAddStatus = async () => {
// //     const label = (newStatus || '').trim();
// //     if (!label) return;

// //     const exists = statusOptions.some(s => s.toLowerCase() === label.toLowerCase());
// //     if (exists) {
// //       setShowAlert('This status already exists in your local list!');
// //       setNewStatus('');
// //       return;
// //     }

// //     try {
// //       const token = localStorage.getItem('authToken');
// //       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
// //         method: 'POST',
// //         headers: {
// //           'Authorization': `Bearer ${token}`,
// //           'Content-Type': 'application/json'
// //         },
// //         body: JSON.stringify({
// //           company: COMPANY_ID,
// //           name: label
// //         })
// //       });

// //       if (response.ok) {
// //         const newStatus = await response.json();

// //         // Refresh the status list from server to ensure we have latest data
// //         await fetchCustomStatuses();

// //         // Set the new status as selected
// //         setFormData(prev => ({ ...prev, status: label }));

// //         setNewStatus('');
// //         // Keep modal open so user can add more statuses
// //         // setShowStatusForm(false);
// //         setShowAlert(`Status "${label}" added successfully! You can add more statuses or close the modal.`);
// //       } else {
// //         const errorData = await response.json().catch(() => ({}));
// //         console.error('AddProject - Failed to create status:', errorData);

// //         // Handle specific error messages from server
// //         if (errorData.message && errorData.message.includes('unique')) {
// //           setShowAlert(`Status "${label}" already exists for your company. Please choose a different name.`);
// //         } else {
// //           setShowAlert(`Failed to create status: ${errorData.message || 'Please try again.'}`);
// //         }

// //         setNewStatus('');
// //       }
// //     } catch (error) {
// //       console.error('AddProject - Error creating status:', error);
// //       setShowAlert('Error creating status. Please check your connection and try again.');
// //       setNewStatus('');
// //     }
// //   };

// //   // Open status form
// //   const handleOpenStatusForm = () => {
// //     setShowStatusForm(true);
// //   };

// //   // Close status form
// //   const handleCloseStatusForm = () => {
// //     setShowStatusForm(false);
// //     setNewStatus('');
// //   };

// //   // Remove a status from the list (local only - for project-specific use)
// //   const handleRemoveStatus = (statusToRemove) => {
// //     const updated = statusOptions.filter(status => status !== statusToRemove);
// //     setStatusOptions(updated);
// //     // Note: Status options are project-specific and not saved globally

// //     // If the removed status was selected, change to the first remaining status or empty
// //     if (formData.status === statusToRemove) {
// //       setFormData(prev => ({ ...prev, status: updated.length > 0 ? updated[0] : '' }));
// //     }
// //   };

// //   // Delete a status from MongoDB database
// //   const handleDeleteStatus = async (statusToDelete) => {
// //     try {
// //       const token = localStorage.getItem('authToken');

// //       // First, find the status ID from the API to delete it
// //       const fetchResponse = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
// //         headers: {
// //           'Authorization': `Bearer ${token}`,
// //           'Content-Type': 'application/json'
// //         }
// //       });

// //       if (!fetchResponse.ok) {
// //         throw new Error('Failed to fetch statuses for deletion');
// //       }

// //       const statuses = await fetchResponse.json();
// //       let statusArray = [];

// //       // Handle wrapped response format
// //       if (Array.isArray(statuses)) {
// //         statusArray = statuses;
// //       } else if (statuses && statuses.statuses && Array.isArray(statuses.statuses)) {
// //         statusArray = statuses.statuses;
// //       }

// //       // Find the status object to get its ID
// //       const statusToDeleteObj = statusArray.find(status => status.name === statusToDelete);

// //       if (!statusToDeleteObj) {
// //         setShowAlert(`Status "${statusToDelete}" not found in database.`);
// //         return;
// //       }

// //       // Make DELETE request to remove from MongoDB
// //       const deleteResponse = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/${statusToDeleteObj._id}`, {
// //         method: 'DELETE',
// //         headers: {
// //           'Authorization': `Bearer ${token}`,
// //           'Content-Type': 'application/json'
// //         }
// //       });

// //       if (deleteResponse.ok) {

// //         // Refresh the status list from server
// //         await fetchCustomStatuses();

// //         // If the deleted status was selected, change to the first remaining status or empty
// //         if (formData.status === statusToDelete) {
// //           const updatedOptions = statusOptions.filter(status => status !== statusToDelete);
// //           setFormData(prev => ({ ...prev, status: updatedOptions.length > 0 ? updatedOptions[0] : '' }));
// //         }

// //         setShowAlert(`Status "${statusToDelete}" deleted successfully from database!`);
// //       } else {
// //         const errorData = await deleteResponse.json().catch(() => ({}));
// //         console.error('AddProject - Failed to delete status:', errorData);
// //         setShowAlert(`Failed to delete status: ${errorData.message || 'Please try again.'}`);
// //       }
// //     } catch (error) {
// //       console.error('AddProject - Error deleting status:', error);
// //       setShowAlert('Error deleting status from database. Please check your connection and try again.');
// //     }
// //   };


// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     // Validation
// //     if (!formData.title || !formData.startDate || !formData.dueDate || formData.departments.length === 0) {
// //       setShowAlert('Please fill in all required fields (Title, Start Date, Due Date, Departments)');
// //       return;
// //     }
// //     if (statusOptions.length === 0 || !formData.status) {
// //       setShowAlert('Please add at least one status and select it for the project.');
// //       return;
// //     }

// //     // Client Information Validation
// //     if (!formData.clientName) {
// //       setShowAlert('Please enter Client Name');
// //       return;
// //     }
// //     if (!formData.clientCompany) {
// //       setShowAlert('Please enter Client Company');
// //       return;
// //     }
// //     if (!formData.clientEmail) {
// //       setShowAlert('Please enter Client Email');
// //       return;
// //     }
// //     if (!formData.clientMobileNo) {
// //       setShowAlert('Please enter Client Mobile Number');
// //       return;
// //     }

// //     if (formData.clientEmail && !isValidEmail(formData.clientEmail)) {
// //       setShowAlert('Please enter a valid email address.');
// //       return;
// //     }
// //     if (formData.clientMobileNo && !isValidPhone(formData.clientMobileNo)) {
// //       setShowAlert('Please enter a valid 10-digit mobile number.');
// //       return;
// //     }

// //     setLoading(true);

// //     try {
// //       const token = localStorage.getItem('authToken'); // or wherever you store your token

// //       const projectData = {
// //         company: formData.company || COMPANY_ID,
// //         title: formData.title,
// //         description: formData.description,
// //         status: formData.status,
// //         startDate: formData.startDate,
// //         dueDate: formData.dueDate,
// //         budget: formData.budget ? parseFloat(formData.budget) : 0,
// //         progress: parseInt(formData.progress) || 0,
// //         teamMembers: selectedTeamMembers.map((emp) => emp._id),
// //         projectHead: formData.projectHead || null,
// //         clientName: formData.clientName,
// //         clientCompany: formData.clientCompany,
// //         clientEmail: formData.clientEmail,
// //         clientMobileNo: formData.clientMobileNo,
// //         clientAddress: formData.clientAddress,
// //         clientCity: formData.clientCity,
// //         clientState: formData.clientState,
// //         department: formData.departments,
// //         customFields: formData.customFields,
// //         statusOptions: statusOptions, // Save custom statuses with project
// //       };

// //       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/projectsmgnt', {
// //         method: 'POST',
// //         headers: { 
// //           'Content-Type': 'application/json',
// //           'Authorization': `Bearer ${token}`  // <-- Add this header
// //         },
// //         body: JSON.stringify(projectData)
// //       });

// //       if (response.ok) {
// //         const savedProject = await response.json();
// //         // setProjects([...projects, savedProject]);

// //         // Trigger refresh of ProjectList and ProjectTracker components
// //         if (window.refreshProjects) {
// //           await window.refreshProjects();
// //         }

// //         // Also refresh ProjectTracker if available
// //         if (window.refreshProjectTracker) {
// //           await window.refreshProjectTracker();
// //         }

// //         // Add small delay before navigation to ensure refresh completes
// //         setTimeout(() => {
// //           if (onNavigate) {
// //             onNavigate('/projects', 'Projects');
// //           } else {
// //             navigate('/projects');
// //           }
// //         }, 500);
// //       } else {
// //         const errorData = await response.json();
// //         setShowAlert(`Error creating project: ${errorData.message || 'Unknown error'}`);
// //       }
// //     } catch (error) {
// //       console.error('Error creating project:', error);
// //       setShowAlert('Error creating project. Please try again.');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };


// //   // ---------------- UI ----------------
// //   return (
// //     <div style={addProjectStyle}>
// //       <div style={pageHeaderStyle}>
// //         <button onClick={() => onNavigate ? onNavigate('/projects', 'Projects') : navigate('/projects')} style={btnSecondaryStyle}>
// //           <ArrowLeft size={20} />
// //           Back to Projects
// //         </button>
// //         <h1 style={headerTitleStyle}>
// //           <Sparkles size={32} style={{ color: '#f093fb' }} />
// //           Create New Project
// //         </h1>
// //       </div>

// //       <div style={formContainerStyle}>
// //         <form onSubmit={handleSubmit}>
// //           {/* Title */}
// //           <div style={formGroupStyle}>
// //             <label htmlFor="title" style={requiredLabelStyle}>
// //               📋 Project Title <span style={requiredStarStyle}>*</span>
// //             </label>
// //             <input
// //               type="text"
// //               id="title"
// //               name="title"
// //               value={formData.title}
// //               onChange={handleChange}
// //               placeholder="Enter project title"
// //               required
// //               style={{
// //                 ...inputStyle,
// //                 '::placeholder': { color: 'rgba(255, 255, 255, 0.6)' }
// //               }}
// //             />
// //           </div>

// //           {/* Departments - Searchable Dropdown with Multiple Selection */}
// //           <div style={formGroupStyle}>
// //             <label style={requiredLabelStyle}>
// //               Departments <span style={requiredStarStyle}>*</span>
// //               {formData.departments.length > 0 && (
// //                 <span style={{ 
// //                   fontSize: '0.75rem', 
// //                   color: '#6b7280', 
// //                   fontWeight: 'normal',
// //                   marginLeft: '0.5rem',
// //                   padding: '0.25rem 0.5rem',
// //                   backgroundColor: '#f3f4f6',
// //                   borderRadius: '0.375rem',
// //                   border: '1px solid #d1d5db'
// //                 }}>
// //                   {formData.departments.length} selected
// //                 </span>
// //               )}
// //             </label>

// //             {/* Search Input with Dropdown Toggle */}
// //             <div style={{ position: 'relative' }} ref={dropdownRef}>
// //               <div style={{ display: 'flex', alignItems: 'center' }}>
// //                 <input
// //                   type="text"
// //                   placeholder="Search departments..."
// //                   value={departmentSearchTerm}
// //                   onChange={(e) => setDepartmentSearchTerm(e.target.value)}
// //                   onFocus={() => setShowDepartmentDropdown(true)}
// //                   style={{
// //                     ...inputStyle,
// //                     paddingRight: '2.5rem'
// //                   }}
// //                 />
// //                 <button
// //                   type="button"
// //                   onClick={() => setShowDepartmentDropdown(!showDepartmentDropdown)}
// //                   style={{
// //                     position: 'absolute',
// //                     right: '0.5rem',
// //                     background: 'none',
// //                     border: 'none',
// //                     cursor: 'pointer',
// //                     padding: '0.25rem',
// //                     color: '#6b7280',
// //                     fontSize: '1rem'
// //                   }}
// //                 >
// //                   {showDepartmentDropdown ? '–' : '–'}
// //                 </button>
// //               </div>

// //               {/* Dropdown List */}
// //               {showDepartmentDropdown && (
// //                 <div style={{
// //                   position: 'absolute',
// //                   top: '100%',
// //                   left: 0,
// //                   right: 0,
// //                   backgroundColor: 'white',
// //                   border: '1px solid #d1d5db',
// //                   borderRadius: '0.375rem',
// //                   boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
// //                   zIndex: 1000,
// //                   maxHeight: '200px',
// //                   overflowY: 'auto'
// //                 }}>
// //                   {filteredDepartments.length > 0 ? (
// //                     filteredDepartments.map((dept) => (
// //                       <div
// //                         key={dept._id}
// //                         onClick={() => handleDepartmentToggle(dept._id)}
// //                         style={{
// //                           padding: '0.75rem',
// //                           cursor: 'pointer',
// //                           backgroundColor: formData.departments.includes(dept._id) ? '#f0f9ff' : 'white',
// //                           borderBottom: '1px solid #f3f4f6',
// //                           display: 'flex',
// //                           alignItems: 'center',
// //                           gap: '0.5rem',
// //                           transition: 'background-color 0.2s ease'
// //                         }}
// //                         onMouseEnter={(e) => {
// //                           if (!formData.departments.includes(dept._id)) {
// //                             e.target.style.backgroundColor = '#f9fafb';
// //                           }
// //                         }}
// //                         onMouseLeave={(e) => {
// //                           if (!formData.departments.includes(dept._id)) {
// //                             e.target.style.backgroundColor = 'white';
// //                           }
// //                         }}
// //                       >
// //                         <input
// //                           type="checkbox"
// //                           checked={formData.departments.includes(dept._id)}
// //                           onChange={() => {}}
// //                           style={{ cursor: 'pointer' }}
// //                         />
// //                         <span style={{
// //                           fontSize: '0.875rem',
// //                           color: formData.departments.includes(dept._id) ? '#0c4a6e' : '#374151',
// //                           fontWeight: formData.departments.includes(dept._id) ? '500' : 'normal'
// //                         }}>
// //                           {dept.name}
// //                         </span>
// //                       </div>
// //                     ))
// //                   ) : (
// //                     <div style={{
// //                       padding: '0.75rem',
// //                       textAlign: 'center',
// //                       color: '#6b7280',
// //                       fontSize: '0.875rem'
// //                     }}>
// //                       {departmentSearchTerm ? 'No departments found' : 'No departments available'}
// //                     </div>
// //                   )}
// //                 </div>
// //               )}
// //             </div>

// //             {/* Selected Departments Display */}
// //             {formData.departments.length > 0 && (
// //               <div style={{ marginTop: '0.75rem' }}>
// //                 <div style={{ fontSize: '0.75rem', color: '#6b7280', marginBottom: '0.5rem' }}>
// //                   Selected Departments:
// //                 </div>
// //                 <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
// //                   {formData.departments.map(deptId => {
// //                      const id = typeof deptId === "object" ? deptId._id : deptId;
// //                      const dept = departments.find(d => String(d._id) === String(id));
// //                     return dept ? (
// //                       <span key={deptId} style={{
// //                         fontSize: '0.75rem',
// //                         padding: '0.25rem 0.5rem',
// //                         backgroundColor: '#e0f2fe',
// //                         color: '#0c4a6e',
// //                         borderRadius: '0.375rem',
// //                         border: '1px solid #bae6fd',
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         gap: '0.25rem'
// //                       }}>
// //                         {dept.name}
// //                         <button
// //                           type="button"
// //                           onClick={() => handleDepartmentToggle(deptId)}
// //                           style={{
// //                             background: 'none',
// //                             border: 'none',
// //                             color: '#0c4a6e',
// //                             cursor: 'pointer',
// //                             padding: '0',
// //                             fontSize: '0.75rem',
// //                             fontWeight: 'bold'
// //                           }}
// //                         >
// //                           ×
// //                         </button>
// //                       </span>
// //                     ) : null;
// //                   })}
// //                 </div>
// //               </div>
// //             )}
// //           </div>

// //           {/* Team Members - Dropdown */}
// //           <div style={formGroupStyle}>
// //             {(() => {

// //               // Filter employees based on selected departments
// //               const filteredEmployees = employees.filter(emp => {
// //                   if (!emp.isActive) return false;
// //                 if (formData.departments.length === 0) return false;

// //                 // Handle different department formats
// //                 let empDeptIds = [];

// //                 if (emp.department) {
// //                   if (Array.isArray(emp.department)) {
// //                     // Employee department is an array of department IDs
// //                     empDeptIds = emp.department.map(dept => {
// //                       if (typeof dept === 'object') {
// //                         return dept._id || dept.id;
// //                       }
// //                       return dept;
// //                     }).filter(Boolean);
// //                   } else if (typeof emp.department === 'object') {
// //                     // Employee department is a single object
// //                     const deptId = emp.department._id || emp.department.id;
// //                     if (deptId) empDeptIds = [deptId];
// //                   } else if (typeof emp.department === 'string') {
// //                     // Employee department is a single string ID
// //                     empDeptIds = [emp.department];
// //                   }
// //                 }

// //                 // Check if any of employee's departments match any selected department
// //                 const matches = empDeptIds.length > 0 && empDeptIds.some(empDeptId => 
// //                   formData.departments.some(selectedDeptId => 
// //                     String(empDeptId) === String(selectedDeptId)
// //                   )
// //                 );

// //                 return matches;
// //               });



// //               // Group employees by department for better display
// //               const departmentWiseEmployees = {};
// //               filteredEmployees.forEach(emp => {
// //                 // Handle employees with multiple departments
// //                 if (Array.isArray(emp.department)) {
// //                   emp.department.forEach(dept => {
// //                     let deptId, deptName;

// //                     if (typeof dept === 'object') {
// //                       deptId = dept._id || dept.id;
// //                       deptName = dept.name || dept.departmentName;
// //                     } else {
// //                       deptId = dept;
// //                       // Find department name from departments array
// //                       const foundDept = departments.find(d => String(d._id) === String(dept));
// //                       deptName = foundDept?.name || foundDept?.departmentName || `Department ${dept}`;
// //                     }

// //                     // Only group if this department is selected
// //                     if (formData.departments.includes(deptId)) {
// //                       if (!departmentWiseEmployees[deptId]) {
// //                         departmentWiseEmployees[deptId] = {
// //                           name: deptName,
// //                           employees: []
// //                         };
// //                       }

// //                       // Avoid duplicate employees in same department
// //                       if (!departmentWiseEmployees[deptId].employees.find(e => e._id === emp._id)) {
// //                         departmentWiseEmployees[deptId].employees.push(emp);
// //                       }
// //                     }
// //                   });
// //                 } else {
// //                   // Handle single department
// //                   let deptId, deptName;

// //                   if (typeof emp.department === 'object') {
// //                     deptId = emp.department._id || emp.department.id;
// //                     deptName = emp.department.name || emp.department.departmentName;
// //                   } else {
// //                     deptId = emp.department;
// //                     const foundDept = departments.find(d => String(d._id) === String(emp.department));
// //                     deptName = foundDept?.name || foundDept?.departmentName || `Department ${emp.department}`;
// //                   }

// //                   if (!departmentWiseEmployees[deptId]) {
// //                     departmentWiseEmployees[deptId] = {
// //                       name: deptName,
// //                       employees: []
// //                     };
// //                   }
// //                   departmentWiseEmployees[deptId].employees.push(emp);
// //                 }
// //               });

// //               return (
// //                 <>
// //                   <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
// //                     <Users size={20} /> Assign Team Members
// //                     {formData.departments.length > 0 && (
// //                       <span style={{ 
// //                         fontSize: '0.75rem', 
// //                         color: '#6b7280', 
// //                         fontWeight: 'normal',
// //                         marginLeft: '0.5rem',
// //                         padding: '0.25rem 0.5rem',
// //                         backgroundColor: '#f3f4f6',
// //                         borderRadius: '0.375rem',
// //                         border: '1px solid #d1d5db'
// //                       }}>
// //                         {filteredEmployees.length} employee{filteredEmployees.length !== 1 ? 's' : ''} available
// //                       </span>
// //                     )}
// //                   </label>
// //             <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
// //               <select
// //                 value={formData.selectedEmployeeId}
// //                 onChange={handleChange}
// //                 name="selectedEmployeeId"
// //                 style={selectStyle}
// //                 disabled={formData.departments.length === 0}
// //               >
// //                 <option value="">
// //                   {formData.departments.length === 0
// //                     ? "Select departments first" 
// //                     : filteredEmployees.length === 0 
// //                       ? "No employees in selected departments"
// //                       : "Select a team member"
// //                   }
// //                 </option>
// //                 {Object.keys(departmentWiseEmployees).map(deptId => {
// //                   const deptGroup = departmentWiseEmployees[deptId];
// //                   return [
// //                     <option key={`dept-${deptId}`} disabled style={{ fontWeight: 'bold', backgroundColor: '#f3f4f6' }}>
// //                       {deptGroup.name} ({deptGroup.employees.length} employees) // //                     </option>,
// //                     ...deptGroup.employees.map(emp => (
// //                       <option key={emp._id} value={emp._id} style={{ paddingLeft: '1rem' }}>
// //                         &nbsp;&nbsp;&nbsp;&nbsp;{emp.teamMemberName || emp.name || 'Unnamed'} - {emp.role || 'No Position'}
// //                       </option>
// //                     ))
// //                   ];
// //                 }).flat()}
// //               </select>
// //               <button
// //                 type="button"
// //                 onClick={handleAddTeamMember}
// //                 style={{ 
// //                   ...btnPrimaryStyle, 
// //                   padding: '0.5rem 1rem',
// //                   opacity: formData.departments.length === 0 || filteredEmployees.length === 0 ? 0.5 : 1,
// //                   cursor: formData.departments.length === 0 || filteredEmployees.length === 0 ? 'not-allowed' : 'pointer'
// //                 }}
// //                 disabled={formData.departments.length === 0 || filteredEmployees.length === 0}
// //               >
// //                 Add
// //               </button>
// //             </div>

// //                   {/* Selected Members */}
// //                   {selectedTeamMembers.length > 0 && (
// //                     <div style={selectedEmployeesContainer}>
// //                       {selectedTeamMembers.map((member) => (
// //                         <div key={member._id} style={selectedEmployeeChip}>
// //                           <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
// //                             <span style={{ fontWeight: '500' }}>
// //                               {member.teamMemberName || member.name || 'Unnamed'}
// //                             </span>
// //                             <span style={{ fontSize: '0.75rem', color: '#64748b', fontStyle: 'italic' }}>
// //                               {member.role || 'No Position'}
// //                             </span>
// //                           </div>
// //                           <X
// //                             size={14}
// //                             style={{ cursor: 'pointer', marginLeft: '0.5rem' }}
// //                             onClick={() => handleRemoveTeamMember(member._id)}
// //                           />
// //                         </div>
// //                       ))}
// //                     </div>
// //                   )}
// //                 </>
// //               );
// //             })()}
// //           </div>

// //           {/* Project Head */}
// //      <div style={formGroupStyle}>
// //   <label htmlFor="projectHead" style={labelStyle}>💼 Project Head</label>
// //   <select
// //     id="projectHead"
// //     name="projectHead"
// //     value={formData.projectHead}
// //     onChange={handleChange}
// //     style={selectStyle}
// //   >
// //     <option value="">Select Project Head</option>
// //     {employees
// //       .filter(emp => emp.isActive)  // Filter only active employees
// //       .map(emp => (
// //         <option key={emp._id} value={emp._id}>
// //           {emp.teamMemberName || emp.name || 'Unnamed'} - {emp.role || 'No Position'}
// //         </option>
// //     ))}
// //   </select>
// // </div>

// //           {/* Description */}
// //           <div style={formGroupStyle}>
// //             <label htmlFor="description" style={labelStyle}> Description</label>
// //             <textarea
// //               id="description"
// //               name="description"
// //               value={formData.description}
// //               onChange={handleChange}
// //               placeholder="Project description..."
// //               style={textareaStyle}
// //             />
// //           </div>

// //           {/* Status */}
// //           <div style={formGroupStyle}>
// //             <label htmlFor="status" style={requiredLabelStyle}>
// //               📊 Status <span style={requiredStarStyle}>*</span>
// //             </label>
// //             <select
// //               id="status"
// //               name="status"
// //               value={formData.status}
// //               onChange={handleChange}
// //               style={selectStyle}
// //               required
// //             >
// //               <option value="">-- Select Status (Add statuses first) --</option>
// //               {statusOptions.map(opt => (
// //                 <option key={opt} value={opt}>{opt}</option>
// //               ))}
// //             </select>
// //             {/* Add Status Button */}
// //             <div style={{ marginTop: '0.75rem' }}>
// //               <button
// //                 type="button"
// //                 onClick={handleOpenStatusForm}
// //                 style={{
// //                   ...btnPrimaryStyle,
// //                   whiteSpace: 'nowrap'
// //                 }}
// //               >
// //                 ž• Add & Manage Statuses
// //               </button>
// //             </div>

// //             {/* Status Form Modal */}
// //             {showStatusForm && (
// //               <div style={{
// //                 position: 'fixed',
// //                 top: 0,
// //                 left: 0,
// //                 right: 0,
// //                 bottom: 0,
// //                 backgroundColor: 'rgba(0, 0, 0, 0.5)',
// //                 display: 'flex',
// //                 justifyContent: 'center',
// //                 alignItems: 'center',
// //                 zIndex: 1000
// //               }}>
// //                 <div style={{
// //                   backgroundColor: 'white',
// //                   borderRadius: '1rem',
// //                   padding: '2rem',
// //                   width: '400px',
// //                   maxWidth: '90vw',
// //                   boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
// //                 }}>
// //                   <h3 style={{
// //                     margin: '0 0 1.5rem 0',
// //                     fontSize: '1.5rem',
// //                     fontWeight: 600,
// //                     color: '#1f2937',
// //                     textAlign: 'center'
// //                   }}>
// //                     📊 Add & Manage Statuses
// //                   </h3>

// //                   <div style={{ marginBottom: '1.5rem' }}>
// //                     <div style={{ marginBottom: '1rem' }}>
// //                       <label style={{
// //                         display: 'block',
// //                         marginBottom: '0.5rem',
// //                         fontWeight: 500,
// //                         color: '#374151',
// //                         fontSize: '0.875rem'
// //                       }}>
// //                         Status Name *
// //                       </label>
// //                       <input
// //                         type="text"
// //                         value={newStatus}
// //                         onChange={(e) => setNewStatus(e.target.value)}
// //                         placeholder="Enter status name (e.g., On Hold, Under Review, Testing)"
// //                         style={{
// //                           ...inputStyle,
// //                           marginBottom: '0.5rem'
// //                         }}
// //                         autoFocus
// //                       />
// //                     </div>

// //                     {/* Show current status count */}
// //                     <div style={{
// //                       padding: '0.75rem',
// //                       backgroundColor: '#f0f9ff',
// //                       borderRadius: '0.5rem',
// //                       border: '1px solid #bae6fd',
// //                       marginBottom: '0.5rem'
// //                     }}>
// //                       <div style={{
// //                         fontSize: '0.75rem',
// //                         color: '#0c4a6e',
// //                         fontWeight: 500,
// //                         marginBottom: '0.25rem'
// //                       }}>
// //                         📊 Current Status Count: {statusOptions.length}
// //                       </div>
// //                       <div style={{
// //                         fontSize: '0.875rem',
// //                         color: '#1f2937'
// //                       }}>
// //                         {newStatus.trim() ? (
// //                           <span>
// //                             Adding: <span style={{ 
// //                               padding: '0.25rem 0.5rem', 
// //                               backgroundColor: '#dbeafe', 
// //                               borderRadius: '0.25rem',
// //                               fontWeight: '500'
// //                             }}>
// //                               {newStatus.trim()}
// //                             </span>
// //                             <span style={{ color: '#6b7280', marginLeft: '0.5rem' }}>†Total will be {statusOptions.length + 1}</span>
// //                           </span>
// //                         ) : (
// //                           <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>Enter status name to add</span>
// //                         )}
// //                       </div>
// //                     </div>

// //                     <div style={{
// //                       fontSize: '0.75rem',
// //                       color: '#6b7280',
// //                       fontStyle: 'italic'
// //                     }}>
// //                       Examples: On Hold, Under Review, Testing, Cancelled, Paused, Approved
// //                     </div>

// //                     <div style={{
// //                       fontSize: '0.75rem',
// //                       color: '#059669',
// //                       fontWeight: '500',
// //                       marginTop: '0.5rem',
// //                       padding: '0.5rem',
// //                       backgroundColor: '#ecfdf5',
// //                       borderRadius: '0.375rem',
// //                       border: '1px solid #a7f3d0'
// //                     }}>
// //                       ¡ Tip: Add multiple statuses one by one. The modal will stay open until you click "Cancel".
// //                     </div>
// //                   </div>

// //                   {/* Existing Statuses Management */}
// //                   {statusOptions.length > 0 && (
// //                     <div style={{ marginBottom: '1.5rem' }}>
// //                       <div style={{
// //                         fontSize: '0.875rem',
// //                         fontWeight: 600,
// //                         color: '#374151',
// //                         marginBottom: '0.75rem',
// //                         borderBottom: '1px solid #e5e7eb',
// //                         paddingBottom: '0.5rem'
// //                       }}>
// //                         —ï Existing Statuses ({statusOptions.length})
// //                       </div>

// //                       <div style={{
// //                         display: 'flex',
// //                         flexDirection: 'column',
// //                         gap: '0.5rem',
// //                         maxHeight: '200px',
// //                         overflowY: 'auto',
// //                         padding: '0.5rem',
// //                         backgroundColor: '#f8fafc',
// //                         borderRadius: '0.5rem',
// //                         border: '1px solid #e5e7eb'
// //                       }}>
// //                         {statusOptions.map((status, index) => (
// //                           <div key={index} style={{
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'space-between',
// //                             padding: '0.5rem 0.75rem',
// //                             backgroundColor: 'white',
// //                             border: '1px solid #e5e7eb',
// //                             borderRadius: '0.375rem'
// //                           }}>
// //                             <span style={{
// //                               fontSize: '0.875rem',
// //                               fontWeight: '500',
// //                               color: '#1f2937'
// //                             }}>
// //                               {status}
// //                             </span>

// //                             <button
// //                               type="button"
// //                               onClick={() => {
// //                                 if (window.confirm(`Delete "${status}" from database? This action cannot be undone.`)) {
// //                                   handleDeleteStatus(status);
// //                                 }
// //                               }}
// //                               style={{
// //                                 backgroundColor: '#ef4444',
// //                                 color: 'white',
// //                                 border: 'none',
// //                                 borderRadius: '0.25rem',
// //                                 padding: '0.25rem 0.5rem',
// //                                 cursor: 'pointer',
// //                                 fontSize: '0.75rem',
// //                                 fontWeight: '500'
// //                               }}
// //                               onMouseEnter={(e) => {
// //                                 e.target.style.backgroundColor = '#dc2626';
// //                               }}
// //                               onMouseLeave={(e) => {
// //                                 e.target.style.backgroundColor = '#ef4444';
// //                               }}
// //                             >
// //                               —ï Delete
// //                             </button>
// //                           </div>
// //                         ))}
// //                       </div>
// //                     </div>
// //                   )}

// //                   <div style={{
// //                     display: 'flex',
// //                     gap: '1rem',
// //                     justifyContent: 'flex-end'
// //                   }}>
// //                     <button
// //                       type="button"
// //                       onClick={handleCloseStatusForm}
// //                       style={{
// //                         ...btnSecondaryStyle,
// //                         padding: '0.75rem 1.5rem'
// //                       }}
// //                     >
// //                       Cancel
// //                     </button>
// //                     <button
// //                       type="button"
// //                       onClick={handleAddStatus}
// //                       style={{
// //                         ...btnPrimaryStyle,
// //                         padding: '0.75rem 1.5rem',
// //                         opacity: (newStatus || '').trim() ? 1 : 0.5,
// //                         cursor: (newStatus || '').trim() ? 'pointer' : 'not-allowed'
// //                       }}
// //                       disabled={!(newStatus || '').trim()}
// //                     >
// //                       ž• Add This Status
// //                     </button>
// //                   </div>
// //                 </div>
// //               </div>
// //             )}

// //           </div>

// //           {/* Start Date & Due Date */}
// //           <div style={formRowStyle}>
// //             <div style={formGroupStyle}>
// //               <label htmlFor="startDate" style={requiredLabelStyle}>
// //                 … Start Date <span style={requiredStarStyle}>*</span>
// //               </label>
// //               <input
// //                 type="date"
// //                 id="startDate"
// //                 name="startDate"
// //                 value={formData.startDate}
// //                 onChange={handleChange}
// //                 required
// //                 style={inputStyle}
// //               />
// //             </div>

// //             <div style={formGroupStyle}>
// //               <label htmlFor="dueDate" style={requiredLabelStyle}>
// //                  Due Date <span style={requiredStarStyle}>*</span>
// //               </label>
// //               <input
// //                 type="date"
// //                 id="dueDate"
// //                 name="dueDate"
// //                 value={formData.dueDate}
// //                 onChange={handleChange}
// //                 required
// //                 style={inputStyle}
// //               />
// //             </div>
// //           </div>

// //           {/* Budget */}
// //           <div style={formGroupStyle}>
// //             <label htmlFor="budget" style={requiredLabelStyle}>💰 Budget <span style={requiredStarStyle}>*</span></label>
// //             <input
// //               type="number"
// //               id="budget"
// //               name="budget"
// //               value={formData.budget}
// //               onChange={handleChange}
// //               placeholder="Enter budget"
// //               required
// //               min="0"
// //               step="0.01"
// //               style={inputStyle}
// //             />
// //           </div>

// //           {/* Progress - Hidden for new projects */}
// //           {/* <div style={formGroupStyle}>
// //             <label htmlFor="progress" style={labelStyle}>📈 Progress (%)</label>
// //             <input
// //               type="number"
// //               id="progress"
// //               name="progress"
// //               value={formData.progress}
// //               onChange={handleChange}
// //               min="0"
// //               max="100"
// //               style={inputStyle}
// //             />
// //           </div> */}


// //           {/* Client Information */}
// //           <div style={formGroupStyle}>
// //             <h3 style={{ ...labelStyle, fontSize: '1.3rem', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
// //               Client Information
// //             </h3>
// //             <div style={formRowStyle}>
// //               <div style={formGroupStyle}>
// //                 <label htmlFor="clientName" style={requiredLabelStyle}>
// //                   ï Client Name <span style={requiredStarStyle}>*</span>
// //                 </label>
// //                 <input
// //                   type="text"
// //                   id="clientName"
// //                   name="clientName"
// //                   value={formData.clientName}
// //                   onChange={handleChange}
// //                   placeholder="Enter client name"
// //                   required
// //                   style={inputStyle}
// //                 />
// //               </div>

// //               <div style={formGroupStyle}>
// //                 <label htmlFor="clientCompany" style={requiredLabelStyle}>
// //                   Client Company <span style={requiredStarStyle}>*</span>
// //                 </label>
// //                 <input
// //                   type="text"
// //                   id="clientCompany"
// //                   name="clientCompany"
// //                   value={formData.clientCompany}
// //                   onChange={handleChange}
// //                   placeholder="Enter client company"
// //                   required
// //                   style={inputStyle}
// //                 />
// //               </div>
// //             </div>

// //             <div style={formRowStyle}>
// //               <div style={formGroupStyle}>
// //                 <label htmlFor="clientEmail" style={requiredLabelStyle}>
// //                    Client Email <span style={requiredStarStyle}>*</span>
// //                 </label>
// //                 <input
// //                   type="email"
// //                   id="clientEmail"
// //                   name="clientEmail"
// //                   value={formData.clientEmail}
// //                   onChange={handleChange}
// //                   placeholder="client@company.com"
// //                   required
// //                   style={inputStyle}
// //                 />
// //               </div>

// //               <div style={formGroupStyle}>
// //                 <label htmlFor="clientMobileNo" style={requiredLabelStyle}>
// //                   📱 Client Mobile Number <span style={requiredStarStyle}>*</span>
// //                 </label>
// //                 <input
// //                   type="tel"
// //                   id="clientMobileNo"
// //                   name="clientMobileNo"
// //                   value={formData.clientMobileNo}

// //                   onChange={handleChange}
// //                   placeholder="10-digit mobile number"
// //                   maxLength={10}
// //                   required
// //                   style={inputStyle}
// //                 />
// //               </div>
// //             </div>

// //             {/* Client Address Information */}
// //             <div style={formGroupStyle}>
// //               <label htmlFor="clientAddress" style={requiredLabelStyle}>  Client Address <span style={requiredStarStyle}>*</span></label>
// //               <textarea
// //                 id="clientAddress"
// //                 name="clientAddress"
// //                 value={formData.clientAddress}
// //                 onChange={handleChange}
// //                 placeholder="Enter client address"
// //                 required
// //                 style={{...textareaStyle, minHeight: '80px'}}
// //               />
// //             </div>

// //             <div style={formRowStyle}>
// //               <div style={formGroupStyle}>
// //                 <label htmlFor="clientCity" style={requiredLabelStyle}>™ï Client City <span style={requiredStarStyle}>*</span></label>
// //                 <input
// //                   type="text"
// //                   id="clientCity"
// //                   name="clientCity"
// //                   value={formData.clientCity}
// //                   onChange={handleChange}
// //                   placeholder="Enter client city"
// //                   required
// //                   style={inputStyle}
// //                 />
// //               </div>

// //               <div style={formGroupStyle}>
// //                 <label htmlFor="clientState" style={requiredLabelStyle}>—ï Client State <span style={requiredStarStyle}>*</span></label>
// //                 <input
// //                   type="text"
// //                   id="clientState"
// //                   name="clientState"
// //                   value={formData.clientState}
// //                   onChange={handleChange}
// //                   placeholder="Enter client state"
// //                   required
// //                   style={inputStyle}
// //                 />
// //               </div>
// //             </div>
// //           </div>

// //           {/* Custom Fields */}
// //           <div style={formGroupStyle}>
// //             <h3 style={{ ...labelStyle, fontSize: '1.3rem', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
// //               š™ï Other Information
// //             </h3>

// //             {/* Add New Custom Field */}
// //             <div style={{ marginBottom: '1rem' }}>
// //               <div style={formRowStyle}>
// //                 <div style={formGroupStyle}>
// //                   <label style={labelStyle}>ï Name</label>
// //                   <input
// //                     type="text"
// //                     value={newCustomField.key}
// //                     onChange={(e) => handleCustomFieldChange('key', e.target.value)}
// //                     placeholder="Enter field name"
// //                     style={inputStyle}
// //                   />
// //                 </div>
// //                 <div style={formGroupStyle}>
// //                   <label style={labelStyle}>¡ Particular</label>
// //                   <input
// //                     type="text"
// //                     value={newCustomField.value}
// //                     onChange={(e) => handleCustomFieldChange('value', e.target.value)}
// //                     placeholder="Enter field value"
// //                     style={inputStyle}
// //                   />
// //                 </div>
// //               </div>
// //               <button
// //                 type="button"
// //                 onClick={handleAddCustomField}
// //                 style={{
// //                   ...btnPrimaryStyle,
// //                   marginTop: '0.5rem',
// //                   opacity: (!newCustomField.key.trim() || !newCustomField.value.trim()) ? 0.5 : 1,
// //                   cursor: (!newCustomField.key.trim() || !newCustomField.value.trim()) ? 'not-allowed' : 'pointer'
// //                 }}
// //                 disabled={!newCustomField.key.trim() || !newCustomField.value.trim()}
// //               >
// //                 ž• Add Other Field
// //               </button>
// //             </div>

// //             {/* Display Custom Fields */}
// //             {formData.customFields.length > 0 && (
// //               <div style={{ marginTop: '1rem' }}>
// //                 <div style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.5rem' }}>
// //                   Other Fields ({formData.customFields.length}):
// //                 </div>
// //                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
// //                   {formData.customFields.map((field, index) => (
// //                     <div key={index} style={{
// //                       display: 'flex',
// //                       alignItems: 'center',
// //                       justifyContent: 'space-between',
// //                       padding: '0.75rem',
// //                       backgroundColor: '#f8fafc',
// //                       border: '1px solid #e5e7eb',
// //                       borderRadius: '0.375rem',
// //                       gap: '1rem'
// //                     }}>
// //                       <div style={{ display: 'flex', gap: '1rem', flex: 1 }}>
// //                         <div style={{ flex: 1 }}>
// //                           <span style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500' }}>Field:</span>
// //                           <div style={{ fontSize: '0.875rem', color: '#1f2937', fontWeight: '500' }}>{field.key}</div>
// //                         </div>
// //                         <div style={{ flex: 1 }}>
// //                           <span style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500' }}>Value:</span>
// //                           <div style={{ fontSize: '0.875rem', color: '#1f2937' }}>{field.value}</div>
// //                         </div>
// //                       </div>
// //                       <button
// //                         type="button"
// //                         onClick={() => handleRemoveCustomField(index)}
// //                         style={{
// //                           background: '#ef4444',
// //                           color: 'white',
// //                           border: 'none',
// //                           borderRadius: '0.25rem',
// //                           padding: '0.25rem 0.5rem',
// //                           cursor: 'pointer',
// //                           fontSize: '0.75rem',
// //                           fontWeight: '500'
// //                         }}
// //                       >
// //                         ✅• Remove
// //                       </button>
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>
// //             )}
// //           </div>

// //           {/* Form Actions */}
// //           <div style={formActionsStyle}>
// //             <button type="button" onClick={() => onNavigate ? onNavigate('/projects', 'Projects') : navigate('/projects')} style={btnSecondaryStyle}>
// //               Cancel
// //             </button>
// //             <button
// //               type="submit"
// //               disabled={loading}
// //               style={{
// //                 ...btnPrimaryStyle,
// //                 opacity: loading ? 0.6 : 1,
// //                 cursor: loading ? 'not-allowed' : 'pointer'
// //               }}
// //             >
// //               <FolderPlus size={20} />
// //               {loading ? 'Creating...' : 'Create Project'}
// //             </button>
// //           </div>
// //         </form>
// //       </div>
// //     </div>
// //   );
// // };

// // export default AddProject;




















// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FolderPlus, ArrowLeft, Users, X, Sparkles } from 'lucide-react';
// import { jwtDecode } from "jwt-decode";
// import AlertBox from '../../Components/AlertBox';
// const AddProject = ({ projects, setProjects, onNavigate }) => {
//   const navigate = useNavigate();
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [showAlert, setShowAlert] = useState(null);

//   useEffect(() => {
//     setIsLoaded(true);
//   }, []);

//   // ---------------- Simple Styles ----------------
//   const addProjectStyle = {
//     minHeight: '100vh',
//     backgroundColor: '#f8fafc',
//     padding: '2rem',
//     fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
//   };

//   const pageHeaderStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '2rem',
//     padding: '1.5rem',
//     backgroundColor: 'white',
//     borderRadius: '0.5rem',
//     border: '1px solid #e5e7eb',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
//   };

//   const headerTitleStyle = {
//     fontSize: '1.875rem',
//     fontWeight: 700,
//     color: '#1f2937',
//     margin: 0,
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.5rem'
//   };

//   const btnStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     padding: '0.5rem 1rem',
//     border: '1px solid #d1d5db',
//     borderRadius: '0.375rem',
//     fontWeight: 500,
//     cursor: 'pointer',
//     gap: '0.5rem',
//     transition: 'all 0.2s ease',
//     fontSize: '0.875rem',
//     backgroundColor: 'white'
//   };

//   const btnSecondaryStyle = {
//     ...btnStyle,
//     backgroundColor: '#6b7280',
//     color: 'white',
//     borderColor: '#6b7280'
//   };

//   const btnPrimaryStyle = {
//     ...btnStyle,
//     backgroundColor: '#3b82f6',
//     color: 'white',
//     borderColor: '#3b82f6'
//   };

//   const formContainerStyle = {
//     maxWidth: '800px',
//     margin: '0 auto',
//     backgroundColor: 'white',
//     borderRadius: '0.5rem',
//     padding: '2rem',
//     border: '1px solid #e5e7eb',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
//   };
//   const formGroupStyle = { marginBottom: '2rem', marginRight: '1.5rem' };
//   const labelStyle = {
//     display: 'block',
//     marginBottom: '0.5rem',
//     fontWeight: 500,
//     color: '#374151',
//     fontSize: '0.875rem'
//   };

//   const inputStyle = {
//     width: '100%',
//     padding: '0.75rem',
//     backgroundColor: 'white',
//     border: '1px solid #d1d5db',
//     borderRadius: '0.375rem',
//     fontSize: '0.875rem',
//     outline: 'none',
//     color: '#1f2937',
//     transition: 'border-color 0.2s ease'
//   };

//   const textareaStyle = { ...inputStyle, resize: 'vertical', minHeight: '100px' };
//   const selectStyle = { ...inputStyle, cursor: 'pointer' };
//   const formRowStyle = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' };
//   const formActionsStyle = { display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '2rem' };

//   const selectedEmployeesContainer = {
//     display: 'flex',
//     flexWrap: 'wrap',
//     gap: '0.5rem',
//     marginTop: '0.5rem'
//   };

//   const selectedEmployeeChip = {
//     display: 'flex',
//     alignItems: 'center',
//     background: '#f0f9ff',
//     padding: '0.75rem 1rem',
//     borderRadius: '0.5rem',
//     fontSize: '0.9rem',
//     gap: '0.75rem',
//     minHeight: 'auto',
//     border: '1px solid #bae6fd',
//     color: '#0c4a6e',
//     boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//     transition: 'all 0.2s ease'
//   };

//   // ---------------- States ----------------
//   const [employees, setEmployees] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [departmentSearchTerm, setDepartmentSearchTerm] = useState('');
//   const [showDepartmentDropdown, setShowDepartmentDropdown] = useState(false);
//   const dropdownRef = useRef(null);
//   const [newCustomField, setNewCustomField] = useState({ key: '', value: '' });
//   // Status management - using API
//   const [statusOptions, setStatusOptions] = useState([]);
//   const [newStatus, setNewStatus] = useState('');
//   const [showStatusForm, setShowStatusForm] = useState(false);

//   // Function to fetch custom statuses from API
//   const fetchCustomStatuses = async () => {
//     try {
//       const token = localStorage.getItem('authToken');
//       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (response.ok) {
//         const statuses = await response.json();

//         // Handle wrapped response format {statuses: Array}
//         let statusArray = [];
//         if (Array.isArray(statuses)) {
//           statusArray = statuses;
//         } else if (statuses && statuses.statuses && Array.isArray(statuses.statuses)) {
//           statusArray = statuses.statuses;
//         } else {
//           console.log('AddProject - Invalid response format:', statuses);
//           setStatusOptions([]);
//           return;
//         }

//         if (statusArray.length > 0) {
//           // Extract status names from the array
//           const statusNames = statusArray.map(status => {
//             // Try to get the name field
//             if (status && typeof status === 'object' && status.name) {
//               return status.name;
//             }
//             console.log('AddProject - No name field found');
//             return null;
//           }).filter(name => name); // Remove null values

//           setStatusOptions(statusNames);
//         } else {
//           setStatusOptions([]);
//         }
//       } else {
//         console.error('AddProject - API Error:', response.status);
//         setStatusOptions([]);
//       }
//     } catch (error) {
//       console.error('AddProject - Fetch Error:', error);
//       setStatusOptions([]);
//     }
//   };

//   // Fetch custom statuses on component mount
//   useEffect(() => {
//     fetchCustomStatuses();
//   }, []);

//   // Test function to create a status if none exist
//   const createTestStatus = async () => {
//     try {
//       const token = localStorage.getItem('authToken');
//       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           company: COMPANY_ID,
//           name: 'Planning'
//         })
//       });

//       if (response.ok) {
//         fetchCustomStatuses(); // Refresh the list
//       } else {
//       }
//     } catch (error) {
//       console.log('AddProject - Error creating test status:', error);
//     }
//   };


//   // Utility function to format date as DD/MM/YYYY
//   const formatDateToDDMMYYYY = (date) => {
//     if (!date) return '';
//     const d = new Date(date);
//     const day = String(d.getDate()).padStart(2, '0');
//     const month = String(d.getMonth() + 1).padStart(2, '0');
//     const year = d.getFullYear();
//     return `${day}/${month}/${year}`;
//   };

//   // Get current date in YYYY-MM-DD format for input field
//   const getCurrentDateForInput = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = String(today.getMonth() + 1).padStart(2, '0');
//     const day = String(today.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   };

//   const [formData, setFormData] = useState({
//     company: '',
//     title: '',
//     description: '',
//     status: '',
//     startDate: getCurrentDateForInput(),
//     dueDate: '',
//     budget: '',
//     progress: 0,
//     clientName: '',
//     clientCompany: '',
//     clientEmail: '',
//     clientMobileNo: '',
//     clientAddress: '',
//     clientCity: '',
//     clientState: '',
//     projectHead: '',
//     departments: [], // Changed to array for multiple departments
//     selectedEmployeeId: '', // for dropdown
//     customFields: [] // Array of {key, value} objects
//   });

//   // Options for state and city dropdowns
//   const indianStates = [
//     'Andhra Pradesh',
//     'Arunachal Pradesh',
//     'Assam',
//     'Bihar',
//     'Chhattisgarh',
//     'Goa',
//     'Gujarat',
//     'Haryana',
//     'Himachal Pradesh',
//     'Jharkhand',
//     'Karnataka',
//     'Kerala',
//     'Madhya Pradesh',
//     'Maharashtra',
//     'Manipur',
//     'Meghalaya',
//     'Mizoram',
//     'Nagaland',
//     'Odisha',
//     'Punjab',
//     'Rajasthan',
//     'Sikkim',
//     'Tamil Nadu',
//     'Telangana',
//     'Tripura',
//     'Uttar Pradesh',
//     'Uttarakhand',
//     'West Bengal'
//   ];

//   const maharashtraCities = [
//     'Mumbai (Capital of Maharashtra)',
//     'Pune',
//     'Nagpur',
//     'Nashik',
//     'Thane',
//     'Aurangabad (now officially Chhatrapati Sambhajinagar)',
//     'Solapur',
//     'Kolhapur',
//     'Amravati',
//     'Jalgaon',
//     'Akola',
//     'Latur',
//     'Sangli',
//     'Satara',
//     'Bhiwandi',
//     'Navi Mumbai',
//     'Kalyan-Dombivli',
//     'Vasai-Virar',
//     'Ahmednagar',
//     'Chandrapur'
//   ];

//   // Map cities by state (expand later as needed)
//   const citiesByState = {
//     Maharashtra: maharashtraCities,
//   };

//   const [showStateList, setShowStateList] = useState(false);
//   const [showCityList, setShowCityList] = useState(false);
//   const stateBoxRef = useRef(null);
//   const cityBoxRef = useRef(null);
//   const [stateHighlight, setStateHighlight] = useState(-1);
//   const [cityHighlight, setCityHighlight] = useState(-1);

//   // Get token from localStorage
//   const token = localStorage.getItem('authToken');

//   let COMPANY_ID = '';
//   if (token) {
//     try {
//       const decodedToken = jwtDecode(token); // Decode JWT
//       // Handle both company and employee login types
//       COMPANY_ID = decodedToken.role === 'company'
//         ? (decodedToken.companyId || decodedToken.id)
//         : decodedToken.companyId;
//     } catch (err) {
//       console.error("Error decoding token:", err);
//     }
//   }
//   // ---------------- Fetch Employees ----------------
//   useEffect(() => {
//     const fetchEmployees = async () => {
//       try {
//         const token = localStorage.getItem('authToken');


//         const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/employees/company/${COMPANY_ID}`, {
//           headers: {
//             'Authorization': `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         });

//         if (res.ok) {
//           const data = await res.json();

//           // Log department-wise employee distribution
//           if (data && data.length > 0) {
//             const departmentGroups = {};
//             data.forEach(emp => {
//               const deptId = emp.department?._id || emp.department || 'No Department';
//               const deptName = emp.department?.name || 'Unknown Department';
//               if (!departmentGroups[deptId]) {
//                 departmentGroups[deptId] = { name: deptName, employees: [] };
//               }
//               departmentGroups[deptId].employees.push(emp);
//             });

//             Object.keys(departmentGroups).forEach(deptId => {
//               const group = departmentGroups[deptId];
//             });
//           }

//           setEmployees(data || []);
//         } else {
//           console.error('AddProject - Failed to fetch employees - Status:', res.status);

//           // Try multiple fallback endpoints for company login
//           let fallbackData = null;

//           // Try general employees endpoint with auth
//           try {
//             const fallbackRes = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/employees', {
//               headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'application/json',
//               },
//             });
//             if (fallbackRes.ok) {
//               fallbackData = await fallbackRes.json();
//             }
//           } catch (error) {
//             console.log("AddProject - Auth fallback failed, trying no-auth");
//           }

//           // Try no-auth fallback for company access
//           if (!fallbackData) {
//             try {
//               const noAuthRes = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/employees');
//               if (noAuthRes.ok) {
//                 fallbackData = await noAuthRes.json();
//               }
//             } catch (error) {
//               console.log("AddProject - No-auth fallback failed");
//             }
//           }

//           setEmployees(fallbackData || []);
//         }
//       } catch (error) {
//         console.error('Error fetching employees:', error);
//         setEmployees([]);
//       }
//     };
//     fetchEmployees();
//   }, []);


//   // ---------------- Fetch Departments ----------------
//   useEffect(() => {
//     const fetchDepartments = async () => {
//       try {
//         const token = localStorage.getItem('authToken');

//         let departmentData = null;

//         // First try: with company ID and auth
//         try {
//           const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${COMPANY_ID}`, {
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json',
//             },
//           });
//           if (res.ok) {
//             departmentData = await res.json();
//           }
//         } catch (error) {
//           console.log("AddProject - Auth department fetch failed, trying alternatives");
//         }

//         // Second try: without auth for company access
//         if (!departmentData) {
//           try {
//             const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${COMPANY_ID}`);
//             if (res.ok) {
//               departmentData = await res.json();
//             }
//           } catch (error) {
//             console.log("AddProject - No-auth department fetch failed");
//           }
//         }

//         // Third try: general departments endpoint
//         if (!departmentData) {
//           try {
//             const res = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/departments', {
//               headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'application/json',
//               },
//             });
//             if (res.ok) {
//               departmentData = await res.json();
//             }
//           } catch (error) {
//             console.log("AddProject - General department fetch failed");
//           }
//         }

//         setDepartments(departmentData || []);
//       } catch (error) {
//         console.error('AddProject - Error fetching departments:', error);
//         setDepartments([]);
//       }
//     };
//     fetchDepartments();
//   }, []);

//   // ---------------- Click Outside Handler ----------------
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowDepartmentDropdown(false);
//       }
//       if (stateBoxRef.current && !stateBoxRef.current.contains(event.target)) {
//         setShowStateList(false);
//         setStateHighlight(-1);
//       }
//       if (cityBoxRef.current && !cityBoxRef.current.contains(event.target)) {
//         setShowCityList(false);
//         setCityHighlight(-1);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   // ---------------- Validation Helpers ----------------
//   const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
//   const isValidPhone = (phone) => /^[6-9]\d{9}$/.test(phone);

//   // ---------------- Computed Values ----------------
//   // Filter departments based on search term
//   const filteredDepartments = departments.filter(dept =>
//     dept.name.toLowerCase().includes(departmentSearchTerm.toLowerCase())
//   );

//   // Group employees by department
//   const employeesByDepartment = employees.reduce((acc, emp) => {
//     const deptId = emp.department?._id || emp.department || 'no-department';
//     const deptName = emp.department?.name || 'No Department';

//     if (!acc[deptId]) {
//       acc[deptId] = {
//         id: deptId,
//         name: deptName,
//         employees: []
//       };
//     }
//     acc[deptId].employees.push(emp);
//     return acc;
//   }, {});



//   // ---------------- Handlers ----------------
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === 'clientState') {
//       setFormData((prev) => ({
//         ...prev,
//         clientState: value,
//         // Reset city if state changed to something that doesn't match current city list
//         clientCity: ''
//       }));
//       return;
//     }
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleDepartmentToggle = (departmentId) => {
//     const id = typeof departmentId === "object" ? departmentId._id : departmentId;

//     setFormData(prev => {
//       const isSelected = prev.departments.includes(id);
//       const updatedDepartments = isSelected
//         ? prev.departments.filter(depId => depId !== id)
//         : [...prev.departments, id];

//       return {
//         ...prev,
//         departments: updatedDepartments,
//         selectedEmployeeId: ''
//       };
//     });

//     setSelectedTeamMembers([]); // Clear team members when departments change
//   };



//   const handleAddTeamMember = () => {
//     const selectedEmployee = employees.find(emp => emp._id === formData.selectedEmployeeId);
//     if (selectedEmployee && !selectedTeamMembers.some(member => member._id === selectedEmployee._id)) {
//       setSelectedTeamMembers(prev => [...prev, selectedEmployee]);
//     }
//     setFormData(prev => ({ ...prev, selectedEmployeeId: '' })); // reset dropdown
//   };

//   const handleRemoveTeamMember = (id) => {
//     setSelectedTeamMembers(prev => prev.filter(member => member._id !== id));
//   };

//   // Custom Fields Handlers
//   const handleAddCustomField = () => {
//     if (newCustomField.key.trim() && newCustomField.value.trim()) {
//       setFormData(prev => ({
//         ...prev,
//         customFields: [...prev.customFields, { ...newCustomField }]
//       }));
//       setNewCustomField({ key: '', value: '' });
//     }
//   };

//   const handleRemoveCustomField = (index) => {
//     setFormData(prev => ({
//       ...prev,
//       customFields: prev.customFields.filter((_, i) => i !== index)
//     }));
//   };

//   const handleCustomFieldChange = (field, value) => {
//     setNewCustomField(prev => ({ ...prev, [field]: value }));
//   };

//   // Add single status to the dropdown list using API
//   const handleAddStatus = async () => {
//     const label = (newStatus || '').trim();
//     if (!label) return;

//     const exists = statusOptions.some(s => s.toLowerCase() === label.toLowerCase());
//     if (exists) {
//       setShowAlert('This status already exists in your local list!');
//       setNewStatus('');
//       return;
//     }

//     try {
//       const token = localStorage.getItem('authToken');
//       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           company: COMPANY_ID,
//           name: label
//         })
//       });

//       if (response.ok) {
//         const newStatus = await response.json();

//         // Refresh the status list from server to ensure we have latest data
//         await fetchCustomStatuses();

//         // Set the new status as selected
//         setFormData(prev => ({ ...prev, status: label }));

//         setNewStatus('');
//         // Keep modal open so user can add more statuses
//         // setShowStatusForm(false);
//         setShowAlert(`Status "${label}" added successfully! You can add more statuses or close the modal.`);
//       } else {
//         const errorData = await response.json().catch(() => ({}));
//         console.error('AddProject - Failed to create status:', errorData);

//         // Handle specific error messages from server
//         if (errorData.message && errorData.message.includes('unique')) {
//           setShowAlert(`Status "${label}" already exists for your company. Please choose a different name.`);
//         } else {
//           setShowAlert(`Failed to create status: ${errorData.message || 'Please try again.'}`);
//         }

//         setNewStatus('');
//       }
//     } catch (error) {
//       console.error('AddProject - Error creating status:', error);
//       setShowAlert('Error creating status. Please check your connection and try again.');
//       setNewStatus('');
//     }
//   };

//   // Open status form
//   const handleOpenStatusForm = () => {
//     setShowStatusForm(true);
//   };

//   // Close status form
//   const handleCloseStatusForm = () => {
//     setShowStatusForm(false);
//     setNewStatus('');
//   };

//   // Remove a status from the list (local only - for project-specific use)
//   const handleRemoveStatus = (statusToRemove) => {
//     const updated = statusOptions.filter(status => status !== statusToRemove);
//     setStatusOptions(updated);
//     // Note: Status options are project-specific and not saved globally

//     // If the removed status was selected, change to the first remaining status or empty
//     if (formData.status === statusToRemove) {
//       setFormData(prev => ({ ...prev, status: updated.length > 0 ? updated[0] : '' }));
//     }
//   };

//   // Delete a status from MongoDB database
//   const handleDeleteStatus = async (statusToDelete) => {
//     try {
//       const token = localStorage.getItem('authToken');

//       // First, find the status ID from the API to delete it
//       const fetchResponse = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (!fetchResponse.ok) {
//         throw new Error('Failed to fetch statuses for deletion');
//       }

//       const statuses = await fetchResponse.json();
//       let statusArray = [];

//       // Handle wrapped response format
//       if (Array.isArray(statuses)) {
//         statusArray = statuses;
//       } else if (statuses && statuses.statuses && Array.isArray(statuses.statuses)) {
//         statusArray = statuses.statuses;
//       }

//       // Find the status object to get its ID
//       const statusToDeleteObj = statusArray.find(status => status.name === statusToDelete);

//       if (!statusToDeleteObj) {
//         setShowAlert(`Status "${statusToDelete}" not found in database.`);
//         return;
//       }

//       // Make DELETE request to remove from MongoDB
//       const deleteResponse = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/${statusToDeleteObj._id}`, {
//         method: 'DELETE',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (deleteResponse.ok) {

//         // Refresh the status list from server
//         await fetchCustomStatuses();

//         // If the deleted status was selected, change to the first remaining status or empty
//         if (formData.status === statusToDelete) {
//           const updatedOptions = statusOptions.filter(status => status !== statusToDelete);
//           setFormData(prev => ({ ...prev, status: updatedOptions.length > 0 ? updatedOptions[0] : '' }));
//         }

//         setShowAlert(`Status "${statusToDelete}" deleted successfully from database!`);
//       } else {
//         const errorData = await deleteResponse.json().catch(() => ({}));
//         console.error('AddProject - Failed to delete status:', errorData);
//         setShowAlert(`Failed to delete status: ${errorData.message || 'Please try again.'}`);
//       }
//     } catch (error) {
//       console.error('AddProject - Error deleting status:', error);
//       setShowAlert('Error deleting status from database. Please check your connection and try again.');
//     }
//   };




//   // Add this useEffect after your other useEffects to handle Google Places Autocomplete

//   useEffect(() => {
//     // Function to initialize Google Places Autocomplete
//     const initAutocomplete = () => {
//       if (!window.google || !window.google.maps || !window.google.maps.places) {
//         console.log('Google Maps not loaded yet');
//         return;
//       }

//       // Initialize autocomplete for client address field
//       const addressInput = document.getElementById('clientAddress');
//       if (addressInput) {
//         const autocomplete = new window.google.maps.places.Autocomplete(addressInput, {
//           types: ['address'],
//           componentRestrictions: { country: 'in' } // Restrict to India, change as needed
//         });

//         // Prevent form submission on Enter key in autocomplete
//         addressInput.addEventListener('keydown', (e) => {
//           if (e.key === 'Enter') {
//             e.preventDefault();
//             e.stopPropagation();
//           }
//         });

//         autocomplete.addListener('place_changed', () => {
//           const place = autocomplete.getPlace();

//           if (!place.geometry) {
//             console.log('No details available for input: ' + place.name);
//             return;
//           }

//           // Extract address components
//           let street = '';
//           let city = '';
//           let state = '';
//           let postalCode = '';
//           let country = '';

//           place.address_components.forEach((component) => {
//             const types = component.types;

//             if (types.includes('street_number') || types.includes('route')) {
//               street += component.long_name + ' ';
//             }
//             if (types.includes('locality') || types.includes('administrative_area_level_2')) {
//               city = component.long_name;
//             }
//             if (types.includes('administrative_area_level_1')) {
//               state = component.long_name;
//             }
//             if (types.includes('postal_code')) {
//               postalCode = component.long_name;
//             }
//             if (types.includes('country')) {
//               country = component.long_name;
//             }
//           });

//           // Update form data programmatically
//           setFormData(prev => ({
//             ...prev,
//             clientAddress: place.formatted_address || street.trim(),
//             clientCity: city,
//             clientState: state
//           }));
//         });
//       }
//     };

//     // Check if Google Maps is already loaded
//     if (window.google && window.google.maps && window.google.maps.places) {
//       initAutocomplete();
//     } else {
//       // Wait for Google Maps to load
//       const checkGoogleMaps = setInterval(() => {
//         if (window.google && window.google.maps && window.google.maps.places) {
//           clearInterval(checkGoogleMaps);
//           initAutocomplete();
//         }
//       }, 100);

//       // Cleanup interval after 10 seconds
//       setTimeout(() => clearInterval(checkGoogleMaps), 10000);
//     }
//   }, []);



//   // Update your handleSubmit to include proper form submission handling
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     e.stopPropagation(); // Add this to prevent event bubbling

//     // Validation
//     if (!formData.title || !formData.startDate || !formData.dueDate || formData.departments.length === 0) {
//       setShowAlert('Please fill in all required fields (Title, Start Date, Due Date, Departments)');
//       return;
//     }
//     if (statusOptions.length === 0 || !formData.status) {
//       setShowAlert('Please add at least one status and select it for the project.');
//       return;
//     }
//     if (formData.clientEmail && !isValidEmail(formData.clientEmail)) {
//       setShowAlert('Please enter a valid email address.');
//       return;
//     }
//     if (formData.clientMobileNo && !isValidPhone(formData.clientMobileNo)) {
//       setShowAlert('Please enter a valid 10-digit mobile number.');
//       return;
//     }

//     setLoading(true);

//     try {
//       const token = localStorage.getItem('authToken');

//       const projectData = {
//         company: formData.company || COMPANY_ID,
//         title: formData.title,
//         description: formData.description,
//         status: formData.status,
//         startDate: formData.startDate,
//         dueDate: formData.dueDate,
//         budget: formData.budget ? parseFloat(formData.budget) : 0,
//         progress: parseInt(formData.progress) || 0,
//         teamMembers: selectedTeamMembers.map((emp) => emp._id),
//         projectHead: formData.projectHead || null,
//         clientName: formData.clientName,
//         clientCompany: formData.clientCompany,
//         clientEmail: formData.clientEmail,
//         clientMobileNo: formData.clientMobileNo,
//         clientAddress: formData.clientAddress,
//         clientCity: formData.clientCity,
//         clientState: formData.clientState,
//         department: formData.departments,
//         customFields: formData.customFields,
//         statusOptions: statusOptions,
//       };

//       const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/projectsmgnt', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`
//         },
//         body: JSON.stringify(projectData)
//       });

//       if (response.ok) {
//         const savedProject = await response.json();

//         if (window.refreshProjects) {
//           await window.refreshProjects();
//         }

//         if (window.refreshProjectTracker) {
//           await window.refreshProjectTracker();
//         }

//         setTimeout(() => {
//           if (onNavigate) {
//             onNavigate('/projects', 'Projects');
//           } else {
//             navigate('/projects');
//           }
//         }, 500);
//       } else {
//         const errorData = await response.json();
//         setShowAlert(`Error creating project: ${errorData.message || 'Unknown error'}`);
//       }
//     } catch (error) {
//       console.error('Error creating project:', error);
//       setShowAlert('Error creating project. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };



//   // ---------------- UI ----------------
//   return (
//     <div style={addProjectStyle}>
//       <div style={pageHeaderStyle}>
//         <button onClick={() => onNavigate ? onNavigate('/projects', 'Projects') : navigate('/projects')} style={btnSecondaryStyle}>
//           <ArrowLeft size={20} />
//           Back to Projects
//         </button>
//         <h1 style={headerTitleStyle}>
//           <Sparkles size={32} style={{ color: '#f093fb' }} />
//           Create New Project
//         </h1>
//       </div>

//       <div style={formContainerStyle}>
//         <form onSubmit={handleSubmit} autoComplete="off">
//           {/* Title */}
//           <div style={formGroupStyle}>
//             <label htmlFor="title" style={labelStyle}>📋 Project Title *</label>
//             <input
//               type="text"
//               id="title"
//               name="title"
//               value={formData.title}
//               onChange={handleChange}
//               placeholder="Enter project title"
//               required
//               style={{
//                 ...inputStyle,
//                 '::placeholder': { color: 'rgba(255, 255, 255, 0.6)' }
//               }}
//             />
//           </div>

//           {/* Departments - Searchable Dropdown with Multiple Selection */}
//           <div style={formGroupStyle}>
//             <label style={labelStyle}>
//               Departments *
//               {formData.departments.length > 0 && (
//                 <span style={{
//                   fontSize: '0.75rem',
//                   color: '#6b7280',
//                   fontWeight: 'normal',
//                   marginLeft: '0.5rem',
//                   padding: '0.25rem 0.5rem',
//                   backgroundColor: '#f3f4f6',
//                   borderRadius: '0.375rem',
//                   border: '1px solid #d1d5db'
//                 }}>
//                   {formData.departments.length} selected
//                 </span>
//               )}
//             </label>

//             {/* Search Input with Dropdown Toggle */}
//             <div style={{ position: 'relative' }} ref={dropdownRef}>
//               <div style={{ display: 'flex', alignItems: 'center' }}>
//                 <input
//                   type="text"
//                   placeholder="Search departments..."
//                   value={departmentSearchTerm}
//                   onChange={(e) => setDepartmentSearchTerm(e.target.value)}
//                   onFocus={() => setShowDepartmentDropdown(true)}
//                   style={{
//                     ...inputStyle,
//                     paddingRight: '2.5rem'
//                   }}
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowDepartmentDropdown(!showDepartmentDropdown)}
//                   style={{
//                     position: 'absolute',
//                     right: '0.5rem',
//                     background: 'none',
//                     border: 'none',
//                     cursor: 'pointer',
//                     padding: '0.25rem',
//                     color: '#6b7280',
//                     fontSize: '1rem'
//                   }}
//                 >
//                   {showDepartmentDropdown ? '–' : '–'}
//                 </button>
//               </div>

//               {/* Dropdown List */}
//               {showDepartmentDropdown && (
//                 <div style={{
//                   position: 'absolute',
//                   top: '100%',
//                   left: 0,
//                   right: 0,
//                   backgroundColor: 'white',
//                   border: '1px solid #d1d5db',
//                   borderRadius: '0.375rem',
//                   boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//                   zIndex: 1000,
//                   maxHeight: '200px',
//                   overflowY: 'auto'
//                 }}>
//                   {filteredDepartments.length > 0 ? (
//                     filteredDepartments.map((dept) => (
//                       <div
//                         key={dept._id}
//                         onClick={() => handleDepartmentToggle(dept._id)}
//                         style={{
//                           padding: '0.75rem',
//                           cursor: 'pointer',
//                           backgroundColor: formData.departments.includes(dept._id) ? '#f0f9ff' : 'white',
//                           borderBottom: '1px solid #f3f4f6',
//                           display: 'flex',
//                           alignItems: 'center',
//                           gap: '0.5rem',
//                           transition: 'background-color 0.2s ease'
//                         }}
//                         onMouseEnter={(e) => {
//                           if (!formData.departments.includes(dept._id)) {
//                             e.target.style.backgroundColor = '#f9fafb';
//                           }
//                         }}
//                         onMouseLeave={(e) => {
//                           if (!formData.departments.includes(dept._id)) {
//                             e.target.style.backgroundColor = 'white';
//                           }
//                         }}
//                       >
//                         <input
//                           type="checkbox"
//                           checked={formData.departments.includes(dept._id)}
//                           onChange={() => { }}
//                           style={{ cursor: 'pointer' }}
//                         />
//                         <span style={{
//                           fontSize: '0.875rem',
//                           color: formData.departments.includes(dept._id) ? '#0c4a6e' : '#374151',
//                           fontWeight: formData.departments.includes(dept._id) ? '500' : 'normal'
//                         }}>
//                           {dept.name}
//                         </span>
//                       </div>
//                     ))
//                   ) : (
//                     <div style={{
//                       padding: '0.75rem',
//                       textAlign: 'center',
//                       color: '#6b7280',
//                       fontSize: '0.875rem'
//                     }}>
//                       {departmentSearchTerm ? 'No departments found' : 'No departments available'}
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>

//             {/* Selected Departments Display */}
//             {formData.departments.length > 0 && (
//               <div style={{ marginTop: '0.75rem' }}>
//                 <div style={{ fontSize: '0.75rem', color: '#6b7280', marginBottom: '0.5rem' }}>
//                   Selected Departments:
//                 </div>
//                 <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
//                   {formData.departments.map(deptId => {
//                     const id = typeof deptId === "object" ? deptId._id : deptId;
//                     const dept = departments.find(d => String(d._id) === String(id));
//                     return dept ? (
//                       <span key={deptId} style={{
//                         fontSize: '0.75rem',
//                         padding: '0.25rem 0.5rem',
//                         backgroundColor: '#e0f2fe',
//                         color: '#0c4a6e',
//                         borderRadius: '0.375rem',
//                         border: '1px solid #bae6fd',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '0.25rem'
//                       }}>
//                         {dept.name}
//                         <button
//                           type="button"
//                           onClick={() => handleDepartmentToggle(deptId)}
//                           style={{
//                             background: 'none',
//                             border: 'none',
//                             color: '#0c4a6e',
//                             cursor: 'pointer',
//                             padding: '0',
//                             fontSize: '0.75rem',
//                             fontWeight: 'bold'
//                           }}
//                         >
//                           ×
//                         </button>
//                       </span>
//                     ) : null;
//                   })}
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Team Members - Dropdown */}
//           <div style={formGroupStyle}>
//             {(() => {

//               // Filter employees based on selected departments
//               const filteredEmployees = employees.filter(emp => {
//                 if (!emp.isActive) return false;
//                 if (formData.departments.length === 0) return false;

//                 // Handle different department formats
//                 let empDeptIds = [];

//                 if (emp.department) {
//                   if (Array.isArray(emp.department)) {
//                     // Employee department is an array of department IDs
//                     empDeptIds = emp.department.map(dept => {
//                       if (typeof dept === 'object') {
//                         return dept._id || dept.id;
//                       }
//                       return dept;
//                     }).filter(Boolean);
//                   } else if (typeof emp.department === 'object') {
//                     // Employee department is a single object
//                     const deptId = emp.department._id || emp.department.id;
//                     if (deptId) empDeptIds = [deptId];
//                   } else if (typeof emp.department === 'string') {
//                     // Employee department is a single string ID
//                     empDeptIds = [emp.department];
//                   }
//                 }

//                 // Check if any of employee's departments match any selected department
//                 const matches = empDeptIds.length > 0 && empDeptIds.some(empDeptId =>
//                   formData.departments.some(selectedDeptId =>
//                     String(empDeptId) === String(selectedDeptId)
//                   )
//                 );

//                 return matches;
//               });



//               // Group employees by department for better display
//               const departmentWiseEmployees = {};
//               filteredEmployees.forEach(emp => {
//                 // Handle employees with multiple departments
//                 if (Array.isArray(emp.department)) {
//                   emp.department.forEach(dept => {
//                     let deptId, deptName;

//                     if (typeof dept === 'object') {
//                       deptId = dept._id || dept.id;
//                       deptName = dept.name || dept.departmentName;
//                     } else {
//                       deptId = dept;
//                       // Find department name from departments array
//                       const foundDept = departments.find(d => String(d._id) === String(dept));
//                       deptName = foundDept?.name || foundDept?.departmentName || `Department ${dept}`;
//                     }

//                     // Only group if this department is selected
//                     if (formData.departments.includes(deptId)) {
//                       if (!departmentWiseEmployees[deptId]) {
//                         departmentWiseEmployees[deptId] = {
//                           name: deptName,
//                           employees: []
//                         };
//                       }

//                       // Avoid duplicate employees in same department
//                       if (!departmentWiseEmployees[deptId].employees.find(e => e._id === emp._id)) {
//                         departmentWiseEmployees[deptId].employees.push(emp);
//                       }
//                     }
//                   });
//                 } else {
//                   // Handle single department
//                   let deptId, deptName;

//                   if (typeof emp.department === 'object') {
//                     deptId = emp.department._id || emp.department.id;
//                     deptName = emp.department.name || emp.department.departmentName;
//                   } else {
//                     deptId = emp.department;
//                     const foundDept = departments.find(d => String(d._id) === String(emp.department));
//                     deptName = foundDept?.name || foundDept?.departmentName || `Department ${emp.department}`;
//                   }

//                   if (!departmentWiseEmployees[deptId]) {
//                     departmentWiseEmployees[deptId] = {
//                       name: deptName,
//                       employees: []
//                     };
//                   }
//                   departmentWiseEmployees[deptId].employees.push(emp);
//                 }
//               });

//               return (
//                 <>
//                   <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                     <Users size={20} /> Assign Team Members
//                     {formData.departments.length > 0 && (
//                       <span style={{
//                         fontSize: '0.75rem',
//                         color: '#6b7280',
//                         fontWeight: 'normal',
//                         marginLeft: '0.5rem',
//                         padding: '0.25rem 0.5rem',
//                         backgroundColor: '#f3f4f6',
//                         borderRadius: '0.375rem',
//                         border: '1px solid #d1d5db'
//                       }}>
//                         {filteredEmployees.length} employee{filteredEmployees.length !== 1 ? 's' : ''} available
//                       </span>
//                     )}
//                   </label>
//                   <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
//                     <select
//                       value={formData.selectedEmployeeId}
//                       onChange={handleChange}
//                       name="selectedEmployeeId"
//                       style={selectStyle}
//                       disabled={formData.departments.length === 0}
//                     >
//                       <option value="">
//                         {formData.departments.length === 0
//                           ? "Select departments first"
//                           : filteredEmployees.length === 0
//                             ? "No employees in selected departments"
//                             : "Select a team member"
//                         }
//                       </option>
//                       {Object.keys(departmentWiseEmployees).map(deptId => {
//                         const deptGroup = departmentWiseEmployees[deptId];
//                         return [
//                           <option key={`dept-${deptId}`} disabled style={{ fontWeight: 'bold', backgroundColor: '#f3f4f6' }}>
//                             {deptGroup.name} ({deptGroup.employees.length} employees) //                           </option>,
//                           ...deptGroup.employees.map(emp => (
//                             <option key={emp._id} value={emp._id} style={{ paddingLeft: '1rem' }}>
//                               &nbsp;&nbsp;&nbsp;&nbsp;{emp.teamMemberName || emp.name || 'Unnamed'} - {emp.role || 'No Position'}
//                             </option>
//                           ))
//                         ];
//                       }).flat()}
//                     </select>
//                     <button
//                       type="button"
//                       onClick={handleAddTeamMember}
//                       style={{
//                         ...btnPrimaryStyle,
//                         padding: '0.5rem 1rem',
//                         opacity: formData.departments.length === 0 || filteredEmployees.length === 0 ? 0.5 : 1,
//                         cursor: formData.departments.length === 0 || filteredEmployees.length === 0 ? 'not-allowed' : 'pointer'
//                       }}
//                       disabled={formData.departments.length === 0 || filteredEmployees.length === 0}
//                     >
//                       Add
//                     </button>
//                   </div>

//                   {/* Selected Members */}
//                   {selectedTeamMembers.length > 0 && (
//                     <div style={selectedEmployeesContainer}>
//                       {selectedTeamMembers.map((member) => (
//                         <div key={member._id} style={selectedEmployeeChip}>
//                           <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
//                             <span style={{ fontWeight: '500' }}>
//                               {member.teamMemberName || member.name || 'Unnamed'}
//                             </span>
//                             <span style={{ fontSize: '0.75rem', color: '#64748b', fontStyle: 'italic' }}>
//                               {member.role || 'No Position'}
//                             </span>
//                           </div>
//                           <X
//                             size={14}
//                             style={{ cursor: 'pointer', marginLeft: '0.5rem' }}
//                             onClick={() => handleRemoveTeamMember(member._id)}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </>
//               );
//             })()}
//           </div>

//           {/* Project Head */}
//           {/* <div style={formGroupStyle}>
//             <label htmlFor="projectHead" style={labelStyle}>💼 Project Head</label>
//             <select
//               id="projectHead"
//               name="projectHead"
//               value={formData.projectHead}
//               onChange={handleChange}
//               style={selectStyle}
//             >
//               <option value="">Select Project Head</option>
//               {employees.map(emp => (
//                 <option key={emp._id} value={emp._id}>
//                   {emp.teamMemberName || emp.name || 'Unnamed'} - {emp.role || 'No Position'}
//                 </option>
//               ))}
//             </select>
//           </div> */}
//           <div style={formGroupStyle}>
//             <label htmlFor="projectHead" style={labelStyle}>💼 Project Head</label>
//             <select
//               id="projectHead"
//               name="projectHead"
//               value={formData.projectHead}
//               onChange={handleChange}
//               style={selectStyle}
//             >
//               <option value="">Select Project Head</option>
//               {employees
//                 .filter(emp => emp.isActive)  // Filter only active employees
//                 .map(emp => (
//                   <option key={emp._id} value={emp._id}>
//                     {emp.teamMemberName || emp.name || 'Unnamed'} - {emp.role || 'No Position'}
//                   </option>
//                 ))}
//             </select>
//           </div>

//           {/* Description */}
//           <div style={formGroupStyle}>
//             <label htmlFor="description" style={labelStyle}> Description</label>
//             <textarea
//               id="description"
//               name="description"
//               value={formData.description}
//               onChange={handleChange}
//               placeholder="Project description..."
//               style={textareaStyle}
//             />
//           </div>

//           {/* Status */}
//           <div style={formGroupStyle}>
//             <label htmlFor="status" style={labelStyle}>📊 Status</label>
//             <select
//               id="status"
//               name="status"
//               value={formData.status}
//               onChange={handleChange}
//               style={selectStyle}
//             >
//               <option value="">-- Select Status (Add statuses first) --</option>
//               {statusOptions.map(opt => (
//                 <option key={opt} value={opt}>{opt}</option>
//               ))}
//             </select>
//             {/* Add Status Button */}
//             <div style={{ marginTop: '0.75rem' }}>
//               <button
//                 type="button"
//                 onClick={handleOpenStatusForm}
//                 style={{
//                   ...btnPrimaryStyle,
//                   whiteSpace: 'nowrap'
//                 }}
//               >
//                 ž• Add & Manage Statuses
//               </button>
//             </div>

//             {/* Status Form Modal */}
//             {showStatusForm && (
//               <div style={{
//                 position: 'fixed',
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 bottom: 0,
//                 backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 zIndex: 1000
//               }}>
//                 <div style={{
//                   backgroundColor: 'white',
//                   borderRadius: '1rem',
//                   padding: '2rem',
//                   width: '400px',
//                   maxWidth: '90vw',
//                   boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
//                 }}>
//                   <h3 style={{
//                     margin: '0 0 1.5rem 0',
//                     fontSize: '1.5rem',
//                     fontWeight: 600,
//                     color: '#1f2937',
//                     textAlign: 'center'
//                   }}>
//                     📊 Add & Manage Statuses
//                   </h3>

//                   <div style={{ marginBottom: '1.5rem' }}>
//                     <div style={{ marginBottom: '1rem' }}>
//                       <label style={{
//                         display: 'block',
//                         marginBottom: '0.5rem',
//                         fontWeight: 500,
//                         color: '#374151',
//                         fontSize: '0.875rem'
//                       }}>
//                         Status Name *
//                       </label>
//                       <input
//                         type="text"
//                         value={newStatus}
//                         onChange={(e) => setNewStatus(e.target.value)}
//                         placeholder="Enter status name (e.g., On Hold, Under Review, Testing)"
//                         style={{
//                           ...inputStyle,
//                           marginBottom: '0.5rem'
//                         }}
//                         autoFocus
//                       />
//                     </div>

//                     {/* Show current status count */}
//                     <div style={{
//                       padding: '0.75rem',
//                       backgroundColor: '#f0f9ff',
//                       borderRadius: '0.5rem',
//                       border: '1px solid #bae6fd',
//                       marginBottom: '0.5rem'
//                     }}>
//                       <div style={{
//                         fontSize: '0.75rem',
//                         color: '#0c4a6e',
//                         fontWeight: 500,
//                         marginBottom: '0.25rem'
//                       }}>
//                         📊 Current Status Count: {statusOptions.length}
//                       </div>
//                       <div style={{
//                         fontSize: '0.875rem',
//                         color: '#1f2937'
//                       }}>
//                         {newStatus.trim() ? (
//                           <span>
//                             Adding: <span style={{
//                               padding: '0.25rem 0.5rem',
//                               backgroundColor: '#dbeafe',
//                               borderRadius: '0.25rem',
//                               fontWeight: '500'
//                             }}>
//                               {newStatus.trim()}
//                             </span>
//                             <span style={{ color: '#6b7280', marginLeft: '0.5rem' }}>†Total will be {statusOptions.length + 1}</span>
//                           </span>
//                         ) : (
//                           <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>Enter status name to add</span>
//                         )}
//                       </div>
//                     </div>

//                     <div style={{
//                       fontSize: '0.75rem',
//                       color: '#6b7280',
//                       fontStyle: 'italic'
//                     }}>
//                       Examples: On Hold, Under Review, Testing, Cancelled, Paused, Approved
//                     </div>

//                     <div style={{
//                       fontSize: '0.75rem',
//                       color: '#059669',
//                       fontWeight: '500',
//                       marginTop: '0.5rem',
//                       padding: '0.5rem',
//                       backgroundColor: '#ecfdf5',
//                       borderRadius: '0.375rem',
//                       border: '1px solid #a7f3d0'
//                     }}>
//                       ¡ Tip: Add multiple statuses one by one. The modal will stay open until you click "Cancel".
//                     </div>
//                   </div>

//                   {/* Existing Statuses Management */}
//                   {statusOptions.length > 0 && (
//                     <div style={{ marginBottom: '1.5rem' }}>
//                       <div style={{
//                         fontSize: '0.875rem',
//                         fontWeight: 600,
//                         color: '#374151',
//                         marginBottom: '0.75rem',
//                         borderBottom: '1px solid #e5e7eb',
//                         paddingBottom: '0.5rem'
//                       }}>
//                         —ï Existing Statuses ({statusOptions.length})
//                       </div>

//                       <div style={{
//                         display: 'flex',
//                         flexDirection: 'column',
//                         gap: '0.5rem',
//                         maxHeight: '200px',
//                         overflowY: 'auto',
//                         padding: '0.5rem',
//                         backgroundColor: '#f8fafc',
//                         borderRadius: '0.5rem',
//                         border: '1px solid #e5e7eb'
//                       }}>
//                         {statusOptions.map((status, index) => (
//                           <div key={index} style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'space-between',
//                             padding: '0.5rem 0.75rem',
//                             backgroundColor: 'white',
//                             border: '1px solid #e5e7eb',
//                             borderRadius: '0.375rem'
//                           }}>
//                             <span style={{
//                               fontSize: '0.875rem',
//                               fontWeight: '500',
//                               color: '#1f2937'
//                             }}>
//                               {status}
//                             </span>

//                             <button
//                               type="button"
//                               onClick={() => {
//                                 if (window.confirm(`Delete "${status}" from database? This action cannot be undone.`)) {
//                                   handleDeleteStatus(status);
//                                 }
//                               }}
//                               style={{
//                                 backgroundColor: '#ef4444',
//                                 color: 'white',
//                                 border: 'none',
//                                 borderRadius: '0.25rem',
//                                 padding: '0.25rem 0.5rem',
//                                 cursor: 'pointer',
//                                 fontSize: '0.75rem',
//                                 fontWeight: '500'
//                               }}
//                               onMouseEnter={(e) => {
//                                 e.target.style.backgroundColor = '#dc2626';
//                               }}
//                               onMouseLeave={(e) => {
//                                 e.target.style.backgroundColor = '#ef4444';
//                               }}
//                             >
//                               —ï Delete
//                             </button>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}

//                   <div style={{
//                     display: 'flex',
//                     gap: '1rem',
//                     justifyContent: 'flex-end'
//                   }}>
//                     <button
//                       type="button"
//                       onClick={handleCloseStatusForm}
//                       style={{
//                         ...btnSecondaryStyle,
//                         padding: '0.75rem 1.5rem'
//                       }}
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       type="button"
//                       onClick={handleAddStatus}
//                       style={{
//                         ...btnPrimaryStyle,
//                         padding: '0.75rem 1.5rem',
//                         opacity: (newStatus || '').trim() ? 1 : 0.5,
//                         cursor: (newStatus || '').trim() ? 'pointer' : 'not-allowed'
//                       }}
//                       disabled={!(newStatus || '').trim()}
//                     >
//                       ž• Add This Status
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}

//           </div>

//           {/* Start Date & Due Date */}
//           <div style={formRowStyle}>
//             <div style={formGroupStyle}>
//               <label htmlFor="startDate" style={labelStyle}>… Start Date *</label>
//               <input
//                 type="date"
//                 id="startDate"
//                 name="startDate"
//                 value={formData.startDate}
//                 onChange={handleChange}
//                 required
//                 style={inputStyle}
//               />
//             </div>

//             <div style={formGroupStyle}>
//               <label htmlFor="dueDate" style={labelStyle}> Due Date *</label>
//               <input
//                 type="date"
//                 id="dueDate"
//                 name="dueDate"
//                 value={formData.dueDate}
//                 onChange={handleChange}
//                 required
//                 style={inputStyle}
//               />
//             </div>
//           </div>

//           {/* Budget */}
//           <div style={formGroupStyle}>
//             <label htmlFor="budget" style={labelStyle}>💰 Budget</label>
//             <input
//               type="number"
//               id="budget"
//               name="budget"
//               value={formData.budget}
//               onChange={handleChange}
//               placeholder="Enter budget"
//               min="0"
//               step="0.01"
//               style={inputStyle}
//             />
//           </div>

//           {/* Progress - Hidden for new projects */}
//           {/* <div style={formGroupStyle}>
//             <label htmlFor="progress" style={labelStyle}>📈 Progress (%)</label>
//             <input
//               type="number"
//               id="progress"
//               name="progress"
//               value={formData.progress}
//               onChange={handleChange}
//               min="0"
//               max="100"
//               style={inputStyle}
//             />
//           </div> */}




//           <div style={formGroupStyle}>
//             <h3 style={{ ...labelStyle, fontSize: '1.3rem', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//               Client Information
//             </h3>
//             <div style={formRowStyle}>
//               <div style={formGroupStyle}>
//                 <label htmlFor="clientName" style={labelStyle}>ï Client Name</label>
//                 <input
//                   type="text"
//                   id="clientName"
//                   name="clientName"
//                   value={formData.clientName}
//                   onChange={handleChange}
//                   placeholder="Enter client name"
//                   style={inputStyle}
//                   autoComplete="new-password" // Trick to disable autofill
//                 />
//               </div>

//               <div style={formGroupStyle}>
//                 <label htmlFor="clientCompany" style={labelStyle}>Client Company</label>
//                 <input
//                   type="text"
//                   id="clientCompany"
//                   name="clientCompany"
//                   value={formData.clientCompany}
//                   onChange={handleChange}
//                   placeholder="Enter client company"
//                   style={inputStyle}
//                   autoComplete="new-password" // Trick to disable autofill
//                 />
//               </div>
//             </div>

//             <div style={formRowStyle}>
//               <div style={formGroupStyle}>
//                 <label htmlFor="clientEmail" style={labelStyle}> Client Email</label>
//                 <input
//                   type="email"
//                   id="clientEmail"
//                   name="clientEmail"
//                   value={formData.clientEmail}
//                   onChange={handleChange}
//                   placeholder="client@company.com"
//                   style={inputStyle}
//                   autoComplete="new-password" // Trick to disable autofill
//                 />
//               </div>

//               <div style={formGroupStyle}>
//                 <label htmlFor="clientMobileNo" style={labelStyle}>📱 Client Mobile Number</label>
//                 <input
//                   type="tel"
//                   id="clientMobileNo"
//                   name="clientMobileNo"
//                   value={formData.clientMobileNo}
//                   onChange={handleChange}
//                   placeholder="10-digit mobile number"
//                   style={inputStyle}
//                   autoComplete="new-password" // Trick to disable autofill
//                 />
//               </div>
//             </div>

//             {/* Client Address Information */}
//             <div style={formGroupStyle}>
//               <label htmlFor="clientAddress" style={labelStyle}>  Client Address</label>
//               <input
//                 type="text"
//                 id="clientAddress"
//                 name="clientAddress"
//                 value={formData.clientAddress}
//                 onChange={handleChange}
//                 placeholder="Enter client address"
//                 style={inputStyle}
//                 autoComplete="new-password" // Trick to disable autofill
//               />
//             </div>

//             <div style={formRowStyle}>
//               <div style={{ ...formGroupStyle, position: 'relative' }} ref={stateBoxRef}>
//                 <label htmlFor="clientState" style={labelStyle}>—ï Client State</label>
//                 <input
//                   type="text"
//                   id="clientState"
//                   name="clientState"
//                   value={formData.clientState}
//                   onChange={(e) => { setStateHighlight(-1); setShowStateList(true); handleChange(e); }}
//                   onFocus={() => setShowStateList(true)}
//                   onKeyDown={(e) => {
//                     const list = indianStates.filter(s => s.toLowerCase().includes((formData.clientState || '').toLowerCase()));
//                     if (e.key === 'ArrowDown') { e.preventDefault(); setStateHighlight(h => Math.min(h + 1, list.length - 1)); }
//                     if (e.key === 'ArrowUp') { e.preventDefault(); setStateHighlight(h => Math.max(h - 1, 0)); }
//                     if (e.key === 'Enter' && stateHighlight >= 0) {
//                       const v = list[stateHighlight];
//                       setFormData(prev => ({ ...prev, clientState: v, clientCity: '' }));
//                       setShowStateList(false);
//                     }
//                     if (e.key === 'Escape') { setShowStateList(false); }
//                   }}
//                   placeholder="Start typing state..."
//                   style={inputStyle}
//                   autoComplete="new-password"
//                 />
//                 {showStateList && (
//                   <div style={{ position: 'absolute', marginTop: '0.25rem', background: 'white', border: '1px solid #d1d5db', borderRadius: '0.375rem', boxShadow: '0 8px 16px rgba(0,0,0,0.08)', maxHeight: '220px', overflowY: 'auto', zIndex: 2000, width: 'calc(100% - 2px)' }}>
//                     {indianStates
//                       .filter(s => s.toLowerCase().includes((formData.clientState || '').toLowerCase()))
//                       .map((s, idx) => (
//                         <div
//                           key={s}
//                           onMouseDown={() => { setFormData(prev => ({ ...prev, clientState: s, clientCity: '' })); setShowStateList(false); }}
//                           onMouseEnter={() => setStateHighlight(idx)}
//                           style={{ padding: '0.5rem 0.75rem', cursor: 'pointer', background: idx === stateHighlight ? '#f3f4f6' : 'white' }}
//                         >
//                           {s}
//                         </div>
//                       ))}
//                   </div>
//                 )}
//               </div>

//               <div style={{ ...formGroupStyle, position: 'relative' }} ref={cityBoxRef}>
//                 <label htmlFor="clientCity" style={labelStyle}>™ï Client City</label>
//                 <input
//                   type="text"
//                   id="clientCity"
//                   name="clientCity"
//                   value={formData.clientCity}
//                   onChange={(e) => { setCityHighlight(-1); setShowCityList(true); handleChange(e); }}
//                   onFocus={() => setShowCityList(true)}
//                   onKeyDown={(e) => {
//                     const list = (citiesByState[formData.clientState] || []).filter(c => c.toLowerCase().includes((formData.clientCity || '').toLowerCase()));
//                     if (e.key === 'ArrowDown') { e.preventDefault(); setCityHighlight(h => Math.min(h + 1, list.length - 1)); }
//                     if (e.key === 'ArrowUp') { e.preventDefault(); setCityHighlight(h => Math.max(h - 1, 0)); }
//                     if (e.key === 'Enter' && cityHighlight >= 0) {
//                       const v = list[cityHighlight];
//                       setFormData(prev => ({ ...prev, clientCity: v }));
//                       setShowCityList(false);
//                     }
//                     if (e.key === 'Escape') { setShowCityList(false); }
//                   }}
//                   placeholder={formData.clientState ? 'Start typing city...' : 'Select state first'}
//                   style={inputStyle}
//                   autoComplete="new-password"
//                   disabled={!formData.clientState}
//                 />
//                 {showCityList && (
//                   <div style={{ position: 'absolute', marginTop: '0.25rem', background: 'white', border: '1px solid #d1d5db', borderRadius: '0.375rem', boxShadow: '0 8px 16px rgba(0,0,0,0.08)', maxHeight: '220px', overflowY: 'auto', zIndex: 2000, width: 'calc(100% - 2px)' }}>
//                     {(citiesByState[formData.clientState] || [])
//                       .filter(c => c.toLowerCase().includes((formData.clientCity || '').toLowerCase()))
//                       .map((c, idx) => (
//                         <div
//                           key={c}
//                           onMouseDown={() => { setFormData(prev => ({ ...prev, clientCity: c })); setShowCityList(false); }}
//                           onMouseEnter={() => setCityHighlight(idx)}
//                           style={{ padding: '0.5rem 0.75rem', cursor: 'pointer', background: idx === cityHighlight ? '#f3f4f6' : 'white' }}
//                         >
//                           {c}
//                         </div>
//                       ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Custom Fields */}
//           <div style={formGroupStyle}>
//             <h3 style={{ ...labelStyle, fontSize: '1.3rem', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//               š™ï Other Information
//             </h3>

//             {/* Add New Custom Field */}
//             <div style={{ marginBottom: '1rem' }}>
//               <div style={formRowStyle}>
//                 <div style={formGroupStyle}>
//                   <label style={labelStyle}>ï Name</label>
//                   <input
//                     type="text"
//                     value={newCustomField.key}
//                     onChange={(e) => handleCustomFieldChange('key', e.target.value)}
//                     placeholder="Enter field name"
//                     style={inputStyle}
//                   />
//                 </div>
//                 <div style={formGroupStyle}>
//                   <label style={labelStyle}>¡ Particular</label>
//                   <input
//                     type="text"
//                     value={newCustomField.value}
//                     onChange={(e) => handleCustomFieldChange('value', e.target.value)}
//                     placeholder="Enter field value"
//                     style={inputStyle}
//                   />
//                 </div>
//               </div>
//               <button
//                 type="button"
//                 onClick={handleAddCustomField}
//                 style={{
//                   ...btnPrimaryStyle,
//                   marginTop: '0.5rem',
//                   opacity: (!newCustomField.key.trim() || !newCustomField.value.trim()) ? 0.5 : 1,
//                   cursor: (!newCustomField.key.trim() || !newCustomField.value.trim()) ? 'not-allowed' : 'pointer'
//                 }}
//                 disabled={!newCustomField.key.trim() || !newCustomField.value.trim()}
//               >
//                 ž• Add Other Field
//               </button>
//             </div>

//             {/* Display Custom Fields */}
//             {formData.customFields.length > 0 && (
//               <div style={{ marginTop: '1rem' }}>
//                 <div style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.5rem' }}>
//                   Other Fields ({formData.customFields.length}):
//                 </div>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//                   {formData.customFields.map((field, index) => (
//                     <div key={index} style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'space-between',
//                       padding: '0.75rem',
//                       backgroundColor: '#f8fafc',
//                       border: '1px solid #e5e7eb',
//                       borderRadius: '0.375rem',
//                       gap: '1rem'
//                     }}>
//                       <div style={{ display: 'flex', gap: '1rem', flex: 1 }}>
//                         <div style={{ flex: 1 }}>
//                           <span style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500' }}>Field:</span>
//                           <div style={{ fontSize: '0.875rem', color: '#1f2937', fontWeight: '500' }}>{field.key}</div>
//                         </div>
//                         <div style={{ flex: 1 }}>
//                           <span style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500' }}>Value:</span>
//                           <div style={{ fontSize: '0.875rem', color: '#1f2937' }}>{field.value}</div>
//                         </div>
//                       </div>
//                       <button
//                         type="button"
//                         onClick={() => handleRemoveCustomField(index)}
//                         style={{
//                           background: '#ef4444',
//                           color: 'white',
//                           border: 'none',
//                           borderRadius: '0.25rem',
//                           padding: '0.25rem 0.5rem',
//                           cursor: 'pointer',
//                           fontSize: '0.75rem',
//                           fontWeight: '500'
//                         }}
//                       >
//                         ✅• Remove
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Form Actions */}
//           <div style={formActionsStyle}>
//             <button type="button" onClick={() => onNavigate ? onNavigate('/projects', 'Projects') : navigate('/projects')} style={btnSecondaryStyle}>
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={loading}
//               style={{
//                 ...btnPrimaryStyle,
//                 opacity: loading ? 0.6 : 1,
//                 cursor: loading ? 'not-allowed' : 'pointer'
//               }}
//             >
//               <FolderPlus size={20} />
//               {loading ? 'Creating...' : 'Create Project'}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddProject;
















import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FolderPlus, ArrowLeft, Users, X, Sparkles } from 'lucide-react';
import { jwtDecode } from "jwt-decode";
import AlertBox from '../../Components/AlertBox';
const AddProject = ({ projects, setProjects, onNavigate }) => {
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [showAlert, setShowAlert] = useState(null);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  // ---------------- Simple Styles ----------------
  const addProjectStyle = {
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
    padding: '2rem',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
  };

  const pageHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '2rem',
    padding: '1.5rem',
    backgroundColor: 'white',
    borderRadius: '0.5rem',
    border: '1px solid #e5e7eb',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
  };

  const headerTitleStyle = {
    fontSize: '1.875rem',
    fontWeight: 700,
    color: '#1f2937',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  };

  const btnStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '0.5rem 1rem',
    border: '1px solid #d1d5db',
    borderRadius: '0.375rem',
    fontWeight: 500,
    cursor: 'pointer',
    gap: '0.5rem',
    transition: 'all 0.2s ease',
    fontSize: '0.875rem',
    backgroundColor: 'white'
  };

  const btnSecondaryStyle = {
    ...btnStyle,
    backgroundColor: '#6b7280',
    color: 'white',
    borderColor: '#6b7280'
  };

  const btnPrimaryStyle = {
    ...btnStyle,
    backgroundColor: '#3b82f6',
    color: 'white',
    borderColor: '#3b82f6'
  };

  const formContainerStyle = {
    maxWidth: '800px',
    margin: '0 auto',
    backgroundColor: 'white',
    borderRadius: '0.5rem',
    padding: '2rem',
    border: '1px solid #e5e7eb',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
  };
  const formGroupStyle = { marginBottom: '2rem', marginRight: '1.5rem' };
  const labelStyle = {
    display: 'block',
    marginBottom: '0.5rem',
    fontWeight: 500,
    color: '#374151',
    fontSize: '0.875rem'
  };

  const inputStyle = {
    width: '100%',
    padding: '0.75rem',
    backgroundColor: 'white',
    border: '1px solid #d1d5db',
    borderRadius: '0.375rem',
    fontSize: '0.875rem',
    outline: 'none',
    color: '#1f2937',
    transition: 'border-color 0.2s ease'
  };

  const textareaStyle = { ...inputStyle, resize: 'vertical', minHeight: '100px' };
  const selectStyle = { ...inputStyle, cursor: 'pointer' };
  const formRowStyle = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' };
  const formActionsStyle = { display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '2rem' };

  const selectedEmployeesContainer = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
    marginTop: '0.5rem'
  };

  const selectedEmployeeChip = {
    display: 'flex',
    alignItems: 'center',
    background: '#f0f9ff',
    padding: '0.75rem 1rem',
    borderRadius: '0.5rem',
    fontSize: '0.9rem',
    gap: '0.75rem',
    minHeight: 'auto',
    border: '1px solid #bae6fd',
    color: '#0c4a6e',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.2s ease'
  };

  // ---------------- States ----------------
  const [employees, setEmployees] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [departmentSearchTerm, setDepartmentSearchTerm] = useState('');
  const [showDepartmentDropdown, setShowDepartmentDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [newCustomField, setNewCustomField] = useState({ key: '', value: '' });
  // Status management - using API
  const [statusOptions, setStatusOptions] = useState([]);
  const [newStatus, setNewStatus] = useState('');
  const [showStatusForm, setShowStatusForm] = useState(false);

  // Function to fetch custom statuses from API
  const fetchCustomStatuses = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const statuses = await response.json();

        // Handle wrapped response format {statuses: Array}
        let statusArray = [];
        if (Array.isArray(statuses)) {
          statusArray = statuses;
        } else if (statuses && statuses.statuses && Array.isArray(statuses.statuses)) {
          statusArray = statuses.statuses;
        } else {
          console.log('AddProject - Invalid response format:', statuses);
          setStatusOptions([]);
          return;
        }

        if (statusArray.length > 0) {
          // Extract status names from the array
          const statusNames = statusArray.map(status => {
            // Try to get the name field
            if (status && typeof status === 'object' && status.name) {
              return status.name;
            }
            console.log('AddProject - No name field found');
            return null;
          }).filter(name => name); // Remove null values

          setStatusOptions(statusNames);
        } else {
          setStatusOptions([]);
        }
      } else {
        console.error('AddProject - API Error:', response.status);
        setStatusOptions([]);
      }
    } catch (error) {
      console.error('AddProject - Fetch Error:', error);
      setStatusOptions([]);
    }
  };

  // Fetch custom statuses on component mount
  useEffect(() => {
    fetchCustomStatuses();
  }, []);

  // Test function to create a status if none exist
  const createTestStatus = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          company: COMPANY_ID,
          name: 'Planning'
        })
      });

      if (response.ok) {
        fetchCustomStatuses(); // Refresh the list
      } else {
      }
    } catch (error) {
      console.log('AddProject - Error creating test status:', error);
    }
  };


  // Utility function to format date as DD/MM/YYYY
  const formatDateToDDMMYYYY = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Get current date in YYYY-MM-DD format for input field
  const getCurrentDateForInput = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [formData, setFormData] = useState({
    company: '',
    title: '',
    description: '',
    status: '',
    startDate: getCurrentDateForInput(),
    dueDate: '',
    budget: '',
    progress: 0,
    clientName: '',
    clientCompany: '',
    clientEmail: '',
    clientMobileNo: '',
    clientAddress: '',
    clientCity: '',
    clientState: '',
    projectHead: '',
    departments: [], // Changed to array for multiple departments
    selectedEmployeeId: '', // for dropdown
    customFields: [] // Array of {key, value} objects
  });

  // Options for state and city dropdowns
  const indianStates = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal'
  ];

  const maharashtraCities = [
    'Mumbai (Capital of Maharashtra)',
    'Pune',
    'Nagpur',
    'Nashik',
    'Thane',
    'Aurangabad (now officially Chhatrapati Sambhajinagar)',
    'Solapur',
    'Kolhapur',
    'Amravati',
    'Jalgaon',
    'Akola',
    'Latur',
    'Sangli',
    'Satara',
    'Bhiwandi',
    'Navi Mumbai',
    'Kalyan-Dombivli',
    'Vasai-Virar',
    'Ahmednagar',
    'Chandrapur'
  ];

  // Map cities by state (expand later as needed)
  const citiesByState = {
    Maharashtra: maharashtraCities,
  };

  const [showStateList, setShowStateList] = useState(false);
  const [showCityList, setShowCityList] = useState(false);
  const stateBoxRef = useRef(null);
  const cityBoxRef = useRef(null);
  const [stateHighlight, setStateHighlight] = useState(-1);
  const [cityHighlight, setCityHighlight] = useState(-1);

  // Get token from localStorage
  const token = localStorage.getItem('authToken');

  let COMPANY_ID = '';
  if (token) {
    try {
      const decodedToken = jwtDecode(token); // Decode JWT
      // Handle both company and employee login types
      COMPANY_ID = decodedToken.role === 'company'
        ? (decodedToken.companyId || decodedToken.id)
        : decodedToken.companyId;
    } catch (err) {
      console.error("Error decoding token:", err);
    }
  }
  // ---------------- Fetch Employees ----------------
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const token = localStorage.getItem('authToken');


        const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/employees/company/${COMPANY_ID}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (res.ok) {
          const data = await res.json();

          // Log department-wise employee distribution
          if (data && data.length > 0) {
            const departmentGroups = {};
            data.forEach(emp => {
              const deptId = emp.department?._id || emp.department || 'No Department';
              const deptName = emp.department?.name || 'Unknown Department';
              if (!departmentGroups[deptId]) {
                departmentGroups[deptId] = { name: deptName, employees: [] };
              }
              departmentGroups[deptId].employees.push(emp);
            });

            Object.keys(departmentGroups).forEach(deptId => {
              const group = departmentGroups[deptId];
            });
          }

          setEmployees(data ? data.filter(emp => emp.isActive !== false) : []);
        } else {
          console.error('AddProject - Failed to fetch employees - Status:', res.status);

          // Try multiple fallback endpoints for company login
          let fallbackData = null;

          // Try general employees endpoint with auth
          try {
            const fallbackRes = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/employees', {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
            });
            if (fallbackRes.ok) {
              fallbackData = await fallbackRes.json();
            }
          } catch (error) {
            console.log("AddProject - Auth fallback failed, trying no-auth");
          }

          // Try no-auth fallback for company access
          if (!fallbackData) {
            try {
              const noAuthRes = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/employees');
              if (noAuthRes.ok) {
                fallbackData = await noAuthRes.json();
              }
            } catch (error) {
              console.log("AddProject - No-auth fallback failed");
            }
          }

          setEmployees(fallbackData ? fallbackData.filter(emp => emp.isActive !== false) : []);
        }
      } catch (error) {
        console.error('Error fetching employees:', error);
        setEmployees([]);
      }
    };
    fetchEmployees();
  }, []);


  // ---------------- Fetch Departments ----------------
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const token = localStorage.getItem('authToken');

        let departmentData = null;

        // First try: with company ID and auth
        try {
          const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${COMPANY_ID}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          });
          if (res.ok) {
            departmentData = await res.json();
          }
        } catch (error) {
          console.log("AddProject - Auth department fetch failed, trying alternatives");
        }

        // Second try: without auth for company access
        if (!departmentData) {
          try {
            const res = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/departments/company/${COMPANY_ID}`);
            if (res.ok) {
              departmentData = await res.json();
            }
          } catch (error) {
            console.log("AddProject - No-auth department fetch failed");
          }
        }

        // Third try: general departments endpoint
        if (!departmentData) {
          try {
            const res = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/departments', {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
            });
            if (res.ok) {
              departmentData = await res.json();
            }
          } catch (error) {
            console.log("AddProject - General department fetch failed");
          }
        }

        setDepartments(departmentData || []);
      } catch (error) {
        console.error('AddProject - Error fetching departments:', error);
        setDepartments([]);
      }
    };
    fetchDepartments();
  }, []);

  // ---------------- Click Outside Handler ----------------
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDepartmentDropdown(false);
      }
      if (stateBoxRef.current && !stateBoxRef.current.contains(event.target)) {
        setShowStateList(false);
        setStateHighlight(-1);
      }
      if (cityBoxRef.current && !cityBoxRef.current.contains(event.target)) {
        setShowCityList(false);
        setCityHighlight(-1);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // ---------------- Validation Helpers ----------------
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isValidPhone = (phone) => {
    // Remove any spaces, dashes, or special characters
    const cleanPhone = phone.replace(/[\s\-\(\)]/g, '');
    // Check if it's exactly 10 digits (no starting digit restriction)
    return /^\d{10}$/.test(cleanPhone);
  };

  // ---------------- Computed Values ----------------
  // Filter departments based on search term
  const filteredDepartments = departments.filter(dept =>
    dept.name.toLowerCase().includes(departmentSearchTerm.toLowerCase())
  );

  // Group employees by department
  const employeesByDepartment = employees.reduce((acc, emp) => {
    const deptId = emp.department?._id || emp.department || 'no-department';
    const deptName = emp.department?.name || 'No Department';

    if (!acc[deptId]) {
      acc[deptId] = {
        id: deptId,
        name: deptName,
        employees: []
      };
    }
    acc[deptId].employees.push(emp);
    return acc;
  }, {});



  // ---------------- Handlers ----------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'clientState') {
      setFormData((prev) => ({
        ...prev,
        clientState: value,
        // Reset city if state changed to something that doesn't match current city list
        clientCity: ''
      }));
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDepartmentToggle = (departmentId) => {
    const id = typeof departmentId === "object" ? departmentId._id : departmentId;

    setFormData(prev => {
      const isSelected = prev.departments.includes(id);
      const updatedDepartments = isSelected
        ? prev.departments.filter(depId => depId !== id)
        : [...prev.departments, id];

      return {
        ...prev,
        departments: updatedDepartments,
        selectedEmployeeId: ''
      };
    });

    setSelectedTeamMembers([]); // Clear team members when departments change
  };



  const handleAddTeamMember = () => {
    const selectedEmployee = employees.find(emp => emp._id === formData.selectedEmployeeId);
    if (selectedEmployee && !selectedTeamMembers.some(member => member._id === selectedEmployee._id)) {
      setSelectedTeamMembers(prev => [...prev, selectedEmployee]);
    }
    setFormData(prev => ({ ...prev, selectedEmployeeId: '' })); // reset dropdown
  };

  const handleRemoveTeamMember = (id) => {
    setSelectedTeamMembers(prev => prev.filter(member => member._id !== id));
  };

  // Custom Fields Handlers
  const handleAddCustomField = () => {
    if (newCustomField.key.trim() && newCustomField.value.trim()) {
      setFormData(prev => ({
        ...prev,
        customFields: [...prev.customFields, { ...newCustomField }]
      }));
      setNewCustomField({ key: '', value: '' });
    }
  };

  const handleRemoveCustomField = (index) => {
    setFormData(prev => ({
      ...prev,
      customFields: prev.customFields.filter((_, i) => i !== index)
    }));
  };

  const handleCustomFieldChange = (field, value) => {
    setNewCustomField(prev => ({ ...prev, [field]: value }));
  };

  // Add single status to the dropdown list using API
  const handleAddStatus = async () => {
    const label = (newStatus || '').trim();
    if (!label) return;

    const exists = statusOptions.some(s => s.toLowerCase() === label.toLowerCase());
    if (exists) {
      setShowAlert('This status already exists in your local list!');
      setNewStatus('');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          company: COMPANY_ID,
          name: label
        })
      });

      if (response.ok) {
        const newStatus = await response.json();

        // Refresh the status list from server to ensure we have latest data
        await fetchCustomStatuses();

        // Set the new status as selected
        setFormData(prev => ({ ...prev, status: label }));

        setNewStatus('');
        // Keep modal open so user can add more statuses
        // setShowStatusForm(false);
        setShowAlert(`Status "${label}" added successfully! You can add more statuses or close the modal.`);
      } else {
        const errorData = await response.json().catch(() => ({}));
        console.error('AddProject - Failed to create status:', errorData);

        // Handle specific error messages from server
        if (errorData.message && errorData.message.includes('unique')) {
          setShowAlert(`Status "${label}" already exists for your company. Please choose a different name.`);
        } else {
          setShowAlert(`Failed to create status: ${errorData.message || 'Please try again.'}`);
        }

        setNewStatus('');
      }
    } catch (error) {
      console.error('AddProject - Error creating status:', error);
      setShowAlert('Error creating status. Please check your connection and try again.');
      setNewStatus('');
    }
  };

  // Open status form
  const handleOpenStatusForm = () => {
    setShowStatusForm(true);
  };

  // Close status form
  const handleCloseStatusForm = () => {
    setShowStatusForm(false);
    setNewStatus('');
  };

  // Remove a status from the list (local only - for project-specific use)
  const handleRemoveStatus = (statusToRemove) => {
    const updated = statusOptions.filter(status => status !== statusToRemove);
    setStatusOptions(updated);
    // Note: Status options are project-specific and not saved globally

    // If the removed status was selected, change to the first remaining status or empty
    if (formData.status === statusToRemove) {
      setFormData(prev => ({ ...prev, status: updated.length > 0 ? updated[0] : '' }));
    }
  };

  // Delete a status from MongoDB database
  const handleDeleteStatus = async (statusToDelete) => {
    try {
      const token = localStorage.getItem('authToken');

      // First, find the status ID from the API to delete it
      const fetchResponse = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!fetchResponse.ok) {
        throw new Error('Failed to fetch statuses for deletion');
      }

      const statuses = await fetchResponse.json();
      let statusArray = [];

      // Handle wrapped response format
      if (Array.isArray(statuses)) {
        statusArray = statuses;
      } else if (statuses && statuses.statuses && Array.isArray(statuses.statuses)) {
        statusArray = statuses.statuses;
      }

      // Find the status object to get its ID
      const statusToDeleteObj = statusArray.find(status => status.name === statusToDelete);

      if (!statusToDeleteObj) {
        setShowAlert(`Status "${statusToDelete}" not found in database.`);
        return;
      }

      // Make DELETE request to remove from MongoDB
      const deleteResponse = await fetch(`https://greenyellow-nightingale-241896.hostingersite.com/api/prjCustomStatus/${statusToDeleteObj._id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (deleteResponse.ok) {

        // Refresh the status list from server
        await fetchCustomStatuses();

        // If the deleted status was selected, change to the first remaining status or empty
        if (formData.status === statusToDelete) {
          const updatedOptions = statusOptions.filter(status => status !== statusToDelete);
          setFormData(prev => ({ ...prev, status: updatedOptions.length > 0 ? updatedOptions[0] : '' }));
        }

        setShowAlert(`Status "${statusToDelete}" deleted successfully from database!`);
      } else {
        const errorData = await deleteResponse.json().catch(() => ({}));
        console.error('AddProject - Failed to delete status:', errorData);
        setShowAlert(`Failed to delete status: ${errorData.message || 'Please try again.'}`);
      }
    } catch (error) {
      console.error('AddProject - Error deleting status:', error);
      setShowAlert('Error deleting status from database. Please check your connection and try again.');
    }
  };




  // Add this useEffect after your other useEffects to handle Google Places Autocomplete

  useEffect(() => {
    // Function to initialize Google Places Autocomplete
    const initAutocomplete = () => {
      if (!window.google || !window.google.maps || !window.google.maps.places) {
        console.log('Google Maps not loaded yet');
        return;
      }

      // Initialize autocomplete for client address field
      const addressInput = document.getElementById('clientAddress');
      if (addressInput) {
        const autocomplete = new window.google.maps.places.Autocomplete(addressInput, {
          types: ['address'],
          componentRestrictions: { country: 'in' } // Restrict to India, change as needed
        });

        // Prevent form submission on Enter key in autocomplete
        addressInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
          }
        });

        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();

          if (!place.geometry) {
            console.log('No details available for input: ' + place.name);
            return;
          }

          // Extract address components
          let street = '';
          let city = '';
          let state = '';
          let postalCode = '';
          let country = '';

          place.address_components.forEach((component) => {
            const types = component.types;

            if (types.includes('street_number') || types.includes('route')) {
              street += component.long_name + ' ';
            }
            if (types.includes('locality') || types.includes('administrative_area_level_2')) {
              city = component.long_name;
            }
            if (types.includes('administrative_area_level_1')) {
              state = component.long_name;
            }
            if (types.includes('postal_code')) {
              postalCode = component.long_name;
            }
            if (types.includes('country')) {
              country = component.long_name;
            }
          });

          // Update form data programmatically
          setFormData(prev => ({
            ...prev,
            clientAddress: place.formatted_address || street.trim(),
            clientCity: city,
            clientState: state
          }));
        });
      }
    };

    // Check if Google Maps is already loaded
    if (window.google && window.google.maps && window.google.maps.places) {
      initAutocomplete();
    } else {
      // Wait for Google Maps to load
      const checkGoogleMaps = setInterval(() => {
        if (window.google && window.google.maps && window.google.maps.places) {
          clearInterval(checkGoogleMaps);
          initAutocomplete();
        }
      }, 100);

      // Cleanup interval after 10 seconds
      setTimeout(() => clearInterval(checkGoogleMaps), 10000);
    }
  }, []);



  // Update your handleSubmit to include proper form submission handling
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation(); // Add this to prevent event bubbling
    console.log('Form submitted - handleSubmit called');

    // Validation
    if (!formData.title || !formData.startDate || !formData.dueDate || formData.departments.length === 0) {
      console.log('Validation failed: Missing required fields', {
        title: formData.title,
        startDate: formData.startDate,
        dueDate: formData.dueDate,
        departments: formData.departments
      });
      setShowAlert('Please fill in all required fields (Title, Start Date, Due Date, Departments)');
      return;
    }
    if (statusOptions.length === 0 || !formData.status) {
      console.log('Validation failed: Status not set', { statusOptions, status: formData.status });
      setShowAlert('Please add at least one status and select it for the project.');
      return;
    }
    if (formData.clientEmail && !isValidEmail(formData.clientEmail)) {
      console.log('Validation failed: Invalid email', formData.clientEmail);
      setShowAlert('Please enter a valid email address.');
      return;
    }
    if (formData.clientMobileNo && !isValidPhone(formData.clientMobileNo)) {
      console.log('Validation failed: Invalid mobile number', formData.clientMobileNo);
      setShowAlert('Please enter a valid 10-digit mobile number.');
      return;
    }

    console.log('All validations passed, creating project...');
    setLoading(true);

    try {
      const token = localStorage.getItem('authToken');

      const projectData = {
        company: formData.company || COMPANY_ID,
        title: formData.title,
        description: formData.description,
        status: formData.status,
        startDate: formData.startDate,
        dueDate: formData.dueDate,
        budget: formData.budget ? parseFloat(formData.budget) : 0,
        progress: parseInt(formData.progress) || 0,
        teamMembers: selectedTeamMembers.map((emp) => emp._id),
        projectHead: formData.projectHead || null,
        clientName: formData.clientName,
        clientCompany: formData.clientCompany,
        clientEmail: formData.clientEmail,
        clientMobileNo: formData.clientMobileNo,
        clientAddress: formData.clientAddress,
        clientCity: formData.clientCity,
        clientState: formData.clientState,
        department: formData.departments,
        customFields: formData.customFields,
        statusOptions: statusOptions,
      };

      console.log('Sending project data to API:', projectData);

      const response = await fetch('https://greenyellow-nightingale-241896.hostingersite.com/api/projectsmgnt', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(projectData)
      });

      if (response.ok) {
        const savedProject = await response.json();
        console.log('Project created successfully:', savedProject);

        // Show success popup message
        setShowAlert('✅ Project created successfully!');

        if (window.refreshProjects) {
          await window.refreshProjects();
        }

        if (window.refreshProjectTracker) {
          await window.refreshProjectTracker();
        }

        // Navigate after showing the alert
        setTimeout(() => {
          if (onNavigate) {
            onNavigate('/projects', 'Projects');
          } else {
            navigate('/projects');
          }
        }, 1500);
      } else {
        const errorData = await response.json();
        console.error('API error:', errorData);
        setShowAlert(`Error creating project: ${errorData.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error creating project:', error);
      setShowAlert('Error creating project. Please try again.');
    } finally {
      setLoading(false);
    }
  };



  // ---------------- UI ----------------
  return (
    <div style={addProjectStyle}>
      <div style={pageHeaderStyle}>
        <button onClick={() => onNavigate ? onNavigate('/projects', 'Projects') : navigate('/projects')} style={btnSecondaryStyle}>
          <ArrowLeft size={20} />
          Back to Projects
        </button>
        <h1 style={headerTitleStyle}>
          <Sparkles size={32} style={{ color: '#f093fb' }} />
          Create New Project
        </h1>
      </div>

      <div style={formContainerStyle}>
        <form onSubmit={handleSubmit} autoComplete="off">
          {/* Title */}
          <div style={formGroupStyle}>
            <label htmlFor="title" style={labelStyle}>📋 Project Title *</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter project title"
              required
              style={{
                ...inputStyle,
                '::placeholder': { color: 'rgba(255, 255, 255, 0.6)' }
              }}
            />
          </div>

          {/* Departments - Searchable Dropdown with Multiple Selection */}
          <div style={formGroupStyle}>
            <label style={labelStyle}>
              Departments *
              {formData.departments.length > 0 && (
                <span style={{
                  fontSize: '0.75rem',
                  color: '#6b7280',
                  fontWeight: 'normal',
                  marginLeft: '0.5rem',
                  padding: '0.25rem 0.5rem',
                  backgroundColor: '#f3f4f6',
                  borderRadius: '0.375rem',
                  border: '1px solid #d1d5db'
                }}>
                  {formData.departments.length} selected
                </span>
              )}
            </label>

            {/* Search Input with Dropdown Toggle */}
            <div style={{ position: 'relative' }} ref={dropdownRef}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  type="text"
                  placeholder="Search departments..."
                  value={departmentSearchTerm}
                  onChange={(e) => setDepartmentSearchTerm(e.target.value)}
                  onFocus={() => setShowDepartmentDropdown(true)}
                  style={{
                    ...inputStyle,
                    paddingRight: '2.5rem'
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowDepartmentDropdown(!showDepartmentDropdown)}
                  style={{
                    position: 'absolute',
                    right: '0.5rem',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '0.25rem',
                    color: '#6b7280',
                    fontSize: '1rem'
                  }}
                >
                  {showDepartmentDropdown ? '–' : '–'}
                </button>
              </div>

              {/* Dropdown List */}
              {showDepartmentDropdown && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  backgroundColor: 'white',
                  border: '1px solid #d1d5db',
                  borderRadius: '0.375rem',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                  zIndex: 1000,
                  maxHeight: '200px',
                  overflowY: 'auto'
                }}>
                  {filteredDepartments.length > 0 ? (
                    filteredDepartments.map((dept) => (
                      <div
                        key={dept._id}
                        onClick={() => handleDepartmentToggle(dept._id)}
                        style={{
                          padding: '0.75rem',
                          cursor: 'pointer',
                          backgroundColor: formData.departments.includes(dept._id) ? '#f0f9ff' : 'white',
                          borderBottom: '1px solid #f3f4f6',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem',
                          transition: 'background-color 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          if (!formData.departments.includes(dept._id)) {
                            e.target.style.backgroundColor = '#f9fafb';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!formData.departments.includes(dept._id)) {
                            e.target.style.backgroundColor = 'white';
                          }
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={formData.departments.includes(dept._id)}
                          onChange={() => { }}
                          style={{ cursor: 'pointer' }}
                        />
                        <span style={{
                          fontSize: '0.875rem',
                          color: formData.departments.includes(dept._id) ? '#0c4a6e' : '#374151',
                          fontWeight: formData.departments.includes(dept._id) ? '500' : 'normal'
                        }}>
                          {dept.name}
                        </span>
                      </div>
                    ))
                  ) : (
                    <div style={{
                      padding: '0.75rem',
                      textAlign: 'center',
                      color: '#6b7280',
                      fontSize: '0.875rem'
                    }}>
                      {departmentSearchTerm ? 'No departments found' : 'No departments available'}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Selected Departments Display */}
            {formData.departments.length > 0 && (
              <div style={{ marginTop: '0.75rem' }}>
                <div style={{ fontSize: '0.75rem', color: '#6b7280', marginBottom: '0.5rem' }}>
                  Selected Departments:
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                  {formData.departments.map(deptId => {
                    const id = typeof deptId === "object" ? deptId._id : deptId;
                    const dept = departments.find(d => String(d._id) === String(id));
                    return dept ? (
                      <span key={deptId} style={{
                        fontSize: '0.75rem',
                        padding: '0.25rem 0.5rem',
                        backgroundColor: '#e0f2fe',
                        color: '#0c4a6e',
                        borderRadius: '0.375rem',
                        border: '1px solid #bae6fd',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.25rem'
                      }}>
                        {dept.name}
                        <button
                          type="button"
                          onClick={() => handleDepartmentToggle(deptId)}
                          style={{
                            background: 'none',
                            border: 'none',
                            color: '#0c4a6e',
                            cursor: 'pointer',
                            padding: '0',
                            fontSize: '0.75rem',
                            fontWeight: 'bold'
                          }}
                        >
                          ×
                        </button>
                      </span>
                    ) : null;
                  })}
                </div>
              </div>
            )}
          </div>

          {/* Team Members - Dropdown */}
          <div style={formGroupStyle}>
            {(() => {

              // Filter employees based on selected departments
              const filteredEmployees = employees.filter(emp => {
                if (!emp.isActive) return false;
                if (formData.departments.length === 0) return false;

                // Handle different department formats
                let empDeptIds = [];

                if (emp.department) {
                  if (Array.isArray(emp.department)) {
                    // Employee department is an array of department IDs
                    empDeptIds = emp.department.map(dept => {
                      if (typeof dept === 'object') {
                        return dept._id || dept.id;
                      }
                      return dept;
                    }).filter(Boolean);
                  } else if (typeof emp.department === 'object') {
                    // Employee department is a single object
                    const deptId = emp.department._id || emp.department.id;
                    if (deptId) empDeptIds = [deptId];
                  } else if (typeof emp.department === 'string') {
                    // Employee department is a single string ID
                    empDeptIds = [emp.department];
                  }
                }

                // Check if any of employee's departments match any selected department
                const matches = empDeptIds.length > 0 && empDeptIds.some(empDeptId =>
                  formData.departments.some(selectedDeptId =>
                    String(empDeptId) === String(selectedDeptId)
                  )
                );

                return matches;
              });



              // Group employees by department for better display
              const departmentWiseEmployees = {};
              filteredEmployees.forEach(emp => {
                // Handle employees with multiple departments
                if (Array.isArray(emp.department)) {
                  emp.department.forEach(dept => {
                    let deptId, deptName;

                    if (typeof dept === 'object') {
                      deptId = dept._id || dept.id;
                      deptName = dept.name || dept.departmentName;
                    } else {
                      deptId = dept;
                      // Find department name from departments array
                      const foundDept = departments.find(d => String(d._id) === String(dept));
                      deptName = foundDept?.name || foundDept?.departmentName || `Department ${dept}`;
                    }

                    // Only group if this department is selected
                    if (formData.departments.includes(deptId)) {
                      if (!departmentWiseEmployees[deptId]) {
                        departmentWiseEmployees[deptId] = {
                          name: deptName,
                          employees: []
                        };
                      }

                      // Avoid duplicate employees in same department
                      if (!departmentWiseEmployees[deptId].employees.find(e => e._id === emp._id)) {
                        departmentWiseEmployees[deptId].employees.push(emp);
                      }
                    }
                  });
                } else {
                  // Handle single department
                  let deptId, deptName;

                  if (typeof emp.department === 'object') {
                    deptId = emp.department._id || emp.department.id;
                    deptName = emp.department.name || emp.department.departmentName;
                  } else {
                    deptId = emp.department;
                    const foundDept = departments.find(d => String(d._id) === String(emp.department));
                    deptName = foundDept?.name || foundDept?.departmentName || `Department ${emp.department}`;
                  }

                  if (!departmentWiseEmployees[deptId]) {
                    departmentWiseEmployees[deptId] = {
                      name: deptName,
                      employees: []
                    };
                  }
                  departmentWiseEmployees[deptId].employees.push(emp);
                }
              });

              return (
                <>
                  <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <Users size={20} /> Assign Team Members
                    {formData.departments.length > 0 && (
                      <span style={{
                        fontSize: '0.75rem',
                        color: '#6b7280',
                        fontWeight: 'normal',
                        marginLeft: '0.5rem',
                        padding: '0.25rem 0.5rem',
                        backgroundColor: '#f3f4f6',
                        borderRadius: '0.375rem',
                        border: '1px solid #d1d5db'
                      }}>
                        {filteredEmployees.length} employee{filteredEmployees.length !== 1 ? 's' : ''} available
                      </span>
                    )}
                  </label>
                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                    <select
                      value={formData.selectedEmployeeId}
                      onChange={handleChange}
                      name="selectedEmployeeId"
                      style={selectStyle}
                      disabled={formData.departments.length === 0}
                    >
                      <option value="">
                        {formData.departments.length === 0
                          ? "Select departments first"
                          : filteredEmployees.length === 0
                            ? "No employees in selected departments"
                            : "Select a team member"
                        }
                      </option>
                      {Object.keys(departmentWiseEmployees).map(deptId => {
                        const deptGroup = departmentWiseEmployees[deptId];
                        return [
                          <option key={`dept-${deptId}`} disabled style={{ fontWeight: 'bold', backgroundColor: '#f3f4f6' }}>
                            {deptGroup.name} ({deptGroup.employees.length} employees) </option>,
                          ...deptGroup.employees.map(emp => (
                            <option key={emp._id} value={emp._id} style={{ paddingLeft: '1rem' }}>
                              &nbsp;&nbsp;&nbsp;&nbsp;{emp.teamMemberName || emp.name || 'Unnamed'} - {emp.role || 'No Position'}
                            </option>
                          ))
                        ];
                      }).flat()}
                    </select>
                    <button
                      type="button"
                      onClick={handleAddTeamMember}
                      style={{
                        ...btnPrimaryStyle,
                        padding: '0.5rem 1rem',
                        opacity: formData.departments.length === 0 || filteredEmployees.length === 0 ? 0.5 : 1,
                        cursor: formData.departments.length === 0 || filteredEmployees.length === 0 ? 'not-allowed' : 'pointer'
                      }}
                      disabled={formData.departments.length === 0 || filteredEmployees.length === 0}
                    >
                      Add
                    </button>
                  </div>

                  {/* Selected Members */}
                  {selectedTeamMembers.length > 0 && (
                    <div style={selectedEmployeesContainer}>
                      {selectedTeamMembers.map((member) => (
                        <div key={member._id} style={selectedEmployeeChip}>
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <span style={{ fontWeight: '500' }}>
                              {member.teamMemberName || member.name || 'Unnamed'}
                            </span>
                            <span style={{ fontSize: '0.75rem', color: '#64748b', fontStyle: 'italic' }}>
                              {member.role || 'No Position'}
                            </span>
                          </div>
                          <X
                            size={14}
                            style={{ cursor: 'pointer', marginLeft: '0.5rem' }}
                            onClick={() => handleRemoveTeamMember(member._id)}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </>
              );
            })()}
          </div>

          {/* Project Head */}
          {/* <div style={formGroupStyle}>
            <label htmlFor="projectHead" style={labelStyle}>💼 Project Head</label>
            <select
              id="projectHead"
              name="projectHead"
              value={formData.projectHead}
              onChange={handleChange}
              style={selectStyle}
            >
              <option value="">Select Project Head</option>
              {employees.map(emp => (
                <option key={emp._id} value={emp._id}>
                  {emp.teamMemberName || emp.name || 'Unnamed'} - {emp.role || 'No Position'}
                </option>
              ))}
            </select>
          </div> */}
          <div style={formGroupStyle}>
            <label htmlFor="projectHead" style={labelStyle}>💼 Project Head</label>
            <select
              id="projectHead"
              name="projectHead"
              value={formData.projectHead}
              onChange={handleChange}
              style={selectStyle}
            >
              <option value="">Select Project Head</option>
              {employees
                .filter(emp => emp.isActive)  // Filter only active employees
                .map(emp => (
                  <option key={emp._id} value={emp._id}>
                    {emp.teamMemberName || emp.name || 'Unnamed'} - {emp.role || 'No Position'}
                  </option>
                ))}
            </select>
          </div>

          {/* Description */}
          <div style={formGroupStyle}>
            <label htmlFor="description" style={labelStyle}> Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Project description..."
              style={textareaStyle}
            />
          </div>

          {/* Status */}
          <div style={formGroupStyle}>
            <label htmlFor="status" style={labelStyle}>Status</label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              style={selectStyle}
            >
              <option value="">-- Select Status (Add statuses first) --</option>
              {statusOptions.map(opt => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
            {/* Add Status Button */}
            <div style={{ marginTop: '0.75rem' }}>
              <button
                type="button"
                onClick={handleOpenStatusForm}
                style={{
                  ...btnPrimaryStyle,
                  whiteSpace: 'nowrap'
                }}
              >
                Add & Manage Statuses
              </button>
            </div>

            {/* Status Form Modal */}
            {showStatusForm && (
              <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
              }}>
                <div style={{
                  backgroundColor: 'white',
                  borderRadius: '1rem',
                  padding: '2rem',
                  width: '400px',
                  maxWidth: '90vw',
                  boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
                }}>
                  <h3 style={{
                    margin: '0 0 1.5rem 0',
                    fontSize: '1.5rem',
                    fontWeight: 600,
                    color: '#1f2937',
                    textAlign: 'center'
                  }}>
                    Add & Manage Statuses
                  </h3>

                  <div style={{ marginBottom: '1.5rem' }}>
                    <div style={{ marginBottom: '1rem' }}>
                      <label style={{
                        display: 'block',
                        marginBottom: '0.5rem',
                        fontWeight: 500,
                        color: '#374151',
                        fontSize: '0.875rem'
                      }}>
                        Status Name *
                      </label>
                      <input
                        type="text"
                        value={newStatus}
                        onChange={(e) => setNewStatus(e.target.value)}
                        placeholder="Enter status name (e.g., On Hold, Under Review, Testing)"
                        style={{
                          ...inputStyle,
                          marginBottom: '0.5rem'
                        }}
                        autoFocus
                      />
                    </div>

                    {/* Show current status count */}
                    <div style={{
                      padding: '0.75rem',
                      backgroundColor: '#f0f9ff',
                      borderRadius: '0.5rem',
                      border: '1px solid #bae6fd',
                      marginBottom: '0.5rem'
                    }}>
                      <div style={{
                        fontSize: '0.75rem',
                        color: '#0c4a6e',
                        fontWeight: 500,
                        marginBottom: '0.25rem'
                      }}>
                        Current Status Count: {statusOptions.length}
                      </div>
                      <div style={{
                        fontSize: '0.875rem',
                        color: '#1f2937'
                      }}>
                        {newStatus.trim() ? (
                          <span>
                            Adding: <span style={{
                              padding: '0.25rem 0.5rem',
                              backgroundColor: '#dbeafe',
                              borderRadius: '0.25rem',
                              fontWeight: '500'
                            }}>
                              {newStatus.trim()}
                            </span>
                            <span style={{ color: '#6b7280', marginLeft: '0.5rem' }}>†Total will be {statusOptions.length + 1}</span>
                          </span>
                        ) : (
                          <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>Enter status name to add</span>
                        )}
                      </div>
                    </div>

                    <div style={{
                      fontSize: '0.75rem',
                      color: '#6b7280',
                      fontStyle: 'italic'
                    }}>
                      Examples: On Hold, Under Review, Testing, Cancelled, Paused, Approved
                    </div>

                    <div style={{
                      fontSize: '0.75rem',
                      color: '#059669',
                      fontWeight: '500',
                      marginTop: '0.5rem',
                      padding: '0.5rem',
                      backgroundColor: '#ecfdf5',
                      borderRadius: '0.375rem',
                      border: '1px solid #a7f3d0'
                    }}>
                      Tip: Add multiple statuses one by one. The modal will stay open until you click "Cancel".
                    </div>
                  </div>

                  {/* Existing Statuses Management */}
                  {statusOptions.length > 0 && (
                    <div style={{ marginBottom: '1.5rem' }}>
                      <div style={{
                        fontSize: '0.875rem',
                        fontWeight: 600,
                        color: '#374151',
                        marginBottom: '0.75rem',
                        borderBottom: '1px solid #e5e7eb',
                        paddingBottom: '0.5rem'
                      }}>
                        Existing Statuses ({statusOptions.length})
                      </div>

                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.5rem',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        padding: '0.5rem',
                        backgroundColor: '#f8fafc',
                        borderRadius: '0.5rem',
                        border: '1px solid #e5e7eb'
                      }}>
                        {statusOptions.map((status, index) => (
                          <div key={index} style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '0.5rem 0.75rem',
                            backgroundColor: 'white',
                            border: '1px solid #e5e7eb',
                            borderRadius: '0.375rem'
                          }}>
                            <span style={{
                              fontSize: '0.875rem',
                              fontWeight: '500',
                              color: '#1f2937'
                            }}>
                              {status}
                            </span>

                            <button
                              type="button"
                              onClick={() => {
                                if (window.confirm(`Delete "${status}" from database? This action cannot be undone.`)) {
                                  handleDeleteStatus(status);
                                }
                              }}
                              style={{
                                backgroundColor: '#ef4444',
                                color: 'white',
                                border: 'none',
                                borderRadius: '0.25rem',
                                padding: '0.25rem 0.5rem',
                                cursor: 'pointer',
                                fontSize: '0.75rem',
                                fontWeight: '500'
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#dc2626';
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#ef4444';
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <div style={{
                    display: 'flex',
                    gap: '1rem',
                    justifyContent: 'flex-end'
                  }}>
                    <button
                      type="button"
                      onClick={handleCloseStatusForm}
                      style={{
                        ...btnSecondaryStyle,
                        padding: '0.75rem 1.5rem'
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={handleAddStatus}
                      style={{
                        ...btnPrimaryStyle,
                        padding: '0.75rem 1.5rem',
                        opacity: (newStatus || '').trim() ? 1 : 0.5,
                        cursor: (newStatus || '').trim() ? 'pointer' : 'not-allowed'
                      }}
                      disabled={!(newStatus || '').trim()}
                    >
                      Add This Status
                    </button>
                  </div>
                </div>
              </div>
            )}

          </div>

          {/* Start Date & Due Date */}
          <div style={formRowStyle}>
            <div style={formGroupStyle}>
              <label htmlFor="startDate" style={labelStyle}>Start Date *</label>
              <input
                type="date"
                id="startDate"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
                required
                style={inputStyle}
              />
            </div>

            <div style={formGroupStyle}>
              <label htmlFor="dueDate" style={labelStyle}>Due Date *</label>
              <input
                type="date"
                id="dueDate"
                name="dueDate"
                value={formData.dueDate}
                onChange={handleChange}
                required
                style={inputStyle}
              />
            </div>
          </div>

          {/* Budget */}
          <div style={formGroupStyle}>
            <label htmlFor="budget" style={labelStyle}>💰 Budget</label>
            <input
              type="number"
              id="budget"
              name="budget"
              value={formData.budget}
              onChange={handleChange}
              placeholder="Enter budget"
              min="0"
              step="0.01"
              style={{
                ...inputStyle,
                MozAppearance: 'textfield'
              }}
              onWheel={(e) => e.target.blur()}
            />
            <style>{`
              #budget::-webkit-outer-spin-button,
              #budget::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
              }
            `}</style>
          </div>

          {/* Progress - Hidden for new projects */}
          {/* <div style={formGroupStyle}>
            <label htmlFor="progress" style={labelStyle}>📈 Progress (%)</label>
            <input
              type="number"
              id="progress"
              name="progress"
              value={formData.progress}
              onChange={handleChange}
              min="0"
              max="100"
              style={inputStyle}
            />
          </div> */}




          <div style={formGroupStyle}>
            <h3 style={{ ...labelStyle, fontSize: '1.3rem', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              Client Information
            </h3>
            <div style={formRowStyle}>
              <div style={formGroupStyle}>
                <label htmlFor="clientName" style={labelStyle}>Client Name</label>
                <input
                  type="text"
                  id="clientName"
                  name="clientName"
                  value={formData.clientName}
                  onChange={handleChange}
                  placeholder="Enter client name"
                  style={inputStyle}
                  autoComplete="off"
                  data-form-type="other"
                />
              </div>

              <div style={formGroupStyle}>
                <label htmlFor="clientCompany" style={labelStyle}>Client Company</label>
                <input
                  type="text"
                  id="clientCompany"
                  name="clientCompany"
                  value={formData.clientCompany}
                  onChange={handleChange}
                  placeholder="Enter client company"
                  style={inputStyle}
                  autoComplete="off"
                  data-form-type="other"
                />
              </div>
            </div>

            <div style={formRowStyle}>
              <div style={formGroupStyle}>
                <label htmlFor="clientEmail" style={labelStyle}> Client Email</label>
                <input
                  type="email"
                  id="clientEmail"
                  name="clientEmail"
                  value={formData.clientEmail}
                  onChange={handleChange}
                  placeholder="client@company.com"
                  style={inputStyle}
                  autoComplete="off"
                  data-form-type="other"
                />
              </div>

              <div style={formGroupStyle}>
                <label htmlFor="clientMobileNo" style={labelStyle}>📱 Client Mobile Number</label>
                <input
                  type="tel"
                  id="clientMobileNo"
                  name="clientMobileNo"
                  value={formData.clientMobileNo}
                  onChange={(e) => {
                    // Only allow digits and limit to 10 characters
                    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                    setFormData(prev => ({ ...prev, clientMobileNo: value }));
                  }}
                  placeholder="10-digit mobile number"
                  maxLength={10}
                  pattern="[0-9]{10}"
                  style={inputStyle}
                  autoComplete="off"
                  data-form-type="other"
                />
                {formData.clientMobileNo && !isValidPhone(formData.clientMobileNo) && (
                  <div style={{ color: '#ef4444', fontSize: '0.75rem', marginTop: '0.25rem' }}>
                    Mobile number must be exactly 10 digits
                  </div>
                )}
              </div>
            </div>

            {/* Client Address Information */}
            <div style={formGroupStyle}>
              <label htmlFor="clientAddress" style={labelStyle}>Client Address</label>
              <input
                type="text"
                id="clientAddress"
                name="clientAddress"
                value={formData.clientAddress}
                onChange={handleChange}
                placeholder="Enter client address"
                style={inputStyle}
                autoComplete="off"
                data-form-type="other"
              />
            </div>

            <div style={formRowStyle}>
              <div style={{ ...formGroupStyle, position: 'relative' }} ref={stateBoxRef}>
                <label htmlFor="clientState" style={labelStyle}>Client State *</label>
                <input
                  type="text"
                  id="clientState"
                  name="clientState"
                  value={formData.clientState}
                  onChange={(e) => { setStateHighlight(-1); setShowStateList(true); handleChange(e); }}
                  onFocus={() => setShowStateList(true)}
                  onKeyDown={(e) => {
                    const list = indianStates.filter(s => s.toLowerCase().includes((formData.clientState || '').toLowerCase()));
                    if (e.key === 'ArrowDown') { e.preventDefault(); setStateHighlight(h => Math.min(h + 1, list.length - 1)); }
                    if (e.key === 'ArrowUp') { e.preventDefault(); setStateHighlight(h => Math.max(h - 1, 0)); }
                    if (e.key === 'Enter' && stateHighlight >= 0) {
                      const v = list[stateHighlight];
                      setFormData(prev => ({ ...prev, clientState: v, clientCity: '' }));
                      setShowStateList(false);
                    }
                    if (e.key === 'Escape') { setShowStateList(false); }
                  }}
                  placeholder="Start typing state..."
                  style={inputStyle}
                  autoComplete="off"
                  data-form-type="other"
                />
                {showStateList && (
                  <div style={{ position: 'absolute', marginTop: '0.25rem', background: 'white', border: '1px solid #d1d5db', borderRadius: '0.375rem', boxShadow: '0 8px 16px rgba(0,0,0,0.08)', maxHeight: '220px', overflowY: 'auto', zIndex: 2000, width: 'calc(100% - 2px)' }}>
                    {indianStates
                      .filter(s => s.toLowerCase().includes((formData.clientState || '').toLowerCase()))
                      .map((s, idx) => (
                        <div
                          key={s}
                          onMouseDown={() => { setFormData(prev => ({ ...prev, clientState: s, clientCity: '' })); setShowStateList(false); }}
                          onMouseEnter={() => setStateHighlight(idx)}
                          style={{ padding: '0.5rem 0.75rem', cursor: 'pointer', background: idx === stateHighlight ? '#f3f4f6' : 'white' }}
                        >
                          {s}
                        </div>
                      ))}
                  </div>
                )}
              </div>

              <div style={{ ...formGroupStyle, position: 'relative' }} ref={cityBoxRef}>
                <label htmlFor="clientCity" style={labelStyle}>Client City *</label>
                <input
                  type="text"
                  id="clientCity"
                  name="clientCity"
                  value={formData.clientCity}
                  onChange={(e) => { setCityHighlight(-1); setShowCityList(true); handleChange(e); }}
                  onFocus={() => setShowCityList(true)}
                  onKeyDown={(e) => {
                    const list = (citiesByState[formData.clientState] || []).filter(c => c.toLowerCase().includes((formData.clientCity || '').toLowerCase()));
                    if (e.key === 'ArrowDown') { e.preventDefault(); setCityHighlight(h => Math.min(h + 1, list.length - 1)); }
                    if (e.key === 'ArrowUp') { e.preventDefault(); setCityHighlight(h => Math.max(h - 1, 0)); }
                    if (e.key === 'Enter' && cityHighlight >= 0) {
                      const v = list[cityHighlight];
                      setFormData(prev => ({ ...prev, clientCity: v }));
                      setShowCityList(false);
                    }
                    if (e.key === 'Escape') { setShowCityList(false); }
                  }}
                  placeholder={formData.clientState ? 'Start typing city...' : 'Select state first'}
                  style={inputStyle}
                  autoComplete="off"
                  data-form-type="other"
                  disabled={!formData.clientState}
                />
                {showCityList && (
                  <div style={{ position: 'absolute', marginTop: '0.25rem', background: 'white', border: '1px solid #d1d5db', borderRadius: '0.375rem', boxShadow: '0 8px 16px rgba(0,0,0,0.08)', maxHeight: '220px', overflowY: 'auto', zIndex: 2000, width: 'calc(100% - 2px)' }}>
                    {(citiesByState[formData.clientState] || [])
                      .filter(c => c.toLowerCase().includes((formData.clientCity || '').toLowerCase()))
                      .map((c, idx) => (
                        <div
                          key={c}
                          onMouseDown={() => { setFormData(prev => ({ ...prev, clientCity: c })); setShowCityList(false); }}
                          onMouseEnter={() => setCityHighlight(idx)}
                          style={{ padding: '0.5rem 0.75rem', cursor: 'pointer', background: idx === cityHighlight ? '#f3f4f6' : 'white' }}
                        >
                          {c}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Custom Fields */}
          <div style={formGroupStyle}>
            <h3 style={{ ...labelStyle, fontSize: '1.3rem', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              Other Information
            </h3>

            {/* Add New Custom Field */}
            <div style={{ marginBottom: '1rem' }}>
              <div style={formRowStyle}>
                <div style={formGroupStyle}>
                  <label style={labelStyle}>Name</label>
                  <input
                    type="text"
                    value={newCustomField.key}
                    onChange={(e) => handleCustomFieldChange('key', e.target.value)}
                    placeholder="Enter field name"
                    style={inputStyle}
                  />
                </div>
                <div style={formGroupStyle}>
                  <label style={labelStyle}>Particular</label>
                  <input
                    type="text"
                    value={newCustomField.value}
                    onChange={(e) => handleCustomFieldChange('value', e.target.value)}
                    placeholder="Enter field value"
                    style={inputStyle}
                  />
                </div>
              </div>
              <button
                type="button"
                onClick={handleAddCustomField}
                style={{
                  ...btnPrimaryStyle,
                  marginTop: '0.5rem',
                  opacity: (!newCustomField.key.trim() || !newCustomField.value.trim()) ? 0.5 : 1,
                  cursor: (!newCustomField.key.trim() || !newCustomField.value.trim()) ? 'not-allowed' : 'pointer'
                }}
                disabled={!newCustomField.key.trim() || !newCustomField.value.trim()}
              >
                Add Other Field
              </button>
            </div>

            {/* Display Custom Fields */}
            {formData.customFields.length > 0 && (
              <div style={{ marginTop: '1rem' }}>
                <div style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.5rem' }}>
                  Other Fields ({formData.customFields.length}):
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  {formData.customFields.map((field, index) => (
                    <div key={index} style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '0.75rem',
                      backgroundColor: '#f8fafc',
                      border: '1px solid #e5e7eb',
                      borderRadius: '0.375rem',
                      gap: '1rem'
                    }}>
                      <div style={{ display: 'flex', gap: '1rem', flex: 1 }}>
                        <div style={{ flex: 1 }}>
                          <span style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500' }}>Field:</span>
                          <div style={{ fontSize: '0.875rem', color: '#1f2937', fontWeight: '500' }}>{field.key}</div>
                        </div>
                        <div style={{ flex: 1 }}>
                          <span style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500' }}>Value:</span>
                          <div style={{ fontSize: '0.875rem', color: '#1f2937' }}>{field.value}</div>
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={() => handleRemoveCustomField(index)}
                        style={{
                          background: '#ef4444',
                          color: 'white',
                          border: 'none',
                          borderRadius: '0.25rem',
                          padding: '0.25rem 0.5rem',
                          cursor: 'pointer',
                          fontSize: '0.75rem',
                          fontWeight: '500'
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Form Actions */}
          <div style={formActionsStyle}>
            <button type="button" onClick={() => onNavigate ? onNavigate('/projects', 'Projects') : navigate('/projects')} style={btnSecondaryStyle}>
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                ...btnPrimaryStyle,
                opacity: loading ? 0.6 : 1,
                cursor: loading ? 'not-allowed' : 'pointer'
              }}
            >
              <FolderPlus size={20} />
              {loading ? 'Creating...' : 'Create Project'}
            </button>
          </div>
        </form>
      </div>

      {/* Alert Box for popup messages */}
      {showAlert && (
        <AlertBox
          message={showAlert}
          onClose={() => setShowAlert(null)}
        />
      )}
    </div>
  );
};

export default AddProject;


